export const fr = {
  common: {
    appName: "noaretraite",
    tagline: "Le Bilan Retraite Individuel par Aon.",
    loading: "Chargement…",
    error: "Une erreur est survenue",
    retry: "Réessayer",
    back: "Retour",
    next: "Suivant",
    cancel: "Annuler",
    save: "Enregistrer",
    delete: "Supprimer",
    edit: "Modifier",
    confirm: "Confirmer",
    learnMore: "En savoir plus",
    getStarted: "Commencer",
    contactUs: "Nous contacter",
    search: "Rechercher",
    close: "Fermer",
    open: "Ouvrir",
    add: "Ajouter",
    create: "Créer",
    update: "Mettre à jour",
    remove: "Retirer",
    yes: "Oui",
    no: "Non",
    all: "Tous",
    none: "Aucun",
    export: "Exporter",
    export_excel: "Exporter (Excel)",
    export_csv: "Exporter CSV",
    no_name: "(sans nom)",
    import: "Importer",
    download: "Télécharger",
    upload: "Téléverser",
    filter: "Filtrer",
    sort: "Trier",
    reset: "Réinitialiser",
    apply: "Appliquer",
    select: "Sélectionner",
    selected: "sélectionné(s)",
    actions: "Actions",
    details: "Détails",
    status: "Statut",
    date: "Date",
    name: "Nom",
    email: "Email",
    phone: "Téléphone",
    description: "Description",
    notes: "Notes",
    total: "Total",
    of: "sur",
    noResults: "Aucun résultat",
    showMore: "Voir plus",
    showLess: "Voir moins",
    showHelp: "Afficher l'aide",
    required: "Obligatoire",
    optional: "Facultatif",
    enabled: "Activé",
    disabled: "Désactivé",
    active: "Actif",
    inactive: "Inactif",
    pending: "En attente",
    success: "Succès",
    warning: "Attention",
    info: "Information",
    copy: "Copier",
    copied: "Copié !",
    preview: "Aperçu",
    send: "Envoyer",
    ctrl_cmd: "Ctrl/Cmd",
    sent: "Envoyé",
    archive: "Archiver",
    restore: "Restaurer",
    today: "Aujourd'hui",
    yesterday: "Hier",
    tomorrow: "Demain",
    days: "jours",
    hours: "heures",
    minutes: "minutes",
    and: "et",
    or: "ou",
    notAvailable: "non renseigné",
    size_kb: "{{size}} Ko",
    size_mb: "{{size}} Mo",
  },
  ui: {
    pagination: {
      range: "sur {{total}} {{unit}}",
      items: "éléments",
      page_of: "Page {{page}} / {{pages}}",
      prev: "Précédent",
      next: "Suivant",
    },
    list: {
      truncated: "Liste limitée aux 20 000 premières lignes, affinez les filtres.",
    },
    combobox: {
      placeholder: "Sélectionner…",
      search: "Rechercher…",
      empty: "Aucun résultat",
      refine: "Affinez la recherche pour voir plus de résultats…",
    },
    collapsible: {
      collapse: "Réduire la section",
      expand: "Déployer la section",
    },
    imageUploader: {
      too_big: "Le fichier dépasse {{max}} Mo.",
      unsupported: "Type non supporté ({{type}}).",
      unknown_type: "inconnu",
      upload_failed: "Échec de l'upload",
      saved: "Image enregistrée",
      replace: "Remplacer",
      remove: "Supprimer",
      uploading: "Upload en cours…",
      drop_here: "Déposez le fichier ici",
      drop_or_click: "Déposez ou cliquez pour téléverser",
      formats: "PNG, JPG, WEBP ou SVG · max {{max}} Mo",
    },
    editor: {
      aria_label: "Éditeur de texte",
      bold: "Gras",
      italic: "Italique",
      heading: "Titre",
      subheading: "Sous-titre",
      paragraph: "Texte normal",
      bullet_list: "Liste à puces",
      ordered_list: "Liste numérotée",
      quote: "Citation",
      insert_link: "Insérer un lien",
      confirm_link: "Valider le lien",
      placeholder:
        "Rédigez le texte ici, puis mettez-le en forme avec la barre d'outils ci-dessus.",
    },
    emailPreview: {
      title: "Aperçu de l'email",
      description: "Vérifiez le contenu du message avant envoi.",
      to: "À",
      subject: "Sujet",
      loading: "Chargement de l'aperçu…",
      iframe_title: "Aperçu email",
    },
    password: {
      strength: "Robustesse :",
      hint: "{{min}} caractères minimum, avec majuscule, minuscule et chiffre.",
      score_0: "Très faible",
      score_1: "Faible",
      score_2: "Moyen",
      score_3: "Bon",
      score_4: "Excellent",
    },
    assistant: {
      title: "Noa",
      subtitle: "Votre assistant retraite",
      open: "Ouvrir l'assistant",
      placeholder: "Posez votre question…",
      disclaimer:
        "Noa peut se tromper : vérifiez les informations importantes avec votre conseiller.",
      thinking: "Noa réfléchit…",
      empty_title: "Comment puis-je vous aider ?",
      empty_subtitle: "Posez une question sur vos données ou demandez une action.",
      new_conversation: "Nouvelle conversation",
      fullscreen: "Plein écran",
      exit_fullscreen: "Quitter le plein écran",
      history: "Historique",
      no_history: "Aucune conversation pour le moment.",
      untitled: "Conversation",
      error_generic: "Une erreur est survenue. Réessayez.",
      action_title: "Action à confirmer",
      action_running: "Exécution en cours…",
      action_done: "Action exécutée",
      action_failed: "L'action a échoué",
      action_rejected: "Action annulée",
      open_dossier_bri: "Ouvrir le dossier pour générer le BRI",
      tools: {
        run_sql_select: "Consultation des données",
        get_schema: "Lecture de la structure",
        call_rpc: "Fonction métier",
        get_dossier_overview: "Lecture du dossier",
        get_simulation_results: "Lecture des résultats",
        get_career: "Lecture de la carrière",
        search_salaries: "Recherche de salariés",
        export_data: "Préparation de l'export",
        compute: "Calcul",
        run_pension_calculation: "Lancement du calcul retraite",
        create_simulation: "Création de simulation",
        update_dossier_souhaits: "Mise à jour des souhaits",
        update_salarie_contact: "Mise à jour des coordonnées",
        replace_retraite_supplementaire: "Mise à jour de l'épargne retraite",
        generate_bri: "Préparation du BRI",
        set_dossier_status: "Changement de statut",
        assign_dossier: "Affectation du dossier",
        log_relance: "Enregistrement de la relance",
        send_message: "Envoi de message",
        create_formation: "Création de session de formation",
        enroll_formation: "Inscription à la formation",
        set_formation_presence: "Émargement de la formation",
        code_interpreter: "Génération de fichier (Python)",
      },
      sugg: {
        explain_results: "Explique-moi mes résultats de simulation",
        fill_projet: "Je veux renseigner mes souhaits de départ",
        best_departure: "Quelle est ma meilleure date de départ ?",
        rachat_worth: "Le rachat de trimestres est-il intéressant pour moi ?",
        compare_runs: "Compare mes différents calculs",
        missing_docs: "Quels documents me manque-t-il ?",
        explain_ris: "Explique-moi mon relevé de carrière",
        draft_message: "Aide-moi à rédiger un message à mon conseiller",
        where_dossier: "Où en est mon dossier ?",
        explain_notion: "Explique-moi la décote et la surcote",
        export_formation_xlsx: "Sors-moi l'Excel des inscrits aux formations",
        participation_summary: "Résume la participation de mes salariés",
        top_risques: "Quels salariés ont des anomalies de carrière ?",
        salaries_inactifs: "Quels salariés ne se sont jamais connectés ?",
        export_salaries: "Exporte la liste des salariés en Excel",
        relance_targets: "Qui faut-il relancer en priorité ?",
        sessions_remplissage: "Quel est le taux de remplissage des sessions ?",
        resume_salarie: "Résume la situation de ce salarié",
        resume_dossier: "Résume ce dossier",
        generate_bri: "Génère le BRI de ce dossier",
        next_action: "Quelle est la prochaine action sur ce dossier ?",
        dispatch_stats: "Combien de dossiers restent à dispatcher ?",
        oldest_pending: "Quels sont les dossiers en attente les plus anciens ?",
        my_workload: "Résume ma charge de travail",
        ai_costs_month: "Combien a coûté l'IA ce mois-ci ?",
        ai_top_users: "Qui sont les plus gros utilisateurs de l'IA ?",
        global_stats: "Donne-moi les statistiques globales de la plateforme",
      },
    },
  },
  nav: {
    home: "Accueil",
    employees: "Salariés",
    employers: "DRH",
    aonTeam: "Équipe Aon",
    security: "Sécurité",
    login: "Connexion",
    signup: "Créer un compte",
    logout: "Déconnexion",
    dashboard: "Mon espace",
  },
  landing: {
    hero: {
      eyebrow: "Plateforme Aon Wealth",
      title: "Votre Bilan Retraite, en confiance.",
      subtitle:
        "noaretraite est la plateforme digitale conçue par Aon pour produire et restituer des bilans retraite individuels — pour les salariés, les DRH et les équipes Aon.",
      ctaPrimary: "Accéder à mon espace",
      ctaSecondary: "Découvrir la plateforme",
    },
    trust: {
      label: "Conçu et opéré par",
      items: [
        "Aon — leader mondial du conseil en risques et capital humain",
        "Hébergement européen conforme RGPD",
        "Moteur de calcul retraite référent",
      ],
    },
    personas: {
      title: "Trois expériences, une seule plateforme.",
      subtitle:
        "Chaque persona dispose d'un espace dédié, avec ses propres données, ses propres droits et son propre niveau de détail.",
      salarie: {
        tag: "Espace Salarié",
        title: "Mon bilan retraite en quelques clics",
        bullets: [
          "Je centralise mes documents (RIS, Agirc-Arrco, bulletin de salaire)",
          "Je lance mes simulations en toute autonomie",
          "Je dialogue avec mon consultant Aon dédié",
          "Je consulte mon Bilan Retraite et l'historique de mes mises à jour",
        ],
        cta: "Découvrir l'espace salarié",
      },
      drh: {
        tag: "Espace DRH",
        title: "Le pilotage des départs au plus juste",
        bullets: [
          "Suivi en temps réel de l'avancement de l'opération",
          "Vision agrégée par BU, région, catégorie",
          "Distribution des dates de départ possibles",
          "Exports CSV/Excel pour vos GPEC / GPEPP",
        ],
        cta: "Découvrir l'espace DRH",
      },
      aon: {
        tag: "Équipes Aon",
        title: "Production industrielle des BRI",
        bullets: [
          "Gestion clients entreprises, opérations et populations",
          "Affectation des dossiers à l'équipe production",
          "Intégration native du moteur de calcul retraite",
          "Génération des Bilans Retraite cobrandés",
        ],
        cta: "Découvrir le back-office",
      },
    },
    features: {
      title: "Une plateforme pensée pour la production industrielle.",
      items: [
        {
          title: "Moteur de calcul intégré",
          body: "Tous les régimes pris en charge par le moteur de calcul, dont CNIEG, Fonction Publique et régimes spécifiques. Plus de 15 messages d'alerte automatiques.",
        },
        {
          title: "Branding par société",
          body: "Logo, couleurs, typographies, wording, livrables PDF — chaque société client dispose de sa propre identité visuelle, cobrandée Aon × Entreprise.",
        },
        {
          title: "RGPD by design",
          body: "Hébergement européen, chiffrement en base, Row Level Security, journalisation, droit à l'effacement et réversibilité.",
        },
        {
          title: "Multi-langue",
          body: "Français, anglais et espagnol disponibles. Les libellés et les emails sont personnalisables par opération.",
        },
        {
          title: "Messagerie intégrée",
          body: "Échanges directs entre salariés, équipe production, chef de projet et RH — avec pièces jointes et traçabilité.",
        },
        {
          title: "Rendez-vous & relances",
          body: "Restitution sur RDV Teams / téléphone, agenda des consultants, relances automatiques paramétrables.",
        },
      ],
    },
    security: {
      title: "Sécurité et conformité au cœur de la plateforme.",
      subtitle:
        "Conçue pour traiter des données personnelles sensibles, noaretraite respecte les exigences les plus strictes.",
      items: [
        "Authentification forte (MFA) et SSO entreprise possible",
        "Chiffrement AES-256 au repos, TLS 1.2/1.3 en transit",
        "Hébergement UE — SOC 2, ISO 27001 / 27018, RGPD",
        "Row Level Security Postgres sur chaque table",
        "Audit trail complet et droit à l'effacement",
        "Aucun stockage de carte bancaire (paiement délégué Stripe)",
      ],
    },
    cta: {
      title: "Prêt à industrialiser vos bilans retraite ?",
      subtitle: "Parlons de votre opération. Notre équipe revient vers vous sous 24h ouvrées.",
      ctaPrimary: "Demander une démo",
      ctaSecondary: "Accéder à mon compte",
    },
  },
  auth: {
    login: {
      title: "Connexion à votre espace",
      subtitle: "Saisissez vos identifiants pour accéder à votre Bilan Retraite.",
      email: "Adresse email",
      password: "Mot de passe",
      submit: "Se connecter",
      forgot: "Mot de passe oublié ?",
      noAccount: "Pas encore de compte ?",
      signup: "Créer un compte",
      orContinueWith: "ou continuer avec",
      remember: "Se souvenir de moi",
      noAccountContact: "Pas de compte ? Contactez votre administrateur Aon.",
      timeoutTitle: "Vous avez été déconnecté",
      timeoutDesc:
        "Pour votre sécurité, votre session a été fermée après une période d'inactivité. Reconnectez-vous pour continuer.",
      expiredTitle: "Lien expiré ou déjà utilisé",
      expiredDesc: "Saisissez votre email ci-dessous pour recevoir un nouveau lien de connexion.",
      close: "Fermer",
      modePassword: "Mot de passe",
      modeOtp: "Lien par email",
      otpInfoTitle: "Connexion par lien email.",
      otpInfoBody:
        "Saisissez votre email professionnel ou personnel. Nous vous enverrons un lien de connexion sécurisé. Aucun mot de passe requis.",
      otpSentTitle: "Email envoyé",
      otpSentBody1: "Un lien de connexion a été envoyé à",
      otpSentBody2: ". Pensez à vérifier vos spams. Le lien est valable 1 heure.",
      otpSubmit: "Recevoir un lien de connexion",
      otpSubmitSent: "Lien envoyé",
    },
    mfa: {
      enrollTitle: "Sécurisez votre compte",
      enrollSubtitle:
        "La double authentification ajoute une seconde vérification à chaque connexion. Elle est gérée par une application gratuite sur votre téléphone.",
      preparing: "Préparation de l'inscription…",
      enrollAppsHint:
        "Installez une application d'authentification gratuite, par exemple Microsoft Authenticator ou Google Authenticator.",
      step1: "Scannez ce code avec votre application",
      step2: "Ou saisissez cette clé manuellement",
      step3: "Saisissez le code affiché par l'application",
      qrAlt: "QR code à scanner avec votre application d'authentification",
      manualKey: "Clé de configuration",
      codeLabel: "Code à 6 chiffres",
      autoVerifyHint: "Le code est vérifié automatiquement dès que les six chiffres sont saisis.",
      verify: "Vérifier",
      errorInvalidCode:
        "Le code ne correspond pas à cette configuration. Utilisez l'entrée associée à ce QR code et le dernier code affiché. Si le problème persiste, vérifiez l'heure automatique du téléphone.",
      errorExpiredCode:
        "La demande de vérification a expiré. Réessayez avec le code actuellement affiché dans votre application.",
      errorGeneric:
        "Le service d'authentification n'a pas pu terminer la demande. Réessayez dans quelques instants.",
      errorFactorMissing:
        "Cette configuration d'authentification a expiré ou a été supprimée. Reprenez l'activation avec un nouveau QR code.",
      errorRejected:
        "La vérification a été refusée par la politique de sécurité. Reconnectez-vous ou contactez votre administrateur.",
      errorNetworkChanged:
        "Votre connexion réseau a changé pendant la vérification. Gardez la même connexion et réessayez.",
      errorEnrollmentConflict:
        "Une activation est déjà en cours. Rechargez la page pour la reprendre.",
      errorSessionExpired:
        "Votre session a expiré. Reconnectez-vous avant de poursuivre la vérification.",
      errorRateLimit: "Trop de tentatives rapprochées. Patientez une minute avant de réessayer.",
      errorNetwork:
        "Le service d'authentification est injoignable. Vérifiez votre connexion puis réessayez.",
      errorRecoveryCodes:
        "La double authentification est activée, mais les codes de secours n'ont pas pu être récupérés. Réessayez pour les obtenir.",
      preparingRecovery: "Double authentification activée. Préparation des codes de secours…",
      retryRecovery: "Récupérer mes codes de secours",
      resumeWithoutQr:
        "Une activation est déjà en cours. Saisissez le code de l'entrée NOA Retraite que vous avez ajoutée dans votre application. Si vous n'avez pas encore scanné le QR code, choisissez « Recommencer l'activation ».",
      restart: "Recommencer l'activation",
      restartWarning:
        "Un nouveau QR code sera créé et l'ancien ne sera plus valable. Supprimez uniquement l'entrée NOA Retraite ajoutée pour cette activation dans votre application, puis scannez le nouveau QR code.",
      retry: "Réessayer",
      recoveryIntro:
        "Ces codes vous permettent de vous reconnecter si vous perdez votre téléphone. Chaque code ne fonctionne qu'une seule fois.",
      recoveryWarning:
        "Ils ne seront plus affichés. Conservez-les en lieu sûr (par exemple dans un coffre-fort de mots de passe).",
      copied: "Copié dans le presse-papiers",
      copyCodes: "Copier les codes",
      downloadCodes: "Télécharger (.txt)",
      recoveryConfirm: "J'ai conservé mes codes de secours",
      continue: "Continuer",
      logout: "Se déconnecter",
      challengeTitle: "Vérification en deux étapes",
      challengeSubtitle:
        "Saisissez le code à 6 chiffres affiché par votre application d'authentification.",
      challengeHint: "Code à 6 chiffres",
      useRecovery: "Utiliser un code de secours",
      recoveryHint: "Téléphone perdu ? Saisissez l'un de vos codes de secours.",
      recoveryLabel: "Code de secours",
      recoverySubmit: "Valider le code",
      backToTotp: "Retour au code à 6 chiffres",
      recoveryFileHeader: "NOA Retraite : codes de secours",
    },
    layout: {
      featMfa: "Authentification forte (MFA) et SSO",
      featEncryption: "Chiffrement AES-256 et TLS 1.2/1.3",
      featHosting: "Hébergement européen, conforme RGPD",
    },
    signup: {
      title: "Créer votre compte",
      subtitle:
        "L'inscription se fait par invitation de votre employeur. Saisissez l'email auquel votre invitation a été envoyée.",
      email: "Adresse email",
      password: "Choisir un mot de passe",
      passwordHelp: "12 caractères minimum, mélange majuscules / minuscules / chiffres / symboles.",
      firstName: "Prénom",
      lastName: "Nom",
      submit: "Créer mon compte",
      hasAccount: "Déjà un compte ?",
      login: "Se connecter",
      acceptTos:
        "En créant votre compte, vous acceptez nos conditions d'utilisation et notre politique de confidentialité.",
    },
    reset: {
      title: "Mot de passe oublié",
      subtitle:
        "Saisissez votre email — nous vous enverrons un lien sécurisé pour réinitialiser votre mot de passe.",
      email: "Adresse email",
      submit: "Envoyer le lien",
      backToLogin: "Retour à la connexion",
      sent: "Si un compte existe pour cette adresse, un email vient d'être envoyé.",
    },
    callback: {
      title: "Définir votre mot de passe",
      subtitle: "Choisissez un mot de passe pour accéder à votre espace.",
      password: "Mot de passe",
      confirm: "Confirmer le mot de passe",
      submit: "Valider",
      success: "Mot de passe défini avec succès.",
    },
    errors: {
      invalidEmail: "Adresse email invalide.",
      passwordTooShort: "Le mot de passe doit faire au moins 12 caractères.",
      passwordsDoNotMatch: "Les mots de passe ne correspondent pas.",
      generic: "Connexion impossible. Vérifiez vos identifiants ou réessayez plus tard.",
      emailRequired: "L'email est obligatoire.",
      invalidCredentials: "Email ou mot de passe incorrect.",
      accountLocked: "Compte bloqué. Contactez votre administrateur.",
      sessionExpired: "Votre session a expiré. Veuillez vous reconnecter.",
    },
  },
  legal: {
    privacy: {
      title: "Engagement de confidentialité d'Aon",
      updated: "Ce texte a été mis à jour : veuillez le relire et l'accepter de nouveau.",
      accept: "J'ai lu et j'accepte l'engagement de confidentialité d'Aon",
      enter: "Accéder à mon espace",
      logout: "Se déconnecter",
      error: "L'acceptation n'a pas pu être enregistrée. Réessayez ou contactez votre conseiller.",
      impersonation_banner: "Ce salarié n'a pas encore accepté l'engagement de confidentialité.",
    },
    ia: {
      learn_more: "En savoir plus",
      // Repli quand legal_texts n'est pas encore publié ou inaccessible : même
      // texte que la version 1 seedée en base.
      mention_default:
        "Contenu généré par intelligence artificielle (OpenAI). Vos nom, prénom et e-mail ne sont pas transmis, et vos données ne servent pas à entraîner les modèles.",
      conditions_default: `NOA utilise un service d'intelligence artificielle (OpenAI, via son interface de programmation) pour deux usages : préparer une synthèse de votre dossier (analyse Noa) et répondre à vos questions générales sur la retraite (assistant).

- Données transmises : uniquement les informations utiles à l'analyse (carrière, résultats de calcul, situation familiale, souhaits). Vos nom, prénom et adresse e-mail ne sont pas transmis.
- Pas d'entraînement : les données envoyées par la plateforme ne sont pas utilisées pour entraîner les modèles du fournisseur.
- Conservation : le fournisseur peut conserver les requêtes au plus 30 jours, pour la sécurité et la prévention des abus, puis les supprime.
- Localisation : le fournisseur peut traiter les données hors de l'Union européenne, dans le cadre des garanties prévues par le RGPD.
- Pas de décision automatisée : l'analyse est une aide. Elle est relue par un consultant Aon avant de vous être communiquée, sauf dans les parcours 100 % digitaux, où elle est présentée comme une aide indicative.`,
    },
  },
  footer: {
    legalDocuments: "Documents juridiques (nouvel onglet)",
    builtBy: "Plateforme conçue par Aon France",
    legal: "© 2026 Aon France. 31-35 rue de la Fédération, 75015 Paris.",
    privacy: "Confidentialité",
    terms: "CGU",
    contact: "Contact",
    dataProtection: "Protection des données",
    legalNotice: "Mentions légales",
    complaint: "Réclamation client",
  },
  salariesView: {
    kicker_admin: "Administration",
    kicker_drh: "Espace DRH",
    kicker_aon: "Production Aon",
    subtitle_admin: "Bénéficiaires des opérations BRI. Création manuelle ou import CSV.",
    subtitle_drh: "Vos salariés sur votre périmètre. Création manuelle ou import CSV.",
    subtitle_aon: "Les dossiers de votre périmètre. Création manuelle ou import CSV.",
    item_salarie: "salarié",
    items_salarie: "salariés",
    item_dossier: "dossier",
    items_dossier: "dossiers",
    import_file: "Importer un fichier",
    new_item: "Nouveau {{item}}",
    search: "Rechercher",
    search_placeholder: "Nom, prénom, matricule, email…",
    filter_society: "Société",
    filter_operation: "Opération",
    filter_type: "Type",
    filter_urgence: "Urgence",
    urgents_only: "Urgents",
    badge_urgent: "Urgent",
    all_f: "Toutes",
    all_m: "Tous",
    vip: "VIP",
    standard: "Standard",
    empty_filtered_title: "Aucun résultat avec ces filtres",
    empty_title: "Aucun {{item}} pour le moment",
    empty_filtered_desc: "Ajustez vos filtres ou créez une nouvelle fiche.",
    confidential_masked_title: "Données des salariés masquées : société confidentielle",
    confidential_masked_desc:
      "Les données personnelles des salariés de cette société ne sont accessibles qu'aux super-admins et aux internes Aon autorisés.",
    empty_desc: "Importez un fichier CSV ou créez des fiches manuellement.",
    count: "{{count}} {{item}}",
    badge_exited: "Sorti",
    badge_outgoing: "Sortant le {{date}}",
    filter_depart: "Départ",
    outgoing_only: "Sortants",
    exited_only: "Sortis",
    badge_account: "Compte activé",
    open_dossier: "Le dossier",
    open_dossier_title: "Ouvrir le dossier (parcours retraite)",
    view_sheet: "Voir la fiche",
    edit: "Modifier",
    delete: "Supprimer",
    send_invitation: "Envoyer une invitation",
    resend_link: "Renvoyer un lien de connexion",
    none_dossier: "Aucun dossier",
    change_status: "Changer le statut",
    change_status_aria: "Changer le statut du dossier",
    delete_title: "Supprimer {{name}} ?",
    delete_desc: "Tous les dossiers associés à ce {{item}} seront également supprimés.",
    delete_irreversible: "Cette action est irréversible.",
    delete_confirm: "Supprimer définitivement",
    status_title: "Changer le statut du dossier",
    status_reason_label: "Raison (optionnelle, tracée dans l'historique)",
    status_reason_placeholder: "Ex. pièces fournies, BRI restitué…",
    status_confirm: "Valider le changement",
    status_incomplete_warn: "Ce dossier n'est pas encore complet",
    status_incomplete_body:
      "(statut actuel : {{status}}). Vous pouvez tout de même changer son statut, mais des éléments peuvent manquer au bilan.",
    status_updated: "Statut mis à jour : {{status}}.",
    status_error: "Erreur lors du changement de statut",
    invitation_sent: "Invitation envoyée à {{recipient}}.",
    invitation_error: "Erreur lors de l'envoi",
    preview_error: "Erreur lors de la prévisualisation",
    send_invitation_confirm: "Envoyer l'invitation",
    invitation_preview_title: "Invitation : {{name}}",
    email_preview: "Aperçu de l'email",
    preview_desc: "Vérifiez le contenu avant d'envoyer le lien magique au {{item}}.",
    category_cadre: "Cadre",
    category_oetam: "OETAM",
    category_dirigeant: "Dirigeant",
    close: "Fermer",
  },
  relancesBoard: {
    kicker_aon: "Suivi Aon",
    kicker_rh: "Suivi RH",
    title: "Relances",
    description:
      "Pilotez le suivi des salariés dont le dossier est en attente d'une action de leur part.",
    kpi_to_relance: "À relancer",
    kpi_to_relance_hint: "Dossiers en attente du salarié",
    kpi_due: "À recontacter",
    kpi_due_hint: "Relance planifiée échue",
    kpi_never: "Jamais relancés",
    kpi_never_hint: "Aucune relance enregistrée",
    kpi_month: "Relances ce mois",
    kpi_month_hint: "Email + téléphone",
    kpi_total: "Total relances",
    kpi_total_hint: "Sur le périmètre affiché",
    search_placeholder: "Rechercher un salarié, matricule, société…",
    only_mine: "Mes dossiers seulement",
    filter_operation_all: "Toutes les opérations",
    filter_operation_aria: "Filtrer par opération",
    filter_status_all: "Tous les statuts",
    filter_status_aria: "Filtrer par statut du dossier",
    queue_title: "File de relances ({{count}})",
    without_dossier: "Sans dossier",
    operation_employees: "Salariés",
    operation_employees_hint: "Salariés de l'opération selon les filtres",
    operation_queue_title: "Salariés de l'opération ({{count}})",
    operation_scope_hint:
      "Cette liste inclut les salariés sans dossier. « Tout sélectionner » sélectionne tous les salariés affichés ayant un e-mail, sur toutes les pages. Les refus de contact et les départs restent exclus.",
    operation_empty_title: "Aucun salarié pour ces filtres",
    operation_empty_desc:
      "Vérifiez l'opération et les filtres. Les salariés ayant refusé le contact ou avec un départ renseigné ne sont pas proposés.",
    load_error: "Impossible de charger les salariés à contacter. Rechargez la page pour réessayer.",
    queue_empty_title: "Aucune relance en attente",
    queue_empty_desc: "Tous les dossiers de votre périmètre sont à jour ou avancés.",
    recent_title: "Activité récente",
    recent_empty_title: "Pas encore de relance",
    recent_empty_desc: "Les relances enregistrées apparaîtront ici.",
    never_relanced: "Jamais relancé",
    last_relance: "Dernière relance {{when}}",
    relance_count_one: "{{count}} relance",
    relance_count_other: "{{count}} relances",
    badge_due: "À recontacter",
    badge_planned: "Prévu",
    email_title: "Relancer {{email}} par email",
    call_title: "Appeler {{phone}}",
    relance: "Relancer",
    never: "Jamais relancé",
    today: "Aujourd'hui",
    yesterday: "Hier",
    days_ago: "Il y a {{count}} j",
    weeks_ago: "Il y a {{count}} sem",
    months_ago: "Il y a {{count}} mois",
    channel_email: "Email",
    channel_phone: "Téléphone",
    outcome_repondu: "A répondu",
    outcome_pas_de_reponse: "Pas de réponse",
    outcome_message_laisse: "Message laissé",
    outcome_a_rappeler: "À rappeler",
    outcome_refus: "Refus",
    outcome_injoignable: "Injoignable",
    drawer_title: "Relancer {{name}}",
    drawer_title_default: "Relancer",
    open_dossier: "Ouvrir le dossier",
    send_email: "Envoyer un email de relance",
    no_email: "Aucune adresse email connue",
    record_title: "Enregistrer une relance",
    notes_placeholder: "Commentaire de suivi (réponse obtenue, prochaine action…)",
    outcome_label_call: "Résultat de l'appel",
    outcome_label_relance: "Résultat de la relance",
    outcome_none: "Non renseigné",
    next_relance_label: "Prochaine relance prévue",
    record_submit: "Enregistrer la relance",
    save_error: "Erreur lors de l'enregistrement",
    history_title: "Historique ({{count}})",
    history_empty: "Aucune relance enregistrée.",
    auto: "Auto",
    by_author: "par {{author}}",
    next_relance_history: "Prochaine relance prévue {{date}}",
    delete_relance_aria: "Supprimer la relance",
    delete: "Supprimer",
    delete_title: "Supprimer cette relance ?",
    delete_desc: "L'entrée sera définitivement supprimée du journal de relances.",
    not_provided: "Non renseigné",
    select_all: "Tout sélectionner",
    deselect_all: "Tout désélectionner",
    select_aria: "Sélectionner {{name}}",
    selected_count_one: "{{count}} salarié sélectionné",
    selected_count_other: "{{count}} salariés sélectionnés",
    clear_selection: "Annuler",
    export_excel: "Exporter en Excel",
    export_hint: "Télécharge la file affichée et le journal des relances au format Excel",
    export_error: "Impossible de générer l'export",
    export_sheet_rows: "Relances",
    export_sheet_journal: "Journal",
    export_col_salarie: "Salarié",
    export_col_matricule: "Matricule",
    export_col_societe: "Société",
    export_col_operation: "Opération",
    export_col_statut: "Statut du dossier",
    export_col_email: "Email",
    export_col_telephone: "Téléphone",
    export_col_relance_count: "Nb relances",
    export_col_last_relance_at: "Dernière relance",
    export_col_last_channel: "Dernier canal",
    export_col_last_outcome: "Dernier résultat",
    export_col_next_relance_at: "Prochaine relance",
    export_col_is_due: "À recontacter",
    export_col_relance_at: "Date",
    export_col_channel: "Canal",
    export_col_outcome: "Résultat",
    export_col_author: "Auteur",
    export_col_automatic: "Automatique",
    export_col_notes: "Notes",
    export_yes: "Oui",
    export_no: "Non",
    bulk_send_email: "Email groupé",
    bulk_title: "Relance groupée par email",
    bulk_desc:
      "Un même modèle, personnalisé automatiquement pour chaque salarié (prénom, société, opération).",
    bulk_recipients_one: "{{count}} destinataire",
    bulk_recipients_other: "{{count}} destinataires",
    bulk_template: "Modèle",
    bulk_preview_note_one: "Aperçu affiché pour {{name}}.",
    bulk_preview_note_other:
      "Aperçu affiché pour {{name}}. L'email sera personnalisé pour chacun des {{count}} destinataires.",
    bulk_no_recipient: "Aucun destinataire avec une adresse email connue.",
    bulk_excluded_one: "{{count}} salarié sans adresse email, exclu de l'envoi :",
    bulk_excluded_other: "{{count}} salariés sans adresse email, exclus de l'envoi :",
    bulk_done_one: "{{count}} email envoyé.",
    bulk_done_other: "{{count}} emails envoyés.",
    bulk_failures_one: "{{count}} envoi en échec :",
    bulk_failures_other: "{{count}} envois en échec :",
    bulk_send_one: "Envoyer à {{count}} destinataire",
    bulk_send_other: "Envoyer à {{count}} destinataires",
    bulk_sending: "Envoi {{sent}}/{{total}}…",
    bulk_send_error: "Échec de l'envoi",
    bulk_customize: "Personnaliser le message",
    bulk_reset: "Réinitialiser",
    bulk_subject: "Objet",
    bulk_body: "Message",
    bulk_customize_hint:
      "Contenu HTML : les variables (prénom, nom, société, lien du dossier…) restent personnalisées pour chaque destinataire. L'en-tête et le pied de page Aon sont ajoutés automatiquement. L'aperçu ci-dessous se met à jour en temps réel.",
  },
  roles: {
    salarie: "Salarié",
    drh: "DRH",
    consultant_aon: "Consultant Aon",
    chef_projet_aon: "Chef de projet Aon",
    admin_aon: "Admin Aon",
    desc_salarie: "Bénéficiaire du BRI",
    desc_drh: "RH / DRH client",
    desc_consultant_aon: "Production des BRI",
    desc_chef_projet_aon: "Pilote opération Aon",
    desc_admin_aon: "Administration de la plateforme",
    no_role: "Aucun rôle attribué",
  },
  statuses: {
    non_demarre: "Non démarré",
    demarre_non_complete: "Démarré",
    complete_incomplet: "Complété — incomplet",
    complete_complet: "Complété — complet",
    en_production: "En production",
    a_restituer: "À restituer",
    restitue_avec_rdv: "Restitué (RDV)",
    restitue_sans_rdv: "Restitué",
    maj_sans_restitution: "MAJ — sans restitution",
    maj_avec_restitution: "MAJ — avec restitution",
    sans_suite: "Sans suite",
    desc_non_demarre: "Le salarié n'a pas encore activé son dossier.",
    desc_demarre_non_complete: "Le salarié a commencé à compléter son dossier.",
    desc_complete_incomplet: "Soumis mais des pièces ou informations manquent.",
    desc_complete_complet: "Le dossier est prêt à passer en production.",
    desc_en_production: "Le consultant Aon prépare votre Bilan Retraite.",
    desc_a_restituer: "Le BRI est prêt — la restitution sera planifiée.",
    desc_restitue_avec_rdv: "Le BRI a été restitué en rendez-vous.",
    desc_restitue_sans_rdv: "Le BRI a été remis sans rendez-vous.",
    desc_maj_sans_restitution: "Une mise à jour du BRI a été produite sans nouvel échange.",
    desc_maj_avec_restitution: "Une mise à jour a été restituée.",
    desc_sans_suite: "Le dossier a été clos sans BRI.",
    group_draft: "Brouillon",
    group_review: "En revue",
    group_production: "Production",
    group_delivered: "Livré",
    group_closed: "Clôturé",
  },
  journey: {
    demarrage: "Démarrage",
    completion: "Complétion",
    production: "Production",
    restitution: "Restitution",
    suivi: "Suivi",
    desc_demarrage: "Activation du compte et premiers échanges.",
    desc_completion: "Documents, situation, scénarios.",
    desc_production: "Calcul de la pension et préparation du BRI.",
    desc_restitution: "Présentation du BRI par un consultant Aon.",
    desc_suivi: "Mises à jour ultérieures du BRI.",
  },
  app: {
    // Évaluation de la prestation par le salarié (B7) : note 1-5, NPS 0-10
    // facultatif, commentaire ; affichée dès que le dossier est éligible.
    evaluation: {
      title: "Évaluation de la prestation",
      desc: "Votre bilan est disponible : aidez-nous à améliorer l'accompagnement.",
      satisfaction: "Votre satisfaction globale",
      pick: "Choisissez une note",
      satisfaction_1: "Très insatisfait",
      satisfaction_2: "Insatisfait",
      satisfaction_3: "Neutre",
      satisfaction_4: "Satisfait",
      satisfaction_5: "Très satisfait",
      nps: "Recommanderiez-vous cet accompagnement à un collègue ?",
      nps_min: "Pas du tout",
      nps_max: "Tout à fait",
      optional: "(facultatif)",
      comment: "Un commentaire à nous transmettre ?",
      comment_placeholder: "Ce qui vous a été utile, ce qui pourrait être amélioré…",
      submit: "Envoyer mon évaluation",
      update: "Mettre à jour",
      sending: "Envoi en cours…",
      edit: "Modifier mon évaluation",
      recorded: "Merci, votre évaluation a bien été enregistrée.",
      stars: "{{count}} étoile(s)",
    },
    // Appétences / souhaits de départ (CDC §13) — saisies par le salarié
    // (parcours 100 % digital) ou le consultant (parcours accompagnés).
    appetences: {
      title: "Vos appétences de départ",
      title_salarie: "Mes souhaits",
      required_badge: "Obligatoire pour accéder à votre BRI",
      optional_badge: "Facultatif",
      confirm: "Valider mes souhaits",
      update: "Mettre à jour",
      confirmed_on: "Souhaits enregistrés le {{date}}",
      description:
        "Vos souhaits pour la suite : ils orientent l'accompagnement et alimentent le reporting de votre entreprise (de façon anonymisée).",
      souhait_depart_au_plus_tot: "Partir au plus tôt",
      souhait_depart_au_plus_tard: "Partir au plus tard",
      souhait_rupture_conventionnelle: "Intérêt pour une rupture conventionnelle",
      souhait_temps_partiel_progressive: "Temps partiel / retraite progressive",
      interet_rachat_trimestres: "Intérêt pour le rachat de trimestres",
      interet_cumul_emploi_retraite: "Intérêt pour le cumul emploi-retraite",
      souhait_date_depart: "Date de départ souhaitée",
      hint: "Chaque réponse est enregistrée immédiatement.",
    },
    // Types de départ (scénarios standards) — libellés courts (tuiles de
    // sélection), descriptions, et libellés « résultat » (chips / tableaux).
    scenarios: {
      des_que_possible: "Dès que possible",
      des_que_possible_desc:
        "Départ au plus tôt, dès qu'une première pension peut vous être versée (souvent avec une décote).",
      des_que_possible_result: "Départ dès que possible",
      age_legal: "À l'âge légal",
      age_legal_desc:
        "Départ dès l'âge légal d'ouverture des droits, qui dépend de votre année de naissance.",
      age_legal_perso: "Votre âge légal : {{age}} (départ possible le {{date}}).",
      age_legal_result: "Départ à l'âge légal",
      age_62: "À 62 ans",
      age_62_desc:
        "Départ anticipé à 62 ans (généralement avec décote si le taux plein n'est pas atteint).",
      age_62_result: "Départ à 62 ans",
      age_65: "À 65 ans",
      age_65_desc: "Départ à 65 ans.",
      age_65_result: "Départ à 65 ans",
      taux_plein_naturel: "Au taux plein",
      taux_plein_naturel_desc:
        "Départ dès l'obtention du taux plein automatique (entre 65 et 67 ans selon votre date de naissance).",
      taux_plein_naturel_result: "Départ à taux plein (pension complète)",
      age_67: "À 67 ans (taux plein garanti)",
      age_67_desc:
        "Départ à 67 ans, âge du taux plein automatique quel que soit le nombre de trimestres.",
      rachat_taux_plein: "Avec rachat pour le taux plein ramené à l’âge légal",
      rachat_taux_plein_desc:
        "Départ à l'âge légal après rachat des trimestres manquants (maximum 12) pour obtenir le taux plein, avec coût et retour sur investissement estimés.",
      rachat_taux_seul: "Avec rachat à l'âge légal (taux seul)",
      rachat_taux_seul_desc:
        "Rachat des trimestres manquants agissant sur le taux de liquidation uniquement.",
      rachat_taux_seul_result: "Départ à l'âge légal après rachat (taux seul)",
      rachat_taux_plein_result: "Départ à l'âge légal après rachat de trimestres",
      date_imposee: "Date fixée par l'entreprise",
      date_imposee_desc:
        "Date de départ demandée par votre entreprise pour l'ensemble de l'opération.",
      age_67_result: "Départ à 67 ans",
      date_departure: "Départ le {{date}}",
      date_chosen: "Départ à une date choisie",
      fallback: "Scénario",
    },
    nav: {
      group_employee: "Mon espace",
      group_aon: "Espace Aon",
      group_drh: "Espace DRH",
      group_admin: "Administration",
      dashboard: "Tableau de bord",
      parcours: "Mon parcours retraite",
      historique: "Historique de mes calculs",
      dossier: "Mon dossier",
      documents: "Mes documents",
      simulations: "Mes simulations",
      bri: "Mon BRI",
      messages: "Messagerie",
      rdv: "Rendez-vous",
      formations: "Formations",
      profile: "Mon profil",
      settings: "Paramètres",
      help: "Aide & contacts",
      evaluation: "Évaluation de la prestation",
      // DRH
      operations: "Opérations",
      salaries: "Salariés",
      relances: "Relances",
      reporting: "Reporting",
      synthese_mission: "Synthèse de mission",
      // Aon
      mes_dossiers: "Mes dossiers",
      calendrier: "Mon agenda",
      bibliotheque: "Bibliothèque",
      revue: "Revue qualité",
      anomalies: "Bibliothèque d'anomalies",
      equipe: "Mon équipe",
      pilotage: "Pilotage",
      // Admin
      onboarding: "Nouvelle entreprise",
      tenants: "Clients",
      utilisateurs: "Utilisateurs",
      email_templates: "Templates emails",
      branding: "Branding",
      audit: "Audit",
      roadmap: "Roadmap",
      rachat_bareme: "Barème rachat",
      annexes_bri: "Annexes BRI",
      rgpd: "RGPD",
      controle_qualite: "Fiche d'autocontrôle",
      document_types: "Types de documents",
      referentiels: "Actualité des référentiels",
      referentiel_professions: "Référentiel professions",
      conventions_collectives: "Conventions collectives",
      parametres: "Paramètres",
      couts_ia: "Coûts IA",
      stats_usage: "Statistiques d'usage",
      external_services: "Services externes",
      suivi_messages: "Suivi des messages",
    },
    header: {
      greeting_morning: "Bonjour",
      greeting_afternoon: "Bon après-midi",
      greeting_evening: "Bonsoir",
      search_placeholder: "Rechercher…",
      open_menu: "Ouvrir le menu",
      change_language: "Changer de langue",
      breadcrumb: "Fil d'Ariane",
    },
    dashboard: {
      welcome_back: "Bon retour",
      no_dossier_title: "Aucun dossier actif",
      no_dossier_body:
        "Votre dossier n'a pas encore été créé. Si votre employeur vient de vous inscrire, patientez quelques minutes ou contactez votre RH.",
      kpi_status: "Statut du dossier",
      kpi_consultant: "Consultant Aon",
      kpi_next_rdv: "Prochain rendez-vous",
      kpi_bri_type: "Type de BRI",
      no_consultant: "À affecter",
      no_rdv: "Aucun RDV planifié",
      progression: "Progression",
      actions_title: "Actions à effectuer",
      actions_empty: "Vous êtes à jour, rien à faire pour le moment ✨",
      action_upload_ris: "Téléverser votre relevé de carrière (RIS)",
      action_upload_agirc: "Téléverser votre relevé Agirc-Arrco",
      action_upload_bulletin: "Téléverser votre dernier bulletin de salaire",
      action_complete_profile: "Compléter vos coordonnées",
      action_select_scenarios: "Choisir vos scénarios de simulation",
      action_book_rdv: "Réserver votre rendez-vous de restitution",
      recent_activity: "Historique récent",
      urgent_title: "Dossier marqué urgent",
      urgent_body:
        "Votre conseiller Aon le traite en priorité. Votre DRH voit seulement qu'il est prioritaire.",
      urgent_auto: "Marqué prioritaire automatiquement (départ proche)",
    },
    notFound: {
      title: "Page introuvable",
      description: "Cette adresse ne correspond à aucune page de votre espace.",
      back_home: "Retour à l'accueil",
    },
    profile: {
      title: "Mon profil",
      subtitle: "Vos coordonnées et préférences personnelles.",
      section_identity: "Identité",
      section_contact: "Coordonnées",
      section_preferences: "Préférences",
      first_name: "Prénom",
      last_name: "Nom",
      civility: "Civilité",
      email: "Email",
      phone: "Téléphone",
      locale: "Langue de l'interface",
      saved: "Modifications enregistrées.",
      save: "Enregistrer les modifications",
      section_security: "Sécurité",
      contact_pref_title: "Préférences de contact",
      contact_pref_desc:
        "Vous pouvez demander à ne plus être relancé(e) par l'équipe au sujet de votre dossier. Vous gardez l'accès à votre espace et pouvez revenir sur ce choix à tout moment.",
      contact_pref_label: "Je ne souhaite pas être recontacté(e) au sujet de mon dossier",
      contact_pref_on: "Vous ne recevrez plus de relances (e-mail, téléphone) de l'équipe.",
      contact_pref_off: "L'équipe peut vous relancer si votre dossier reste incomplet.",
      security_description: "Modifiez votre mot de passe de connexion.",
      new_password: "Nouveau mot de passe",
      confirm_password: "Confirmer le mot de passe",
      password_hint: "8 caractères minimum.",
      password_too_short: "Le mot de passe doit contenir au moins 8 caractères.",
      password_mismatch: "Les mots de passe ne correspondent pas.",
      change_password: "Modifier le mot de passe",
      password_saved: "Mot de passe mis à jour.",
      mfa_title: "Double authentification",
      mfa_desc:
        "Protégez votre compte avec un code généré par une application sur votre téléphone.",
      mfa_status_on: "2FA activée",
      mfa_status_off: "2FA non activée",
      mfa_required_badge: "Obligatoire pour votre profil",
      mfa_enable: "Activer la double authentification",
      mfa_regenerate: "Régénérer mes codes de secours",
      mfa_disable: "Désactiver la double authentification",
      mfa_codes_done: "J'ai conservé mes nouveaux codes",
      mfa_error: "L'opération a échoué. Réessayez.",
      rgpd: {
        title: "Mes données personnelles (RGPD)",
        description:
          "Exercez vos droits sur vos données : accès, rectification, effacement, opposition ou limitation. Votre demande est traitée sous un mois.",
        kind_label: "Type de demande",
        reason_label: "Précisions (facultatif)",
        reason_placeholder: "Décrivez votre demande si nécessaire…",
        submit: "Envoyer ma demande",
        submitted: "Demande enregistrée",
        my_requests: "Mes demandes ({{count}})",
        deposited: "Déposée le {{date}}",
      },
    },
    dossier: {
      title: "Mon dossier",
      subtitle: "Vue d'ensemble de votre dossier retraite.",
      tab_overview: "Synthèse",
      tab_career: "Carrière",
      tab_family: "Situation familiale",
      tab_special: "Cas particuliers",
      tab_scenarios: "Scénarios",
      not_assigned: "Pas encore rattaché à une fiche salarié.",
    },
    dossierDetail: {
      // Tabs
      tab_synthesis: "Synthèse",
      tab_documents: "Documents",
      tab_scenarios: "Scénarios",
      tab_career: "Carrière",
      tab_calculations: "Calculs",
      tab_analysis: "Analyse Noa",
      tab_vip: "VIP",
      tab_appointments: "RDV",
      tab_history: "Historique",
      chomage_title: "Scénario chômage",
      chomage_desc:
        "Modélise une période de chômage avant le départ, à partir des dates déclarées par le salarié.",
      chomage_active: "Actif",
      chomage_inactive: "Non prévu",
      chomage_by_config: "Ouvert par le paramétrage de l'opération.",
      chomage_request_cta: "Demander le scénario chômage",
      chomage_request_title: "Demander un scénario chômage",
      chomage_request_desc:
        "Le scénario sera pris en compte au prochain calcul, à partir des dates renseignées par le salarié.",
      chomage_request_message: "Message pour l'équipe Aon (facultatif)",
      chomage_request_placeholder: "Ex : rupture conventionnelle prévue fin 2027.",
      chomage_request_send: "Envoyer la demande",
      chomage_request_received: "Scénario chômage demandé le {{date}}",
      chomage_request_clear: "Retirer la demande",
      // Header
      not_found: "Dossier introuvable",
      not_found_description: "Vous n'avez peut-être pas accès à ce dossier.",
      back_to_list: "← Revenir à la liste",
      vip: "VIP",
      consultant: "Consultant :",
      me: "Moi",
      not_assigned: "non assigné",
      assign: "affecter",
      // Dossier urgent (B4)
      urgent_badge: "Urgent",
      urgence_delay_badge: "Délai dépassé",
      urgent_detail_prefix: "depuis le {{date}}",
      urgence_reason_depart_moins_6_mois: "Départ prévu dans moins de 6 mois",
      urgence_reason_rupture_licenciement: "Rupture ou licenciement en cours",
      urgence_reason_decision_rapide: "Décision à prendre rapidement",
      urgence_reason_autre: "Autre",
      urgence_source_salarie: "salarié",
      urgence_source_consultant: "interne Aon",
      urgence_source_automatique: "marquage automatique",
      urgence_mark: "Marquer urgent",
      urgence_lift: "Lever l'urgence",
      urgence_lift_title: "Lever l'urgence ?",
      urgence_lift_desc:
        "Le dossier perdra son badge urgent. Cette action est enregistrée dans l'historique.",
      urgence_lift_desc_auto:
        "Cette urgence a été posée automatiquement. En la levant, vous indiquez qu'elle ne doit pas être reposée : la tâche quotidienne ne la réactivera plus.",
      urgence_dialog_title: "Marquer le dossier urgent",
      urgence_dialog_desc:
        "Le dossier remontera en tête des listes et une notification sera envoyée au chef de projet et au consultant assignés.",
      urgence_reason_label: "Motif",
      urgence_reason_pick: "Choisir un motif",
      urgence_comment_label: "Commentaire (facultatif)",
      urgence_comment_ph: "Précisions visibles uniquement par l'équipe Aon.",
      urgence_history_title: "Historique de l'urgence",
      urgence_history_marked: "Marqué urgent",
      urgence_history_lifted: "Urgence levée",
      modify: "modifier",
      project_manager: "Chef de projet :",
      reviewer: "Relecteur :",
      restitution_consultant: "Consultant de restitution :",
      restitution_same_as_production: "Identique au consultant de production",
      release: "Relâcher",
      open_file: "Le dossier",
      edit_file: "Modifier la fiche",
      // Overview tab
      not_editable_warning:
        "Ce dossier n'est plus en phase de complétion par le salarié. La modification de la fiche se fait désormais en back-office uniquement.",
      identity: "Identité",
      civility: "Civilité",
      first_name: "Prénom",
      last_name: "Nom",
      birth_name: "Nom de naissance",
      birth_date: "Date de naissance",
      birth_place: "Lieu",
      email: "Email",
      phone: "Téléphone",
      career_current_company: "Carrière (société courante)",
      company: "Société",
      site: "Site",
      position: "Poste",
      category: "Catégorie",
      entry_date: "Date d'entrée",
      presence: "Présence",
      present: "Présent",
      left: "Sorti",
      declared_salary: "Salaire déclaré",
      confirmed_salary: "Salaire confirmé",
      family: "Famille",
      situation: "Situation",
      spouse_birth: "Conjoint — naissance",
      wedding_date: "Date mariage",
      children_count: "Nombre d'enfants",
      children_charge_retirement: "Enfants à charge retraite",
      children_handicap: "Enfants en handicap",
      yes: "Oui",
      no: "Non",
      special_cases: "Cas particuliers",
      no_special_cases: "Aucun cas particulier déclaré.",
      cet_jours: "Jours de CET épargnés",
      cet_avant_depart: "Utilisation du CET avant le départ",
      children_quarters_title: "Trimestres par enfant",
      children_quarters_hint:
        "Trimestres de majoration retenus par enfant. Vide = règle générale (8 trimestres, 4 pour un enfant mort-né). Ajustez pour un partage entre parents, une adoption ou un régime spécial.",
      children_quarters_total: "{{count}} trimestres au total",
      children_quarters_empty: "Aucun enfant déclaré à l'étape Famille.",
      child_n: "Enfant {{index}}",
      child_stillborn: "Mort-né",
      child_handicap: "Handicap",
      child_quarters_label: "Trimestres",
      file_metadata: "Métadonnées dossier",
      id: "ID",
      bri_type: "Type BRI",
      created_on: "Créé le",
      submitted_on: "Soumis le",
      control_n1: "Contrôle N1",
      control_n2: "Contrôle N2",
      restored_on: "Restitué le",
      // Documents tab
      no_document_uploaded: "Aucun document téléversé",
      no_document_description:
        "Le salarié n'a pas encore fourni de pièces. Relancez-le si nécessaire.",
      close: "Fermer",
      reject_document: "Refuser ce document",
      reject_reason: "Motif du refus",
      reject_placeholder: "Ex. illisible, document incomplet, mauvais type de pièce…",
      reject_button: "Refuser",
      document_rejected_default: "Document refusé",
      launch_ris_extraction: "Lancer l'extraction du RIS",
      launch_analysis: "Lancer l'analyse",
      ris_extraction_description:
        "Le RIS va être transmis au moteur de calcul pour en extraire automatiquement les périodes de carrière, points et trimestres, alimentant l'onglet <strong>Carrière</strong>.",
      ris_revenue_note:
        "Le revenu de fin de carrière est recalculé (déplafonné du PASS) par le moteur.",
      validated: "Validé",
      rejected: "Refusé",
      to_validate: "À valider",
      parsed: "Parsé",
      parse_this_ris: "Parser ce RIS",
      uploaded_on: "Téléversé le",
      reason: "Motif :",
      // Scenarios tab
      no_scenario_selected: "Aucun scénario sélectionné",
      no_scenario_description: "Le salarié choisira ses scénarios à la complétion du dossier.",
      selected_by: "par",
      inactive: "inactif",
      selected_on: "Sélectionné le",
      // History tab
      no_history: "Aucun historique",
      current_status: "Statut courant :",
      // Journal des consentements
      consents_title: "Consentements",
      consent_privacy: "Confidentialité Aon acceptée, version {{version}}",
      consent_share: "Partage employeur : {{from}} → {{to}}",
      share_full: "bilan complet",
      share_date_only: "date de départ uniquement",
      share_none: "aucune information",
      share_initial: "aucun choix",
      // Appointments tab
      appointments_count_one: "{{count}} rendez-vous",
      appointments_count_other: "{{count}} rendez-vous",
      schedule_appointment: "Programmer un RDV",
      no_appointment: "Aucun rendez-vous",
      schedule_description: "Programmez un rendez-vous de restitution avec le salarié.",
      no_appointment_description: "Aucun rendez-vous n'a encore été programmé pour ce dossier.",
      open_meeting_link: "Ouvrir le lien de réunion",
      realized: "Réalisé",
      cancel: "Annuler",
      cancel_appointment: "Annuler ce rendez-vous",
      appointment_cancellation_note:
        "Le créneau associé sera de nouveau disponible. Le salarié ne sera pas notifié automatiquement dans cette version.",
      // Status transitions
      change_status: "Changer de statut",
      status_change_description: "Changer de statut",
      reason_optional: "Raison (optionnelle, tracée dans l'historique)",
      reason_placeholder: "Ex. salarié a fourni les pièces manquantes, RDV planifié…",
      validate_change: "Valider le changement",
      // Take over menu
      reassign: "Réaffecter",
      assign_to_myself: "Me l'attribuer",
      take_charge: "Prendre en charge",
      i_become_consultant: "Je deviens le consultant.",
      assign_to_consultant: "Affecter à un consultant…",
      choose_team_member: "Choisir un membre de l'équipe.",
      // Dynamic labels
      reject_document_description: "Document « {{filename}} ». Le salarié sera notifié.",
      parse_document_description: "Document « {{filename}} ».",
      parsed_with_count_one: "{{count}} période",
      parsed_with_count_other: "{{count}} périodes",
      cancel_appointment_description: "RDV du {{date}}.",
      selected_on_date: "Sélectionné le {{date}}",
      uploaded_on_date: "Téléversé le {{date}}",
      reason_value: "Motif : {{reason}}",
      full_rate_age_value: "{{years}} ans{{months}}",
      full_rate_age_months: " {{months}} m",
      appointment_consultant: "Consultant : {{name}}",
      // Calculation tab
      retirement_calculation: "Calcul retraite",
      open_retirement_journey: "Ouvrir le parcours retraite",
      no_calculation_available:
        "Aucun calcul disponible. Importez un RIS, puis lancez le calcul depuis le parcours retraite.",
      monthly_gross_pension: "Pension mens. brute",
      monthly_net_pension: "Pension mens. nette",
      replacement_rate: "Taux remplacement",
      validated_quarters: "Trimestres validés",
      contributed_quarters: "Trimestres cotisés",
      deemed_contributed_quarters: "Réputés cotisés",
      full_rate_age: "Âge taux plein",
      // Appointment channels
      video: "Visio",
      telephone: "Téléphone",
      in_person: "Présentiel",
      // Appointment statuses
      proposed: "Proposé",
      planned: "Planifié",
      cancelled: "Annulé",
      absent: "Absent",
      // Tracking
      file_tracking: "Suivi du dossier",
      closed_short: "Sans suite",
      to_do: "À faire",
      status_non_demarre: "Non démarré",
      status_demarre_non_complete: "Démarré",
      status_complete_incomplet: "Complété — incomplet",
      status_complete_complet: "Complété — complet",
      status_en_production: "En production",
      status_a_restituer: "À restituer",
      status_restitue_avec_rdv: "Restitué (RDV)",
      status_restitue_sans_rdv: "Restitué",
      status_maj_sans_restitution: "MAJ — sans restitution",
      status_maj_avec_restitution: "MAJ — avec restitution",
      status_sans_suite: "Sans suite",
      status_non_demarre_description: "Le salarié n'a pas encore activé son dossier.",
      status_demarre_non_complete_description: "Le salarié a commencé à compléter son dossier.",
      status_complete_incomplet_description: "Soumis mais des pièces ou informations manquent.",
      status_complete_complet_description: "Le dossier est prêt à passer en production.",
      status_en_production_description: "Le consultant Aon prépare votre Bilan Retraite.",
      status_a_restituer_description: "Le BRI est prêt — la restitution sera planifiée.",
      status_restitue_avec_rdv_description: "Le BRI a été restitué en rendez-vous.",
      status_restitue_sans_rdv_description: "Le BRI a été remis sans rendez-vous.",
      status_maj_sans_restitution_description:
        "Une mise à jour du BRI a été produite sans nouvel échange.",
      status_maj_avec_restitution_description: "Une mise à jour a été restituée.",
      status_sans_suite_description: "Le dossier a été clos sans BRI.",
      journey_step_demarrage: "Démarrage",
      journey_step_demarrage_description: "Activation du compte et premiers échanges.",
      journey_step_completion: "Complétion",
      journey_step_completion_description: "Documents, situation, scénarios.",
      journey_step_production: "Production",
      journey_step_production_description: "Calcul de la pension et préparation du BRI.",
      journey_step_restitution: "Restitution",
      journey_step_restitution_description: "Présentation du BRI par un consultant Aon.",
      journey_step_suivi: "Suivi",
      journey_step_suivi_description: "Mises à jour ultérieures du BRI.",
      next_action_non_demarre: "Inviter / relancer le salarié pour qu'il active son espace.",
      next_action_demarre_non_complete:
        "Le salarié doit compléter son dossier (informations, documents, scénarios).",
      next_action_complete_incomplet:
        "Des pièces ou informations manquent : relancer le salarié pour compléter.",
      next_action_complete_complet:
        "Dossier prêt : affecter un consultant et passer en production.",
      next_action_en_production: "Calculs et rédaction du BRI en cours, puis contrôles N1 / N2.",
      next_action_a_restituer: "BRI prêt : planifier la restitution avec le salarié.",
      next_action_restitue_avec_rdv:
        "Bilan restitué : recueillir l'évaluation et traiter les demandes de mise à jour.",
      next_action_restitue_sans_rdv:
        "Bilan restitué : recueillir l'évaluation et traiter les demandes de mise à jour.",
      next_action_maj_sans_restitution:
        "Mise à jour produite : rien à faire, suivi au fil de l'eau.",
      next_action_maj_avec_restitution:
        "Mise à jour produite : rien à faire, suivi au fil de l'eau.",
      next_action_sans_suite: "Dossier clos sans suite.",
      // BRI
      bri_delivered: "BRI livré",
      bri_description:
        "Génère le PDF du Bilan Retraite Individuel — le même document que celui téléchargeable depuis le parcours retraite du salarié.",
      pptx_source_title: "Source PowerPoint (dossier VIP)",
      pptx_source_hint:
        "Mêmes pages que le PDF, en formes éditables, pour retravailler la restitution. Les illustrations du gabarit sont reprises en images haute résolution.",
      pptx_source_download: "Télécharger le .pptx",
      generation_blocked: "Génération bloquée.",
      n1_must_be_validated: "Le contrôle N1 doit être validé.",
      n2_must_be_validated: "Le contrôle N2 doit être validé.",
      generate_new_version: "Générer une nouvelle version",
      generate_bri: "Générer le BRI",
      create_version_vX:
        "Crée une v{{nextVersion}} (remplace la v{{currentVersion}} comme version courante).",
      first_bri_v1: "Premier BRI livré (v1).",
      regenerate: "Régénérer",
      previous_versions: "Versions précédentes ({{count}})",
      send_bri_to_employee: "Envoyer le BRI au salarié",
      send_bri_description:
        "La version {{version}} sera mise à disposition dans l'espace du salarié, qui sera notifié par email.",
      send: "Envoyer",
      employee_will_receive_email:
        "Le salarié recevra un email l'invitant à consulter son Bilan Retraite.",
      bri_version: "Version {{version}}",
      draft: "Brouillon",
      current: "Courante",
      sent_on: "Envoyé le {{date}}",
      not_sent_to_employee: "Non envoyé au salarié",
      send_to_employee: "Envoyer au salarié",
      open: "Ouvrir",
      bri_selection_title: "Simulations présentées dans le BRI",
      bri_selection_help:
        "Le BRI présentera uniquement les simulations cochées, dans cet ordre. Le choix s'applique à la prochaine génération ; les BRI déjà produits ne changent pas.",
      bri_selection_source_consultant: "Choix du consultant",
      bri_selection_source_operation: "Fléchage de l'opération",
      bri_selection_source_all: "Toutes les simulations",
      bri_selection_degraded_warning:
        "Aucun élément de la sélection n'est disponible dans le dernier calcul : le BRI présentera toutes les simulations.",
      bri_selection_empty: "Aucune simulation disponible : lancez d'abord le calcul du dossier.",
      bri_selection_on_demand: "Simulation à la demande",
      bri_selection_progressive_title: "Retraite progressive : quotités présentées",
      bri_selection_save: "Enregistrer la sélection",
      bri_selection_reset: "Revenir au choix par défaut",
      // Controls
      controls_self_control_sheet: "Fiche d'autocontrôle",
      controls_description:
        "Relecture à deux niveaux à compléter avant la mise à disposition du BRI.",
      sim_settings_title: "Paramètres de simulation",
      sim_settings_desc:
        "Bornes héritées de l'opération, et débridage éventuel de ce dossier précis.",
      sim_parcours_type: "Type de parcours",
      sim_max_age: "Date de départ maximale",
      sim_rachat: "Rachat de trimestres",
      sim_quota: "Simulations / 12 mois",
      sim_quota_value: "{{count}} par salarié",
      sim_quota_unlimited: "Illimité",
      sim_policy_taux_plein_naturel: "Taux plein naturel",
      sim_policy_age_65: "Jusqu'à 65 ans",
      sim_policy_age_67: "Jusqu'à 67 ans",
      sim_policy_libre: "Libre",
      sim_request_title: "Le salarié a demandé une date spécifique le {{date}}",
      sim_unlock_label: "Autoriser les dates libres pour ce dossier",
      sim_unlock_active: "Débridé",
      sim_unlock_hint:
        "Le salarié pourra simuler n'importe quelle date de départ, sans la limite de l'opération.",
      controls_n1_production: "Contrôle N1 — Auto-contrôle production",
      controls_n1_description:
        "Auto-contrôle réalisé par le consultant en charge du dossier (chef de projet et admin en reprise).",
      controls_n1_reserved_consultant:
        "Réservé au consultant en charge du dossier, au chef de projet ou à un admin.",
      controls_unvalidate_n1_cascade: "Annuler le N1 annule aussi le contrôle N2.",
      controls_n2_project_manager: "Contrôle N2 — Chef de projet",
      controls_n2_description_available: "Contrôle final par le chef de projet avant restitution.",
      controls_n2_description_waiting: "Attend la validation N1 avant d'être disponible.",
      controls_validated: "Validé",
      controls_validated_by: "Validé par {{name}}",
      controls_bri_can_be_generated: "Le BRI peut maintenant être généré.",
      controls_progress:
        "{{doneRequired}}/{{totalRequired}} requis · {{doneTotal}}/{{totalTotal}} au total",
      controls_validate_level: "Valider N{{level}}",
      controls_validate_blocked: "Cochez tous les points requis du N{{level}} pour valider.",
      controls_reserved_project_manager: "Réservé au chef de projet",
      controls_loading_grid: "Chargement de la grille…",
      controls_no_checkpoints_defined: "Aucun point de contrôle défini pour ce niveau.",
      controls_required: "Requis",
    },
    salarieFollowup: {
      // Salarie follow-up
      account_management: "Gestion du compte",
      account_management_description: "Formation, activation et connexion du salarié.",
      formation_followed: "Formation suivie",
      formation_marked_on: "Marquée le {{date}}",
      formation_question: "Le salarié a-t-il suivi la formation retraite ?",
      trained_check_title: "Salarié formé — vérification du suivi :",
      logged_in: "S'est connecté",
      last_login_on: "Dernière connexion le {{date}}",
      login_detected: "Connexion détectée",
      checking: "Vérification…",
      account_created_never_logged_in: "Compte créé mais jamais connecté",
      no_account_send_invitation: "Aucun compte — envoyer une invitation",
      file_complete: "Dossier complet",
      all_required_elements_provided: "Tous les éléments requis sont fournis",
      elements_provided: "{{done}}/{{total}} éléments fournis",
      trained_but_issue: "Salarié formé mais {{issue}}",
      not_connected: "non connecté",
      file_incomplete: "dossier incomplet",
      follow_up_below: "— à relancer (voir le module Relances ci-dessous).",
      not_yet_trained: "Salarié non encore formé",
      invite_to_training:
        "— à inviter à une session de formation avant le suivi connexion/complétude.",
      account_activated: "Compte activé",
      account_created: "Compte créé",
      no_account_send_invitation_from_list: "Aucun compte — envoyer une invitation depuis la liste",
      file_completeness: "Complétude du dossier",
      all_elements_present: "Tous les éléments requis sont présents.",
      elements_missing: "Des éléments manquent encore au dossier.",
      no_file_yet: "Aucun dossier : il sera créé à la première connexion du salarié.",
      checklist_infos: "Informations individuelles",
      checklist_ris: "Relevé de carrière",
      checklist_agirc_arrco: "Relevé Agirc-Arrco",
      checklist_bulletin: "Bulletin de salaire décembre N-1",
      checklist_profil: "Autres éléments suivant profil (pénibilité, handicap…)",
      checklist_hypotheses: "Paramétrage des hypothèses de calcul",
      profile_requires_justification:
        "Le profil du salarié (cas particuliers) exige un justificatif.",
      no_special_case_no_justification:
        "Aucun cas particulier déclaré : pas de justificatif requis.",
      not_required: "Non requis",
      account_closure_title: "Clôture du compte",
      account_closure_description: "Enregistre la sortie du salarié (date et motif du départ).",
      account_closed_badge: "Clôturé",
      account_outgoing_badge: "Sortant le {{date}}",
      account_active_badge: "Actif",
      exit_date: "Date de départ",
      exit_reason: "Motif du départ",
      exit_reason_unspecified: "Non précisé",
      reactivate_account: "Réactiver le compte",
      close_account: "Clôturer le compte",
      active_description:
        "Le salarié est actuellement actif. Enregistrez son départ lorsqu'il quitte l'entreprise.",
      closure_warning:
        "La clôture marque le salarié comme sorti de l'entreprise. Son compte restera consultable mais il sera signalé « Sorti ».",
      exit_comment_placeholder: "Commentaire complémentaire sur le départ (facultatif)",
      exit_date_required: "La date de départ est obligatoire.",
      exit_reason_required: "Le motif du départ est obligatoire.",
      closure_error: "Erreur lors de la clôture du compte.",
      reactivate_account_title: "Réactiver ce compte ?",
      reactivate_account_description:
        "La date et le motif de départ seront effacés et le salarié redeviendra actif.",
      exit_type_retraite: "Départ volontaire en retraite",
      exit_type_mise_a_la_retraite: "Mise à la retraite (employeur)",
      exit_type_rupture_conventionnelle: "Rupture conventionnelle",
      exit_type_licenciement: "Licenciement",
      exit_type_demission: "Démission",
      exit_type_mutation: "Mutation",
      exit_type_deces: "Décès",
      exit_type_autre: "Autre",
      relances_title: "Relances",
      refuse_contact_title: "Ce salarié a demandé à ne plus être recontacté.",
      refuse_contact_body:
        "Il est exclu des relances automatiques et de la file de relances. Respectez ce choix : ne le relancez que pour une obligation légale ou contractuelle.",
      relances_description: "Suivi des relances effectuées par email ou par téléphone.",
      new_relance: "Nouvelle relance",
      relance_channel_email: "Email",
      relance_channel_telephone: "Téléphone",
      relance_notes_placeholder: "Commentaire de suivi (réponse obtenue, prochaine action…)",
      relance_outcome_label: "Résultat de la relance ({{channel}})",
      relance_outcome_repondu: "A répondu",
      relance_outcome_pas_de_reponse: "Pas de réponse",
      relance_outcome_message_laisse: "Message laissé",
      relance_outcome_a_rappeler: "À rappeler",
      relance_outcome_refus: "Refus",
      relance_outcome_injoignable: "Injoignable",
      next_relance_date: "Prochaine relance prévue",
      save_relance: "Enregistrer la relance",
      relance_save_error: "Erreur lors de l'enregistrement",
      no_relances: "Aucune relance enregistrée pour ce salarié.",
      relance_auto: "Auto",
      relance_by: "par {{name}}",
      next_relance_on: "Prochaine relance prévue {{date}}",
      delete_relance: "Supprimer la relance",
      delete_relance_title: "Supprimer cette relance ?",
      delete_relance_description: "L'entrée sera définitivement supprimée du journal de relances.",
      evaluation_title: "Évaluation de la prestation",
      evaluation_description: "Avis déposé par le salarié après la restitution de son bilan.",
      no_evaluation_yet: "Le salarié n'a pas encore évalué la prestation.",
      evaluation_score: "{{score}}/5",
      evaluation_recommendation_badge: "Recommandation {{score}}/10",
      evaluated_on: "Évalué le {{date}}",
      evaluation_invited_on: "Invitation envoyée le {{date}}",
      evaluation_reminded_on: "Relance envoyée le {{date}}",
      satisfaction_1: "Très insatisfait",
      satisfaction_2: "Insatisfait",
      satisfaction_3: "Neutre",
      satisfaction_4: "Satisfait",
      satisfaction_5: "Très satisfait",
    },
    careerPeriods: {
      unavailable_title: "L'éditeur des périodes de carrière n'est pas disponible",
      unavailable_desc:
        "La table des périodes de carrière n'est pas encore disponible sur cet environnement.",
      postgres_error: "Erreur Postgres : {{msg}}",
      unknown_error: "Erreur inconnue",
      count_one: "{{count}} période",
      count_other: "{{count}} périodes",
      validated_count_one: "{{count}} validée",
      validated_count_other: "{{count}} validées",
      add_period: "Ajouter une période",
      empty_title: "Aucune période saisie",
      empty_desc_editable:
        "Commencez par ajouter la première période professionnelle de ce dossier.",
      empty_desc_readonly: "Aucune période n'a encore été saisie sur ce dossier.",
      add_first_period: "Ajouter la première période",
      activity_period: "Période d'activité",
      validated: "Validée",
      revenues: "Revenus :",
      evolution: "évolution",
      remove_validation: "Retirer la validation",
      validate_period: "Valider la période",
      invalidate: "Invalider",
      validate: "Valider",
      edit: "Modifier",
      delete_confirm: "Supprimer la période « {{label}} » ?",
      delete_desc:
        "Les informations de cette période seront définitivement supprimées. Cette action est irréversible.",
      delete_desc_ris:
        "Les trimestres et points de cette période restent comptés : ils figurent dans le relevé de carrière transmis au calcul. Supprimez une période du relevé uniquement pour corriger un doublon d'affichage.",
      delete: "Supprimer",
      cancel: "Annuler",
      period_fallback: "période {{range}}",
      in_progress: "en cours",
    },
    noaAnalyse: {
      cancel: "Annuler",
      save: "Enregistrer",
      edit_text: "Éditer le texte",
      regenerate: "Régénérer (IA)",
      generate: "Générer avec l'IA",
      generate_self: "Lancer mon analyse",
      regenerate_self: "Relancer mon analyse",
      generate_failed: "La génération de l'analyse a échoué.",
      save_failed: "L'enregistrement a échoué.",
      reset_failed: "La réinitialisation a échoué.",
      title_aon: "Analyse complète par Noa",
      title_salarie: "Votre analyse personnalisée",
      description_aon:
        "Étude de cas détaillée du dossier, vérifiée sur les sources officielles. Générez une première version avec l'IA puis ajustez librement le texte : c'est cette version que verra le salarié.",
      description_salarie:
        "Une étude détaillée de votre situation retraite : profil, scénarios, leviers d'optimisation et recommandations personnalisées.",
      editor_aria: "Contenu de l'analyse",
      reset_to_ai: "Réinitialiser au texte généré par l'IA",
      publish: "Publier au salarié",
      unpublish: "Retirer la publication",
      publish_failed: "La publication n'a pas pu être enregistrée.",
      badge_published: "Publiée",
      badge_draft: "Brouillon",
      pending_publication:
        "Votre analyse est en cours de relecture par votre conseiller Aon. Elle s'affichera ici dès qu'elle sera validée.",
      unpublish_confirm_title: "Retirer la publication ?",
      unpublish_confirm_desc:
        "Le salarié n'aura plus accès à l'analyse ni à l'arbitrage Tranche C, et ils disparaîtront de son BRI. Vous pourrez republier à tout moment.",
      empty_aon:
        "Lancez l'analyse pour générer une première version avec l'IA, puis ajustez le texte avant qu'il ne soit visible par le salarié.",
      empty_salarie:
        "Votre analyse personnalisée sera bientôt disponible. Votre conseiller Aon la prépare pour vous.",
      description_self:
        "Noa étudie votre situation et rédige pour vous une analyse détaillée : profil, scénarios de départ, leviers d'optimisation et recommandations.",
      empty_self:
        "Lancez votre analyse quand vous voulez : Noa reprend votre carrière, vos simulations et les règles en vigueur pour vous expliquer votre situation. Comptez une à deux minutes.",
      disclaimer_self:
        "Analyse rédigée par Noa, notre intelligence artificielle spécialisée retraite, à partir des informations de votre dossier. Aide à la décision : elle ne remplace pas un conseil juridique ou fiscal personnalisé.",
      disclaimer_self_with_date:
        "Analyse rédigée par Noa, notre intelligence artificielle spécialisée retraite, le {{date}}, à partir des informations de votre dossier. Relancez-la après toute modification. Aide à la décision : elle ne remplace pas un conseil juridique ou fiscal personnalisé.",
      cooldown:
        "Votre analyse vient d'être générée. Vous pourrez la relancer dans quelques minutes.",
      no_credit:
        "Le crédit du service d'IA est épuisé : la génération est suspendue le temps de recharger le compte. Réessayez ensuite.",
      last_error_title: "Dernière génération échouée le {{date}}",
      last_error_retry: "Relancez la génération une fois la cause corrigée.",
      disclaimer_readonly:
        "Cette analyse a été préparée pour vous par votre conseiller Aon. Elle constitue une aide à la décision et ne remplace pas un conseil juridique ou fiscal personnalisé.",
      disclaimer_editable_with_date:
        "Première version générée par intelligence artificielle le {{date}}{{model}}, puis relue et ajustée par l'équipe Aon. Aide à la décision : ne remplace pas un conseil juridique ou fiscal personnalisé.",
      disclaimer_editable_no_date:
        "Première version générée par intelligence artificielle{{model}}, puis relue et ajustée par l'équipe Aon. Aide à la décision : ne remplace pas un conseil juridique ou fiscal personnalisé.",
      loading_title: "Noa étudie votre dossier… cela peut prendre quelques minutes.",
      background_hint:
        "Vous pouvez quitter cette page : l'analyse continue et s'affichera à votre retour.",
      did_you_know: "Le saviez-vous ?",
      steps: [
        "Reconstitution de votre carrière et de vos droits",
        "Vérification des paramètres légaux en vigueur",
        "Analyse de vos différents scénarios de départ",
        "Identification des leviers d'optimisation",
        "Rédaction de votre conclusion personnalisée",
      ],
      facts: [
        "Le taux plein s'obtient soit en réunissant la durée d'assurance requise pour votre génération, soit en atteignant l'âge du taux plein automatique.",
        "Chaque trimestre manquant entraîne une décote ; à l'inverse, travailler au-delà du taux plein ouvre droit à une surcote.",
        "La retraite complémentaire Agirc-Arrco fonctionne en points, convertis en pension via la valeur de service du point.",
        "La pension de base du régime général est calculée sur la moyenne de vos 25 meilleures années de salaire, ramenée à 24 ou 23 années pour certains parents depuis la loi de financement de la sécurité sociale pour 2026.",
        "Le dispositif « carrière longue » peut permettre un départ avant l'âge légal, sous conditions de début d'activité.",
        "Le coefficient de solidarité (malus temporaire) de l'Agirc-Arrco a été supprimé pour les retraites prenant effet depuis le 1er décembre 2023.",
      ],
    },
    documents: {
      title: "Mes documents",
      subtitle:
        "Téléversez les pièces nécessaires à la production de votre Bilan Retraite Individuel.",
      kind_ris: "Relevé de carrière (RIS)",
      kind_agirc_arrco: "Relevé Agirc-Arrco",
      kind_bulletin: "Bulletin de salaire (décembre N-1)",
      kind_other: "Autre justificatif",
      uploaded_at: "Téléversé le",
      validated: "Validé",
      pending_validation: "En attente de validation",
      rejected: "Refusé",
      add: "Téléverser un document",
      drop_here: "Glissez votre fichier ici ou cliquez pour parcourir.",
      empty: "Aucun document téléversé pour le moment.",
      extracted_periods_one: "{{count}} période importée depuis le RIS (onglet Carrière).",
      extracted_periods_other: "{{count}} périodes importées depuis le RIS (onglet Carrière).",
      extract_failed: "Échec de l'analyse du RIS.",
      download: "Télécharger",
      download_aria: "Télécharger {{name}}",
      download_error: "Impossible de télécharger la pièce. Réessayez dans un instant.",
    },
    messages: {
      kicker: "Mon espace",
      title: "Messages",
      subtitle: "Votre canal direct avec l'équipe Aon en charge de votre dossier.",
      new_message: "Nouveau message",
      no_messages: "Aucun message pour le moment.",
      send: "Envoyer",
      type_message: "Écrire un message…",
      attachment: "Pièce jointe",
      attachments: "Pièces jointes",
      no_dossier_title: "La messagerie sera disponible bientôt",
      no_dossier_body:
        "Dès qu'un dossier sera créé pour vous, vous pourrez échanger avec votre consultant Aon depuis cet espace.",
      no_consultant_title: "Pas de consultant assigné pour le moment",
      no_consultant_body:
        "Vous pourrez démarrer une conversation dès qu'un consultant Aon vous sera attribué.",
      start_title: "Démarrer une conversation",
      start_body: "Posez votre première question à votre consultant Aon.",
      start_button: "Démarrer la discussion",
      unknown_error: "Erreur inconnue",
      aon_team: "Équipe Aon Retraite",
      role_chef_projet: "Chef de projet Aon",
      role_consultant: "Consultant Aon",
      // Espace Aon + fil de discussion partagé
      aon_kicker: "Pilotage Aon",
      aon_subtitle: "Vos conversations avec les salariés et chefs de projet.",
      new_conversation: "Nouvelle conversation",
      tab_active: "Actifs",
      tab_archived: "Archivés",
      no_archived: "Aucune conversation archivée",
      no_conversation: "Aucune conversation",
      empty_hint: "Les threads démarrés depuis un dossier apparaîtront ici.",
      back_to_list: "Conversations",
      select_conversation: "Sélectionnez une conversation",
      dialog_title: "Nouvelle conversation",
      dialog_description:
        "Sélectionnez un salarié de votre périmètre pour démarrer (ou rouvrir) un échange.",
      search_employee_placeholder: "Rechercher un salarié (nom, prénom, email, matricule)…",
      error_create_dossier: "Impossible de créer le dossier du salarié.",
      no_employee_found: "Aucun salarié trouvé",
      no_employee: "Aucun salarié",
      no_employee_scope: "Aucun salarié n'est rattaché à votre périmètre.",
      no_name: "(sans nom)",
      opening: "Ouverture…",
      no_subject: "(sans sujet)",
      participants_count_one: "{{count}} participant",
      participants_count_other: "{{count}} participants",
      channel_salarie_production: "Salarié ↔ Production",
      channel_drh_chefprojet: "DRH ↔ Chef projet",
      open_dossier_title: "Ouvrir le dossier lié",
      dossier: "Dossier",
      archive: "Archiver",
      restore: "Désarchiver",
      no_one: "(personne)",
      relative_min: "il y a {{count}} min",
      relative_hour: "il y a {{count}} h",
      relative_day: "il y a {{count}} j",
      drop_files: "Déposez vos fichiers ici",
      no_messages_title: "Aucun message",
      no_messages_body: "Lancez la discussion en envoyant un premier message ci-dessous.",
      remove_file: "Retirer",
      attach_file: "Joindre un fichier",
      archived_conversation: "Conversation archivée",
      send_shortcut: "Envoyer (Ctrl/Cmd+Entrée)",
      enter_key: "Entrée",
      drop_hint: "pour envoyer · glissez vos fichiers dans la conversation",
      deleted_message: "Message supprimé",
      delete_message: "Supprimer le message",
      seen: "Vu",
      mark_unread: "Marquer comme non lu",
      size_b: "{{value}} o",
      size_kb: "{{value}} Ko",
      size_mb: "{{value}} Mo",
      send_failed: "Échec de l'envoi",
      file_too_big: "Le fichier « {{name}} » dépasse 25 Mo.",
      max_files: "Maximum {{count}} fichiers par message.",
    },
    bri_lock: {
      title: "Votre Bilan Retraite est prêt",
      version: "Version {{version}}",
      finalized_on: "finalisé le {{date}}",
      body: "Votre consultant Aon a finalisé votre Bilan Retraite Individuel. Il vous le présentera et le commentera lors d'un entretien de restitution : choisissez la date qui vous convient dans son agenda.",
      next_rdv_title: "Rendez-vous confirmé.",
      next_rdv_body: "Votre restitution est prévue le {{date}}.",
      manage_rdv: "Gérer mon rendez-vous",
      choose_date: "Choisir une date de rendez-vous",
      unlock_note:
        "Le document sera téléchargeable ici à l'issue de votre entretien de restitution.",
      parcours_body:
        "Votre document est finalisé et vous sera remis lors de votre entretien de restitution avec votre consultant Aon. Il sera téléchargeable ici juste après.",
      appetences_title: "Indiquez vos souhaits pour accéder à votre BRI",
      appetences_body:
        "Votre Bilan Retraite est prêt. Pour y accéder, indiquez d'abord vos souhaits de départ dans l'étape « Mes résultats », même si aucun ne vous convient : il suffit de valider.",
      appetences_cta: "Indiquer mes souhaits",
    },
    rdv: {
      kicker: "Mon espace",
      title: "Mes rendez-vous",
      subtitle: "Rendez-vous de restitution de votre Bilan Retraite.",
      book: "Réserver un créneau",
      book_short: "Réserver",
      no_rdv: "Aucun rendez-vous planifié.",
      upcoming: "À venir",
      past: "Passés",
      cancel_rdv: "Annuler le rendez-vous",
      confirm_cancel: "Êtes-vous sûr de vouloir annuler ce rendez-vous ?",
      no_consultant_title: "Aucun consultant assigné pour le moment.",
      no_consultant_body:
        "Vous pourrez prendre rendez-vous dès qu'un consultant Aon vous sera attribué.",
      disabled_title: "Votre parcours est 100% autonome",
      disabled_body:
        "Il ne prévoit pas de rendez-vous. Posez vos questions à l'assistant Noa ou écrivez à l'équipe depuis la messagerie : vous obtiendrez une réponse écrite.",
      upcoming_title: "Prochains rendez-vous",
      upcoming_empty: "Aucun rendez-vous programmé",
      upcoming_empty_can_book: "Réservez un créneau dans l'agenda de votre consultant.",
      upcoming_empty_cannot_book: "Aucun rendez-vous prévu pour le moment.",
      history_title: "Historique",
      history_count: "{{count}} RDV passés ou annulés.",
      join_meeting: "Rejoindre la réunion",
      with: "avec {{name}}",
      cancel: "Annuler",
      cancel_dialog_title: "Annuler ce rendez-vous",
      cancel_dialog_desc: "RDV du {{date}}.",
      cancel_dialog_confirm: "Annuler le RDV",
      cancel_dialog_body: "Vous pourrez prendre un nouveau rendez-vous à tout moment.",
      status_propose: "Proposé",
      status_planifie: "Planifié",
      status_realise: "Réalisé",
      status_annule: "Annulé",
      status_no_show: "Absent",
      channel_visio: "Visio",
      channel_phone: "Téléphone",
      channel_presentiel: "Présentiel",
      book_dialog: {
        title: "Réserver un rendez-vous",
        desc_with: "Avec votre consultant {{name}}",
        desc_default: "Choisissez un créneau dans l'agenda de votre consultant",
        cancel: "Annuler",
        confirm: "Confirmer ce créneau",
        error_unknown: "Erreur inconnue.",
        empty_title: "Aucun créneau disponible",
        empty_desc:
          "Votre consultant n'a pas encore ouvert de créneaux. Réessayez plus tard ou contactez-le.",
        slots_label: "Créneaux disponibles",
        notes_label: "Un message pour votre consultant ?",
        notes_hint: "Optionnel : précisez vos questions ou attentes pour ce RDV.",
        notes_placeholder: "Ex. j'aimerais qu'on parle de la retraite progressive…",
        summary_prefix: "Vous allez réserver :",
        duration_note:
          "La durée de rendez-vous prévue pour votre opération est de {{minutes}} minutes.",
        channel_teams: "Visio Teams",
        channel_phone: "Téléphone",
        channel_presentiel: "Présentiel",
      },
    },
    aon: {
      appointments: {
        form: {
          title: "Programmer un rendez-vous",
          desc_with: "Avec {{name}}",
          mode_slot: "Sur un créneau",
          mode_custom: "Date personnalisée",
          slot_label: "Choisissez un créneau",
          no_slot:
            'Aucun créneau ouvert. Ouvrez d\'abord des créneaux depuis votre agenda, ou basculez sur "Date personnalisée".',
          date_label: "Date",
          start_label: "Heure début",
          end_label: "Heure fin",
          modality_label: "Modalité",
          channel_teams: "Visio (Teams)",
          channel_phone: "Téléphone",
          channel_presentiel: "Présentiel",
          url_label: "Lien Teams / visio",
          url_hint: "Optionnel — peut être ajouté plus tard",
          url_placeholder: "https://teams.microsoft.com/...",
          phone_label: "Numéro de téléphone",
          phone_hint: "Sera affiché au salarié",
          phone_placeholder: "+33 6 12 34 56 78",
          notes_label: "Notes internes (consultant)",
          notes_hint: "Non visibles par le salarié",
          notes_placeholder: "Ex. prévoir la maquette PDF, demander confirmation Excel…",
          cancel: "Annuler",
          submit: "Programmer le RDV",
          error_select_slot_or_date: "Sélectionnez un créneau ou saisissez une date.",
          error_unknown: "Erreur inconnue.",
        },
      },
    },
    library: {
      kicker: "Ressources retraite",
      title: "Ma bibliothèque",
      subtitle:
        "Fiches, vidéos et articles pour comprendre votre retraite et préparer sereinement votre départ.",
      empty: "Aucune ressource",
      empty_search: "Aucun contenu ne correspond à votre recherche.",
      empty_none: "Aucune ressource n'est disponible pour le moment.",
      search_placeholder: "Rechercher une fiche, un thème, un mot-clé…",
      category_all: "Tout",
      category_comprendre: "Mieux comprendre ma retraite",
      category_dispositifs: "Dispositifs & optimisation",
      category_demarches: "Démarches",
      category_fiscalite: "Fiscalité",
      category_outils: "Outils & simulateurs",
      category_pilotage: "Pilotage RH",
      category_methode: "Méthode & production",
      kind_article: "Article",
      kind_video: "Vidéo",
      kind_document: "Document",
      kind_link: "Lien",
      kind_pdf: "Document",
      audience_salarie: "Salarié",
      audience_drh: "DRH",
      audience_aon: "Aon",
      featured: "À la une",
      min_suffix: "min",
      viewer_download: "Télécharger",
      viewer_download_ext: "Télécharger ({{ext}})",
      viewer_download_fallback: "le document",
      viewer_open_link: "Ouvrir la ressource",
      viewer_attachment: "Pièce jointe",
      viewer_unavailable_video: "Vidéo indisponible",
      viewer_unavailable_document: "Document indisponible",
      viewer_unavailable_preview: "Aperçu indisponible. Téléchargez le document ci-dessous.",
      viewer_unavailable_link: "Lien indisponible",
    },
    formations_employee: {
      kicker: "Mon espace",
      title: "Formations retraite",
      subtitle: "Consultez les sessions de formation disponibles et inscrivez-vous directement.",
      no_formations: "Aucune formation disponible",
      no_formations_desc:
        "Les sessions de formation retraite organisées pour votre entreprise apparaîtront ici.",
      register: "S'inscrire",
      unregister: "Se désinscrire",
      registered: "Inscrit",
      period_upcoming: "À venir",
      period_all: "Toutes",
      period_past: "Passées",
      stat_sessions: "Sessions",
      stat_upcoming: "À venir",
      stat_enrolled: "Mes inscriptions",
      filter_empty: "Aucune session pour ce filtre",
      filter_empty_desc: "Changez de période pour afficher davantage de sessions.",
      badge_past: "Passée",
      badge_full: "Complet",
      participants: "{{count}} inscrit(s)",
      unenroll_title: "Se désinscrire de cette formation ?",
      unenroll_desc: "Vous ne serez plus inscrit à la session « {{title}} » du {{date}}.",
      unenroll_confirm: "Me désinscrire",
    },
    formations: {
      channel_presentiel: "Présentiel",
      channel_visio: "Visio",
      channel_mixte: "Mixte",
      form: {
        title_edit: "Modifier la session",
        title_create: "Nouvelle session de formation",
        description: "Planifiez une session de formation retraite rattachée à une opération.",
        title_label: "Titre",
        title_placeholder: "Atelier retraite — départ anticipé",
        operation_label: "Opération",
        operation_placeholder: "Sélectionner une opération",
        starts_label: "Début",
        ends_label: "Fin",
        channel_label: "Canal",
        channel_placeholder: "Non précisé",
        capacity_label: "Capacité max",
        capacity_placeholder: "Illimitée",
        location_label: "Lieu",
        location_placeholder: "Salle, ville, ou lien de connexion",
        description_label: "Description",
        description_placeholder: "Programme, objectifs, intervenant…",
        cancel: "Annuler",
        save: "Enregistrer",
        create: "Créer la session",
        error_title_required: "Le titre est obligatoire.",
        error_operation_required: "Sélectionnez une opération.",
        error_start_required: "La date de début est obligatoire.",
        error_start_invalid: "Date de début invalide.",
        error_end_after_start: "La date de fin doit être postérieure à la date de début.",
        error_capacity_invalid: "La capacité doit être un entier positif.",
        error_unknown: "Une erreur est survenue.",
      },
      manage: {
        title: "Formations",
        kicker_aon: "Espace AON · Production",
        kicker_admin: "Espace Admin · Aon",
        description:
          "Planifiez les sessions de formation retraite, gérez les inscriptions et l'émargement des participants.",
        new_session: "Nouvelle session",
        empty_title: "Aucune session de formation",
        empty_desc:
          "Créez votre première session de formation retraite pour commencer à gérer les inscriptions.",
        stats_sessions: "Sessions",
        stats_upcoming: "À venir",
        stats_inscriptions: "Inscriptions",
        filter_all: "Toutes les sessions",
        filter_upcoming: "À venir",
        filter_past: "Passées",
        empty_filter_title: "Aucune session pour ce filtre",
        empty_filter_desc: "Changez de période pour afficher davantage de sessions.",
        badge_upcoming: "À venir",
        badge_past: "Passée",
        participants: "Participants",
        present_label: "{{rate}} % présents",
        edit_title: "Modifier",
        delete_title: "Supprimer",
        delete_title_dialog: "Supprimer cette session ?",
        delete_desc:
          "La session « {{title}} » et ses {{count}} inscription(s) seront définitivement supprimées.",
        delete_confirm: "Supprimer",
      },
      participants: {
        description: "{{count}} inscrit(s) · {{presents}} présent(s)",
        close_add: "Fermer l'ajout",
        add_one: "Ajouter un participant",
        done: "Terminé",
        loading: "Chargement…",
        empty_title: "Aucun participant inscrit",
        empty_desc: "Ajoutez des salariés à cette session pour gérer les présences.",
        no_match: "Aucun inscrit ne correspond à « {{term}} ».",
        range_label: "{{start}}–{{end}} sur {{total}} inscrit(s)",
        range_filtered_suffix: " (filtré sur {{filtered}})",
        previous_page: "Page précédente",
        next_page: "Page suivante",
        present: "Présent",
        absent: "Absent",
        remove_title: "Retirer de la session",
        bulk_title: "Inscrire toute l'opération",
        bulk_available: "{{count}} membre(s) non inscrit(s)",
        bulk_all_enrolled: "Tous les membres de l'opération sont déjà inscrits.",
        bulk_enroll_all: "Tout inscrire",
        bulk_cancel: "Annuler",
        bulk_confirm: "Confirmer ({{count}})",
        bulk_success: "{{count}} salarié(s) inscrit(s) avec succès.",
        bulk_none: "Aucun nouveau salarié à inscrire.",
        add_search_placeholder: "Rechercher un salarié (nom, prénom, matricule…)",
        list_search_placeholder: "Rechercher un inscrit (nom, prénom, matricule, email…)",
        no_available: "Aucun salarié disponible pour cette opération.",
        no_search_result: "Aucun résultat pour cette recherche.",
        add_button: "Ajouter",
        unnamed_salarie: "Salarié sans nom",
        matricule_prefix: "Mat. {{matricule}}",
        unnamed_fallback: "Salarié",
      },
    },
    historique: {
      kicker: "Mon espace",
      title: "Historique de mes calculs",
      subtitle:
        "Retrouvez tous vos calculs retraite, du plus récent au plus ancien. Cliquez sur un calcul pour revoir son estimation et le détail par scénario.",
      empty_title: "Aucun calcul pour le moment",
      empty_desc:
        "Dès que vous lancerez une estimation ou une simulation, chaque calcul sera archivé ici avec ses résultats. Vous pourrez ainsi revenir sur n'importe quel calcul passé.",
      base_estimate: "Estimation de base",
      calculated_on: "Calculé le {{date}}",
      badge_simulation: "Simulation",
      badge_parcours: "Parcours",
      badge_carriere_longue: "Carrière longue",
      no_result: "Aucun résultat enregistré pour ce calcul.",
    },
    parcours: {
      evaluation_banner: "Donnez votre avis sur la prestation",
      tranchec: {
        kicker: "Arbitrage Tranche C",
        title: "Vos cotisations Tranche C valent-elles le coup ?",
        lead: "Nous avons comparé ce que vos cotisations sur la Tranche C vous coûtent à la rente qu'elles vous rapporteront, puis mis ce résultat en regard d'un rachat de trimestres.",
        years: "{{value}} ans",
        roi_caption: "de rente pour amortir vos cotisations",
        ratio_caption: " de rente perçue par euro cotisé",
        verdict_favorable: "Arbitrage favorable",
        verdict_neutre: "Arbitrage équilibré",
        verdict_defavorable: "Arbitrage défavorable",
        verdict_inconnu: "Arbitrage à compléter",
        tile_cout: "Coût total des cotisations",
        tile_cout_hint: "sur {{years}} années de cotisation",
        tile_rente: "Rente annuelle générée",
        tile_rente_hint: "soit {{amount}} par mois",
        tile_esperance: "Durée de perception retenue",
        tile_age: "Âge de départ retenu",
        age_value: "{{age}} ans",
        compare_title: "Tranche C ou rachat de trimestres ?",
        compare_desc:
          "Plus la barre est courte, plus le levier est rentable : c'est le temps nécessaire pour récupérer ce que vous avez versé.",
        compare_tranchec: "Cotisations Tranche C",
        compare_rachat: "Rachat de trimestres",
        compare_rachat_empty:
          "Aucun rachat n'a été chiffré pour votre situation. Parlez-en à votre conseiller si vous souhaitez l'étudier.",
        advisor_note: "Commentaire de votre conseiller",
        note: "Estimation établie à partir des paramètres retenus par votre conseiller. Elle constitue une aide à la décision et ne vaut pas conseil en investissement.",
        note_with_point:
          "Estimation établie avec une valeur de service du point de {{value}} € et les paramètres retenus par votre conseiller. Aide à la décision : elle ne vaut pas conseil en investissement.",
      },
      not_ready_title: "Votre dossier n'est pas encore prêt",
      not_ready_body:
        "Votre espace retraite sera disponible dès que votre dossier aura été créé par votre entreprise.",
      gate: {
        kicker: "Mon espace",
        title: "Mon parcours retraite",
        subtitle:
          "Votre bilan retraite se prépare en trois étapes : la formation d'abord, votre parcours personnalisé ensuite.",
        step1_title: "Je m'inscris à une formation",
        step1_desc: "Choisissez une session de formation retraite organisée pour votre entreprise.",
        step2_title: "Je participe à la formation",
        step2_desc: "Votre présence est confirmée par l'organisateur à l'issue de la session.",
        step3_title: "J'accède à mon parcours retraite",
        step3_desc:
          "Votre parcours personnalisé se débloque : informations, documents, simulations.",
        step_label: "Étape {{index}}",
        badge_done: "Fait",
        badge_active: "En cours",
        sessions_title: "Sessions disponibles — inscrivez-vous pour démarrer",
        no_sessions:
          "Aucune session n'est planifiée pour le moment. Votre entreprise organisera prochainement des sessions de formation retraite : vous pourrez alors vous inscrire ici et débloquer votre parcours.",
        see_all: "Voir toutes les formations",
        enrolled_title: "Vous êtes inscrit — plus qu'à participer !",
        enrolled_session:
          "Session « {{title}} » le {{date}} à {{time}}{{place}}. Votre parcours retraite se débloquera automatiquement dès que votre présence aura été confirmée par l'organisateur.",
        enrolled_no_session:
          "Votre parcours retraite se débloquera automatiquement dès que votre présence à la formation aura été confirmée par l'organisateur.",
        my_formations: "Mes formations",
        rule: "L'accès au parcours retraite est réservé aux salariés ayant participé à une formation retraite. Cette étape garantit que vous disposez de toutes les clés pour tirer le meilleur de votre bilan.",
        participants: "{{count}} inscrit(s)",
        register: "S'inscrire",
      },
      layout: {
        step_of: "Étape {{current}} sur {{total}}",
        restart: "Recommencer",
        restart_title: "Période de test : recommencer le parcours depuis le début",
        progress_label: "Progression : étape {{current}} sur {{total}}",
        help_toggle: "Besoin d'aide pour comprendre ?",
        recap_default: "Ce que nous avons retenu",
        back: "Retour",
        continue: "Continuer",
      },
      runner: {
        step_bienvenue_label: "Bienvenue",
        step_bienvenue_title: "Bienvenue dans votre parcours retraite",
        step_confidentialite_label: "Confidentialité",
        step_confidentialite_title: "Le choix sur la confidentialité de vos données",
        step_confidentialite_lead:
          "Choisissez ce que vous souhaitez partager avec votre entreprise.",
        step_confidentialite_help:
          "L'équipe Aon a toujours accès à vos données pour réaliser votre bilan. Ces cases concernent uniquement ce que votre employeur peut voir. Certaines peuvent être imposées par votre entreprise.",
        step_informations_label: "Mes infos",
        step_informations_title: "Mes informations",
        step_informations_lead: "Vérifions ensemble les informations qui vous concernent.",
        step_informations_help:
          "Votre date de naissance détermine l'âge auquel vous pourrez partir à la retraite. Vérifiez qu'elle est correcte.",
        step_famille_label: "Ma famille",
        step_famille_title: "Ma famille",
        step_famille_lead:
          "Votre conjoint et vos enfants peuvent vous donner des droits supplémentaires.",
        // B2 : les trois explications reprennent mot pour mot les textes de
        // l'arbitrage du 30/09/2026 (aussi affichés en bulles d'aide).
        step_famille_help:
          "Avoir eu des enfants augmente souvent le nombre de trimestres et le montant de la retraite. Indiquez-les pour une estimation plus juste.\n\nEnfant handicapé\nSi vous avez élevé un enfant ouvrant droit à l'allocation d'éducation de l'enfant handicapé (AEEH), vous pouvez bénéficier d'une majoration de durée d'assurance d'un trimestre par période de 30 mois d'éducation, dans la limite de 8 trimestres par enfant. Cette majoration n'est pas intégrée automatiquement à votre estimation : votre caisse l'examine sur justificatifs lors de votre demande de retraite.\n\nEnfant né sans vie\nUn enfant né sans vie peut, selon les cas, ouvrir des droits au titre de la maternité. Ils ne sont pas intégrés automatiquement à votre estimation : rapprochez-vous de votre caisse de retraite, qui les examine sur justificatifs.\n\nPartage des trimestres\nPour un enfant né ou adopté depuis 2010, les 4 trimestres accordés au titre de son éducation peuvent être répartis entre les parents. Sans choix exprimé dans les 6 mois qui suivent son 4e anniversaire, ils sont attribués à la mère.",
        step_documents_label: "Mes documents",
        step_documents_title: "Mon relevé de carrière",
        step_documents_lead:
          "Déposez votre relevé de carrière : nous lisons votre parcours automatiquement.",
        step_documents_help:
          "Le « relevé de carrière » (ou RIS) est un document envoyé par l'Assurance retraite. Il liste tous vos emplois. Vous pouvez le télécharger sur le site info-retraite.fr.",
        step_carriere_label: "Ma carrière",
        step_carriere_title: "Ma carrière",
        step_carriere_lead: "Voici ce que nous avons compris de votre parcours professionnel.",
        step_carriere_help:
          "Chaque ligne correspond à une période où vous avez travaillé. Si une période vous semble manquante, votre conseiller pourra la corriger avec vous.",
        step_carriere_help_self:
          "Chaque ligne correspond à une période où vous avez travaillé. Si une période vous semble manquante ou inexacte, corrigez-la directement : votre estimation en tiendra compte.",
        step_situation_label: "Ma situation",
        step_situation_title: "Ma situation particulière",
        step_situation_lead:
          "Certaines situations donnent droit à un départ plus tôt ou à un complément.",
        step_situation_help:
          "Par exemple : un travail pénible, un handicap, ou avoir commencé à travailler très jeune. Cochez ce qui vous concerne, sans crainte.",
        step_vip_label: "Mes projets",
        step_vip_title: "Mes projets d'après",
        step_vip_lead:
          "Ce que vous envisagez après votre départ change l'analyse de vos scénarios.",
        step_vip_help:
          "Créer une activité de conseil, poursuivre en cumul emploi-retraite ou passer par une période de chômage n'a pas le même effet sur votre pension. Répondez librement : rien n'est engageant.",
        step_chomage_label: "Mon chômage",
        step_chomage_title: "Ma période de chômage",
        step_chomage_lead:
          "Une période sans emploi avant votre départ modifie le calcul de vos droits.",
        step_chomage_help:
          "Les périodes de chômage indemnisé peuvent valider des trimestres, sans cotisation de votre part. Indiquez les dates que vous envisagez, même approximatives : elles seront prises en compte dans vos calculs.",
        step_supplementaire_label: "Mon épargne",
        step_supplementaire_title: "Ma retraite supplémentaire",
        step_supplementaire_lead:
          "Renseignez vos dispositifs d'épargne retraite (PER, plan d'épargne, dispositifs d'entreprise…).",
        step_supplementaire_help:
          "Ces produits ne figurent pas sur votre relevé de carrière : ils ne sont pas connus de l'Assurance retraite. En les indiquant, ils apparaîtront dans la section « Régime supplémentaire » de votre bilan.",
        step_supplementaire_epargne_title: "Retrouver vos contrats d'épargne retraite",
        step_supplementaire_epargne_loi:
          "La loi n° 2021-219 du 26 février 2021 relative à la déshérence des contrats de retraite supplémentaire renforce l'information des épargnants : les contrats d'épargne retraite (PER, contrats « article 83 », PERCO, contrats Madelin…) peuvent être consultés dans votre compte retraite en ligne, sur info-retraite.fr.",
        step_supplementaire_epargne_justif:
          "Justificatifs à déposer : pour chaque contrat, le dernier relevé annuel (situation de votre épargne au 31 décembre) ou, à défaut, un courrier de l'organisme gestionnaire indiquant le montant de votre épargne.",
        step_supplementaire_epargne_link_loi: "Consulter la loi sur Légifrance",
        step_supplementaire_epargne_link_inforetraite: "Accéder à info-retraite.fr",
        step_projet_label: "Mon projet",
        step_projet_title: "Mon projet de départ",
        step_projet_lead: "Dites-nous quand vous aimeriez partir et ce que vous voulez comparer.",
        step_projet_help:
          "Vous pouvez comparer plusieurs situations : partir dès que possible, à l'âge légal, etc. Chaque choix donnera une estimation différente.",
        step_resultats_label: "Mes résultats",
        step_resultats_title: "Mon estimation & mes simulations",
        step_resultats_lead:
          "Voici votre estimation de référence. Juste en dessous, créez et comparez autant de simulations que vous voulez.",
        step_resultats_help:
          "Votre estimation de référence ne change que si vous la recalculez. Chaque simulation est indépendante : testez une date de départ précise, un rachat de trimestres… sans jamais modifier votre estimation de référence.",
        tab_estimation: "Mon estimation",
        tab_simulations: "Mes simulations",
        tab_analyse: "Analyse Noa",
        tab_analyse_salarie: "Mon analyse",
        tab_document: "Mon document",
        step_attention_appetences: "Souhaits à valider pour accéder à votre BRI",
        prev: "Précédent",
        next: "Suivant",
        error_required: "Merci de compléter les champs obligatoires avant de continuer.",
        error_save: "Votre progression n'a pas pu être enregistrée : {{error}}",
        reset_ok:
          "Dossier réinitialisé : toutes les données ont été supprimées. Vous pouvez recommencer depuis le début.",
        reset_failed: "La réinitialisation a échoué : {{error}}",
        reset_title: "Tout effacer et recommencer ?",
        reset_desc:
          "Cette action supprime DÉFINITIVEMENT toutes les données de ce dossier : informations, famille, documents, carrière, scénarios et résultats. Le parcours repart de zéro.",
        reset_confirm: "Tout effacer",
        reset_cancel: "Annuler",
      },
      steps: {
        bienvenue_hello: "Bonjour {{name}} 👋",
        bienvenue_intro:
          "Ce parcours vous accompagne, étape par étape, pour estimer votre future retraite. Tout est simple : vous avancez à votre rythme, et vous pouvez vous arrêter puis reprendre quand vous voulez.",
        bienvenue_prepare: "Pour bien commencer, préparez si possible :",
        bienvenue_prepare_ris:
          "Votre relevé de carrière (le « RIS ») au format PDF, si vous l'avez.",
        bienvenue_prepare_family: "Les dates de naissance de votre conjoint et de vos enfants.",
        bienvenue_outro_1:
          "Pas d'inquiétude si vous n'avez pas tout : vous pourrez compléter plus tard. Cliquez sur",
        bienvenue_outro_continue: " « Continuer »",
        bienvenue_outro_2: " pour démarrer.",
        infos_title: "Vérifions votre identité",
        infos_desc:
          "Ces informations servent à calculer votre retraite. Vérifiez-les et corrigez si besoin. Elles sont enregistrées automatiquement à chaque étape et synchronisées avec votre profil ; ce sont ces données qui font foi pour vos estimations.",
        infos_civility: "Civilité",
        infos_civility_m: "Monsieur",
        infos_civility_mme: "Madame",
        infos_first_name: "Prénom",
        infos_last_name: "Nom",
        infos_birth_date: "Date de naissance",
        infos_birth_place: "Lieu de naissance",
        infos_postal_code: "Code postal de votre domicile actuel",
        infos_postal_placeholder: "Ex. 75015",
        infos_phone: "Téléphone",
        infos_phone_placeholder: "Ex. 06 12 34 56 78",
        infos_email: "Email",
        infos_email_placeholder: "prenom.nom@entreprise.com",
        infos_min_warning: "Merci de renseigner au moins votre prénom, nom et date de naissance.",
        err_first_name_required: "Prénom obligatoire.",
        err_last_name_required: "Nom obligatoire.",
        err_birth_required: "Date de naissance obligatoire.",
        err_postal: "Code postal à 5 chiffres (ex. 75015).",
        famille_conjoint_title: "Votre conjoint",
        famille_conjoint_desc: "Vivez-vous en couple ? Cela peut influencer vos droits.",
        famille_has_conjoint: "J'ai un conjoint (marié, pacsé ou en concubinage)",
        famille_union_type: "Type d'union",
        famille_union_epoux: "Marié(e)",
        famille_union_pacse: "Pacsé(e)",
        famille_union_concubin: "Concubinage / union libre",
        famille_conjoint_dob: "Date de naissance du conjoint",
        famille_enfants_title: "Vos enfants",
        famille_enfants_desc: "Le nombre d'enfants peut augmenter votre retraite (majoration).",
        famille_no_enfant: "Vous n'avez pas encore ajouté d'enfant.",
        famille_add_enfant: "Ajouter un enfant",
        famille_enfant_dob: "Enfant {{index}} — date de naissance",
        // B2 (30/09/2026) : information seulement, aucun effet sur le calcul.
        famille_enfant_handicap: "Enfant handicapé",
        famille_enfant_mort_ne: "Enfant né sans vie",
        famille_partage_label: "Partage des trimestres",
        famille_help_handicap:
          "Si vous avez élevé un enfant ouvrant droit à l'allocation d'éducation de l'enfant handicapé (AEEH), vous pouvez bénéficier d'une majoration de durée d'assurance d'un trimestre par période de 30 mois d'éducation, dans la limite de 8 trimestres par enfant. Cette majoration n'est pas intégrée automatiquement à votre estimation : votre caisse l'examine sur justificatifs lors de votre demande de retraite.",
        famille_help_mort_ne:
          "Un enfant né sans vie peut, selon les cas, ouvrir des droits au titre de la maternité. Ils ne sont pas intégrés automatiquement à votre estimation : rapprochez-vous de votre caisse de retraite, qui les examine sur justificatifs.",
        famille_help_partage:
          "Pour un enfant né ou adopté depuis 2010, les 4 trimestres accordés au titre de son éducation peuvent être répartis entre les parents. Sans choix exprimé dans les 6 mois qui suivent son 4e anniversaire, ils sont attribués à la mère.",
        famille_recap_couple: "Vous vivez en couple. ",
        famille_recap_single: "Vous vivez seul(e). ",
        famille_recap_children_one: "Vous avez déclaré {{count}} enfant.",
        famille_recap_children_many: "Vous avez déclaré {{count}} enfants.",
        docs_ris_title: "Votre relevé de carrière",
        docs_ris_desc:
          "Déposez votre relevé de carrière (RIS) au format PDF. Nous lisons automatiquement votre parcours professionnel.",
        docs_ris_choose: "Cliquez pour choisir votre fichier PDF",
        docs_ris_drop: "ou glissez-le ici — un seul relevé à la fois (PDF, {{size}} Mo max)",
        docs_analyzing: "Analyse de votre relevé en cours...",
        docs_sending: "Envoi en cours...",
        docs_analyzing_hint:
          'Cette opération peut prendre jusqu\'à une minute. Le bouton "Continuer" sera débloqué automatiquement.',
        docs_analyzing_wait: "Analyse du relevé en cours... Veuillez patienter avant de continuer.",
        docs_analyzed: "Relevé analysé : {{count}} périodes de carrière identifiées.",
        docs_default_name: "Document",
        docs_delete_aria: "Supprimer {{name}}",
        docs_delete_this: "ce document",
        docs_delete_title_default: "le document",
        docs_replace_title: "Supprimer pour en déposer un autre",
        docs_delete_impossible: "Suppression impossible : {{error}}",
        docs_others_title: "Vos autres documents",
        docs_others_desc:
          "Ces pièces complètent votre dossier. La liste s'adapte à votre entreprise et à votre situation.",
        docs_missing_one: "Document obligatoire manquant : {{labels}}.",
        docs_missing_many: "Documents obligatoires manquants : {{labels}}.",
        docs_no_extra: "Aucune pièce complémentaire n'est demandée pour votre parcours.",
        docs_howto: {
          toggle: "Où récupérer ce document ?",
          ris: {
            steps: [
              "Connectez-vous sur info-retraite.fr avec FranceConnect (impots.gouv, Ameli ou La Poste).",
              "Ouvrez la rubrique « Ma carrière » puis « Mon relevé de carrière ».",
              "Téléchargez le relevé de situation individuelle (RIS) au format PDF, avec toutes ses pages.",
            ],
            tip: "Un relevé daté de moins de 6 mois donne les résultats les plus fiables. Ne déposez pas de capture d'écran : il nous faut le PDF complet.",
          },
          agirc_arrco: {
            steps: [
              "Connectez-vous à votre espace personnel sur agirc-arrco.fr (ou via FranceConnect).",
              "Dans « Mes points », choisissez « Relevé de points » ou « Mon relevé de carrière complémentaire ».",
              "Téléchargez le relevé au format PDF : il détaille vos points année par année.",
            ],
            tip: "Si vous n'avez jamais créé d'espace, l'inscription se fait en ligne avec votre numéro de sécurité sociale.",
          },
          bulletin_salaire: {
            steps: [
              "Récupérez votre bulletin de salaire du mois de décembre de l'année dernière.",
              "Il se trouve généralement dans votre coffre-fort numérique (ex. Digiposte, MyPeopleDoc) ou sur l'intranet RH.",
              "À défaut, demandez-le à votre service paie : c'est la version PDF ou un scan lisible qui est attendu.",
            ],
          },
          retraite_supp: {
            steps: [
              "Retrouvez les relevés annuels de vos contrats de retraite supplémentaire (PER, article 83, article 39, PERCO…).",
              "Ils sont envoyés chaque année par l'assureur ou le gestionnaire (courrier ou espace en ligne).",
              "Déposez un relevé par contrat ; le relevé le plus récent suffit.",
            ],
            tip: "Le service « Mes contrats d'épargne retraite » d'info-retraite.fr recense les contrats connus à votre nom.",
          },
          justificatif_penibilite: {
            steps: [
              "Connectez-vous sur compteprofessionnelprevention.fr pour consulter votre compte C2P.",
              "Téléchargez le relevé de points de pénibilité ou l'attestation d'exposition remise par votre employeur.",
            ],
          },
          justificatif_handicap: {
            steps: [
              "Réunissez la notification de RQTH délivrée par la MDPH ou la notification de pension d'invalidité de la CPAM.",
              "Déposez le document indiquant la date de début et, le cas échéant, le taux d'incapacité.",
            ],
          },
          justificatif_carriere: {
            steps: [
              "Pour une période à l'étranger : relevé ou attestation de la caisse de retraite du pays concerné.",
              "Pour le service militaire : état signalétique et des services, à demander au Centre des archives du personnel militaire.",
              "Pour toute autre période : certificats de travail, contrats ou attestations de l'employeur.",
            ],
          },
        },
        docs_required: "Obligatoire",
        docs_optional: "Optionnel",
        docs_add: "Ajouter",
        docs_replace: "Remplacer",
        docs_deposit: "Déposer",
        docs_delete_doc_title: "Supprimer ce document ?",
        docs_delete_doc_desc:
          "Le fichier {{name}} sera définitivement supprimé. Cette action est irréversible.",
        docs_delete: "Supprimer",
        docs_cancel: "Annuler",
        docs_error: "Erreur : {{error}}",
        carriere_title: "Votre carrière reconstituée",
        carriere_desc:
          "Voici les périodes de travail que nous avons comprises à partir de votre relevé. Vérifiez qu'elles vous semblent correctes.",
        carriere_empty_title: "Aucune période pour le moment",
        carriere_empty_desc:
          "Revenez à l'étape précédente pour déposer et analyser votre relevé de carrière.",
        carriere_manual_hint:
          "Une période manque (par exemple un emploi à l'étranger absent de votre relevé) ? Ajoutez-la, modifiez-la ou supprimez-la ici.",
        carriere_manual_empty_desc:
          "Déposez d'abord votre relevé de carrière à l'étape précédente, ou ajoutez vos périodes manuellement (par exemple une période à l'étranger).",
        carriere_period_default: "Période d'activité",
        carriere_verified: "Vérifiée",
        carriere_ongoing: "en cours",
        carriere_convention: "Convention :",
        carriere_revenus: "Revenus :",
        carriere_revenus_ignored: "non utilisé par le calcul, le détail annuel ci-dessous prime",
        carriere_evolution: "évolution",
        carriere_source: "Source : {{source}}",
        situation_title: "Votre situation particulière",
        situation_desc:
          "Cochez ce qui vous concerne. Si rien ne s'applique, passez simplement à la suite.",
        situation_warn_many:
          "Vous avez coché de nombreuses situations. Un conseiller vérifiera leur cohérence et l'impact sur votre estimation.",
        situation_warn_many_self:
          "Vous avez coché de nombreuses situations. Vérifiez qu'elles vous concernent vraiment : elles influencent votre estimation.",
        situation_warn_invalidite:
          "« Invalidité » et « départ anticipé au taux plein » relèvent souvent de dispositifs différents : à confirmer avec votre conseiller.",
        situation_warn_invalidite_self:
          "« Invalidité » et « départ anticipé au taux plein » relèvent souvent de dispositifs différents : votre estimation reste indicative sur ce point.",
        cas_penibilite: "J'ai exercé un travail pénible",
        cas_amiante: "J'ai été exposé(e) à l'amiante",
        cas_rqth: "Je suis reconnu(e) travailleur handicapé",
        cas_invalidite: "Je suis en invalidité",
        cas_arret_long_maladie: "J'ai eu un arrêt maladie de longue durée",
        cas_militaire: "J'ai effectué un service militaire",
        cas_expatriation_sans_cfe: "J'ai travaillé à l'étranger sans cotiser en France",
        cas_poly_pension: "J'ai plusieurs régimes de retraite",
        cas_multi_activite: "J'ai eu plusieurs activités en même temps",
        cas_travail_etudiant: "J'ai travaillé pendant mes études",
        cas_carriere_longue: "J'ai commencé à travailler très jeune",
        cas_taux_plein_anticipe: "Je pense partir au taux plein de façon anticipée",
        cas_cet: "Je dispose d'un compte épargne-temps",
        // Blocs de l'étape « Votre situation particulière » (B1, 30/09/2026).
        situation_block_carriere: "Ma carrière",
        situation_block_carriere_help:
          "Les situations qui ont pu modifier votre durée d'assurance ou ouvrir droit à un départ anticipé.",
        situation_block_sante: "Ma santé",
        situation_block_sante_help:
          "Les situations de santé ou d'exposition qui peuvent ouvrir des trimestres supplémentaires ou un départ anticipé.",
        situation_block_autre: "Autre",
        situation_block_autre_help:
          "Les dispositifs qui peuvent influencer la date effective de votre départ.",
        cet_title: "Votre compte épargne-temps",
        cet_hint:
          "Ces informations aident votre consultant à articuler la fin de carrière (congé de fin de carrière, monétisation) avec la date de départ.",
        cet_jours_label: "Jours épargnés",
        cet_avant_depart_label: "Je souhaite utiliser mon CET avant mon départ",
        cet_avant_depart_hint: "Par exemple sous forme de congé de fin de carrière.",
        militaire_dates_title: "Dates de votre service national",
        militaire_dates_hint:
          "Ces dates sont comparées à celles de votre relevé de carrière pour vérifier qu'elles concordent.",
        militaire_debut: "Début",
        militaire_fin: "Fin",
        militaire_match: "Conforme à votre relevé de carrière.",
        militaire_mismatch:
          "Votre relevé indique la période du {{debut}} au {{fin}}. Un conseiller vérifiera cet écart.",
        militaire_mismatch_self:
          "Votre relevé indique la période du {{debut}} au {{fin}}. Vérifiez vos dates : en cas d'erreur sur le relevé, la correction se demande à l'Assurance retraite.",
        militaire_no_ris:
          "Aucune période militaire n'apparaît dans votre relevé : ces dates permettront de la faire ajouter.",
        vip_title: "Vos projets d'après",
        vip_desc:
          "Ces réponses permettent de comparer vos scénarios de départ et de préparer votre restitution.",
        vip_no_work: "Je ne veux pas travailler à la retraite",
        vip_no_work_hint: "Vous souhaitez cesser toute activité professionnelle.",
        vip_conseil: "J'ai une activité de conseil à monter",
        vip_conseil_hint: "Création d'une structure pour une activité indépendante.",
        vip_ca: "Chiffre d'affaires envisagé (€/an)",
        vip_forme: "Forme juridique",
        vip_forme_sas: "SAS",
        vip_forme_sarl: "SARL",
        vip_remuneration: "Rémunération",
        vip_remu_salaire: "Salaire",
        vip_remu_dividendes: "Dividendes",
        vip_remu_mixte: "Salaire et dividendes",
        vip_undecided: "Pas encore décidé",
        vip_cumul: "Je veux travailler en cumul emploi-retraite",
        vip_cumul_hint: "Poursuivre une activité tout en percevant votre retraite.",
        vip_chomage: "Une période de chômage est prévue avant mon départ",
        vip_chomage_hint: "Par exemple après une rupture conventionnelle.",
        vip_chomage_debut: "Début du chômage",
        vip_chomage_fin: "Fin du chômage",
        vip_comment: "Précisions (facultatif)",
        vip_comment_placeholder: "Tout élément utile à votre conseiller…",
        vip_note:
          "Ces informations sont transmises à votre conseiller Aon, qui les intègre à l'analyse de vos scénarios.",
        projet_when_title: "Quand souhaitez-vous partir ?",
        projet_when_desc: "Indiquez une date de départ envisagée (vous pourrez la changer).",
        projet_date_visee: "Date de départ envisagée (facultatif)",
        projet_date_eval: "Date d'évaluation",
        projet_derive_title: "Revalorisation de votre salaire",
        projet_derive_desc: "Hypothèse de progression annuelle de votre rémunération.",
        projet_derive_label: "Augmentation annuelle estimée de votre salaire (%)",
        projet_derive_hint: "Jusqu'à votre départ. Valeur proposée : {{pct}} %",
        projet_compare_title: "Que voulez-vous comparer ?",
        projet_compare_desc: "Choisissez une ou plusieurs situations à simuler.",
        projet_urgence_title: "Dossier urgent",
        projet_urgence_desc:
          "Une échéance proche ou une situation qui demande une réponse rapide ?",
        projet_urgence_label: "Mon dossier est urgent",
        projet_urgence_reason: "Motif",
        projet_urgence_reason_pick: "Choisissez un motif",
        projet_urgence_reason_required: "Choisissez un motif pour marquer votre dossier urgent.",
        projet_urgence_reason_depart_moins_6_mois: "Mon départ est prévu dans moins de 6 mois",
        projet_urgence_reason_rupture_licenciement: "Une rupture ou un licenciement est en cours",
        projet_urgence_reason_decision_rapide: "Je dois prendre une décision rapidement",
        projet_urgence_reason_autre: "Autre",
        projet_urgence_comment: "Commentaire (facultatif)",
        projet_urgence_comment_ph: "Précisez votre situation à votre conseiller…",
        projet_urgence_privacy:
          "Votre conseiller Aon traitera votre dossier en priorité. Votre DRH voit seulement que votre dossier est prioritaire, jamais le motif ni votre commentaire.",
        projet_urgence_auto: "Marqué prioritaire automatiquement (départ proche)",
        projet_urgence_consultant: "Votre dossier est marqué prioritaire par votre conseiller Aon.",
        resultats_estimation_title: "Votre estimation de retraite",
        resultats_estimation_desc:
          "Lancez le calcul pour découvrir votre estimation, scénario par scénario.",
        resultats_recalc: "Recalculer",
        resultats_calc: "Calculer mon estimation",
        resultats_calc_ok: "Votre estimation a été calculée.",
        resultats_empty: "Aucune estimation pour le moment. Lancez le calcul ci-dessus.",
        result_per_month_gross: "par mois (brut)",
        result_per_month_net: " / mois (net)",
        result_depart: "Départ estimé",
        result_depart_age: "{{age}} ans",
        result_taux: "Taux de remplacement",
        result_trim_valid: "Trimestres validés",
        result_trim_cotises: "Trimestres cotisés",
        result_trim_reputes: "Réputés cotisés",
        result_trim_reputes_hint: "approx.",
        result_trim_missing_age: "Trimestres manquants pour le taux plein",
        result_penalite_tous_regimes: "Pénalité / tous régimes",
        result_decote_appliquee: "Décote appliquée",
        result_penalite_cnav: "Trimestres de décote appliqués au régime de base",
        bubble_trim_missing:
          "Trimestres qu'il vous manque à la date de départ pour obtenir le taux plein.",
        bubble_penalite_cnav:
          "Nombre de trimestres de décote effectivement appliqués au calcul de votre retraite de base.",
        bubble_decote_base:
          "Décote du régime de base : 1,25 % par trimestre manquant, dans la limite de 20 trimestres (25 %), ici {{n}} trimestres, soit {{pct}} %.",
        bubble_decote_base_short:
          "Décote du régime de base : 1,25 % par trimestre manquant, dans la limite de 20 trimestres (25 %).",
        result_taux_cnav: "Taux pension CNAV",
        result_points_agirc: "Points Agirc-Arrco",
        result_show_detail: "Voir le détail",
        result_hide_detail: "Masquer le détail",
        result_estimation: "Estimation",
        result_date_visee: "À la date souhaitée",
        conf_intro_title: "Vos données vous appartiennent",
        conf_intro_body_1:
          "Pour réaliser votre bilan, l'équipe Aon a besoin d'accéder à vos informations. En revanche, ",
        conf_intro_you_decide: "vous décidez",
        conf_intro_body_2: " de ce qui est partagé avec votre ",
        conf_company: "entreprise",
        conf_rule: "Règle fixée par votre entreprise : {{label}}",
        conf_opt_date_title: "Partager la date de mon départ à taux plein",
        conf_opt_date_desc:
          "Mon entreprise pourra connaître la date à laquelle je pourrai partir à taux plein, sans aucun autre détail.",
        conf_opt_full_title: "Partager l'intégralité de mon bilan retraite (BRI)",
        conf_opt_full_desc:
          "Mon entreprise aura accès au support complet de mon bilan retraite (montants, scénarios, etc.).",
        conf_required: "Obligatoire",
        conf_recap_full_1: "Vous partagez ",
        conf_recap_full_strong: "l'intégralité de votre bilan",
        conf_recap_full_2: " avec votre entreprise.",
        conf_recap_date_1: "Vous partagez ",
        conf_recap_date_strong: "uniquement votre date de départ",
        conf_recap_date_2: " avec votre entreprise.",
        conf_recap_none_1: "Vous ne partagez ",
        conf_recap_none_strong: "aucune information",
        conf_recap_none_2: " avec votre entreprise. Seule l'équipe Aon y a accès.",
        supp_intro_title: "Vos dispositifs d'épargne retraite",
        supp_intro_body:
          "Renseignez ici vos produits de retraite supplémentaire (PER, PERCOL, plan d'épargne, dispositifs d'entreprise…) et la rente mensuelle nette estimée. Ces montants n'apparaissent pas sur votre relevé de carrière : ils complètent votre bilan.",
        supp_hint:
          "Laissez le montant vide si vous ne le connaissez pas encore : votre conseiller pourra le compléter. Vous pouvez aussi ajouter ou retirer des lignes selon vos contrats.",
        supp_hint_self:
          "Laissez le montant vide si vous ne le connaissez pas encore : vous pourrez y revenir plus tard. Vous pouvez aussi ajouter ou retirer des lignes selon vos contrats.",
        supp_col_device: "Dispositif",
        supp_col_rente: "Rente nette / mois",
        supp_device_placeholder: "Nom du dispositif",
        supp_per_month: "€/mois",
        supp_remove_aria: "Supprimer cette ligne",
        supp_empty: "Aucun dispositif. Ajoutez-en un si vous avez de l'épargne retraite.",
        supp_add: "Ajouter un dispositif",
        supp_total: "Total estimé",
        supp_footer_1: "Ces dispositifs figureront dans la section ",
        supp_footer_strong: "« Régime supplémentaire »",
        supp_footer_2: " de votre bilan (BRI).",
      },
      simulations: {
        title: "Mes simulations",
        intro:
          "Créez plusieurs simulations pour comparer différentes situations : un départ à une date précise, un rachat de trimestres… Vous pouvez les modifier et les recalculer à tout moment.",
        create: "Créer une simulation",
        empty_title: "Aucune simulation pour le moment",
        empty_desc:
          "Créez votre première simulation pour tester une date de départ ou un rachat de trimestres.",
        comparator_label: "Comparaison des âges de départ",
        comparator_title: "Comparer les âges de départ",
        comparator_desc:
          "Calculez d'un coup vos 6 scénarios de départ (62 ans, dès que possible, âge légal, 65 ans, taux plein, 67 ans) pour voir l'impact sur votre pension.",
        comparator_refresh: "Actualiser la comparaison",
        comparator_run: "Comparer mes départs",
        comparator_hint:
          "Lancez la comparaison pour visualiser, scénario par scénario, votre pension et l'âge de départ correspondant.",
        col_scenario: "Scénario de départ",
        col_depart: "Départ estimé",
        col_brut: "Pension brute / mois",
        col_net: "Pension nette / mois",
        col_vs: "vs estimation",
        col_trim_missing: "Trim. manquants",
        best: "Le + avantageux",
        age_years: "{{age}} ans",
        card_calculated: "Calculée",
        card_to_calculate: "À calculer",
        card_requested_drh: "Demandée par votre RH",
        card_recalc: "Recalculer",
        card_calc: "Calculer",
        card_edit: "Modifier",
        card_delete_aria: "Supprimer la simulation {{label}}",
        card_show_details: "Voir le détail des résultats",
        card_hide_details: "Masquer le détail des résultats",
        card_no_result: "Aucun résultat enregistré. Lancez le calcul ci-dessus.",
        card_no_params:
          "Cette simulation n'a aucun paramètre : le calcul utilisera le départ à taux plein.",
        card_calculated_notice: "La simulation « {{label}} » a été calculée.",
        delete_title: "Supprimer cette simulation ?",
        delete_desc:
          "La simulation « {{label}} » et son historique de résultats seront détachés. Cette action est définitive.",
        delete_confirm: "Supprimer",
        result_per_month_gross: "par mois (brut)",
        result_per_month_net: " / mois (net)",
        result_depart: "Départ estimé",
        result_age: "{{age}} ans",
        result_trim_valid: "Trimestres validés",
        result_trim_missing_age: "Trimestres manquants pour le taux plein",
        result_penalite_tous_regimes: "Pénalité / tous régimes",
        result_decote_appliquee: "Décote appliquée",
        result_penalite_cnav: "Trimestres de décote appliqués au régime de base",
        result_taux_cnav: "Taux pension CNAV",
        result_rachat: "Rachat",
        result_rachat_value: "Pris en compte",
        comp_identical: "Identique à votre estimation",
        comp_delta: "{{sign}}{{amount}} / mois",
        comp_vs_base: "vs estimation de base",
        comp_vs_base_pct: "{{sign}}{{pct}} % vs estimation de base ({{kind}})",
        comp_net: "net",
        bubble_decote_base:
          "Décote du régime de base : 1,25 % par trimestre manquant, dans la limite de 20 trimestres (25 %), ici {{n}} trimestres, soit {{pct}} %.",
        comp_delta_hint:
          "Écart entre cette simulation et votre estimation de référence, en pension nette mensuelle (référence {{ref}}, simulation {{sim}}).",
        delta_hint:
          "Écart entre cette simulation et votre estimation de référence, en pension nette mensuelle (référence {{ref}}, simulation {{sim}}).",
        bubble_trim_missing:
          "Trimestres qu'il vous manque à la date de départ pour obtenir le taux plein.",
        bubble_penalite_cnav:
          "Nombre de trimestres de décote effectivement appliqués au calcul de votre retraite de base.",
        comp_brut: "brut",
        resume_title: "En résumé",
        resume_cl_yes:
          "Vous pourriez bénéficier du dispositif « carrière longue » (départ anticipé possible).",
        resume_cl_no:
          "Le dispositif « carrière longue » ne se déclenche pas dans cette simulation.",
        resume_missing_one:
          "Il vous manque encore {{count}} trimestre pour le taux plein dans le meilleur des cas.",
        resume_missing_other:
          "Il vous manque encore {{count}} trimestres pour le taux plein dans le meilleur des cas.",
        resume_missing_none: "Vous avez tous les trimestres nécessaires pour le taux plein.",
        resume_rachat_one:
          "Cette simulation inclut le rachat de {{count}} trimestre ({{effect}}). Le coût estimé et la rentabilité figurent ci-dessus.",
        resume_rachat_other:
          "Cette simulation inclut le rachat de {{count}} trimestres ({{effect}}). Le coût estimé et la rentabilité figurent ci-dessus.",
        resume_effect_opt1: "améliore votre taux uniquement",
        resume_effect_opt2: "améliore votre taux et votre durée d'assurance",
        table_title: "Comparer mes simulations",
        table_desc:
          "Chaque simulation est comparée à votre estimation de base (en surbrillance). Votre conseiller vous aidera à choisir la situation la plus adaptée.",
        table_desc_self:
          "Chaque simulation est comparée à votre estimation de base (en surbrillance). Comparez librement les situations pour trouver celle qui vous convient.",
        table_col_simulation: "Simulation",
        table_base_row: "Estimation de base",
        table_ref: "repère",
        form_title_edit: "Modifier la simulation",
        form_title_new: "Nouvelle simulation",
        form_desc: "Choisissez ce que vous voulez tester. Vous pourrez tout modifier plus tard.",
        form_create: "Créer la simulation",
        form_name: "Nom de la simulation",
        form_name_placeholder: "Ex. Départ en juin 2030 avec rachat",
        form_err_name: "Donnez un nom à votre simulation (ex. « Départ en juin 2030 »).",
        form_err_params:
          "Choisissez au moins une situation, une date de départ ou un rachat de trimestres.",
        form_scenarios_legend: "Quelles situations voulez-vous comparer ?",
        form_scenarios_hint: "Cochez une ou plusieurs situations. Chacune donnera une estimation.",
        form_dates_legend: "Tester une ou plusieurs dates de départ précises ?",
        form_dates_hint:
          "Par exemple une date proposée par votre employeur ou une date qui vous tient à cœur.",
        form_dates_hint_max:
          "Par exemple une date proposée par votre employeur. Date maximale autorisée : {{date}}.",
        form_err_max_date:
          "La date de départ ne peut pas dépasser le {{date}} dans votre entreprise. Demandez une date spécifique à votre conseiller.",
        form_err_max_date_self:
          "La date de départ ne peut pas dépasser le {{date}} dans votre entreprise. Vous pouvez demander l'ouverture d'une date spécifique.",
        limit_hint_date: "Votre entreprise limite les simulations aux départs jusqu'au {{date}}.",
        limit_hint_tpn:
          "Votre entreprise limite les simulations aux départs jusqu'au taux plein naturel.",
        limit_request_cta: "Demander une date spécifique",
        limit_request_title: "Demander une date de départ spécifique",
        limit_request_desc:
          "Votre conseiller Aon reçoit la demande et peut ouvrir la saisie libre des dates sur votre dossier.",
        limit_request_desc_self:
          "Votre service RH reçoit la demande et peut ouvrir la saisie libre des dates sur votre dossier.",
        limit_request_sent_self: "Demande envoyée à votre service RH.",
        limit_request_pending_self:
          "Demande transmise le {{date}}, en attente de votre service RH.",
        limit_request_message: "Votre message (optionnel)",
        limit_request_placeholder: "Ex : mon employeur me propose un départ au 30/06/2032.",
        limit_request_send: "Envoyer la demande",
        limit_request_sent: "Demande envoyée à votre conseiller Aon.",
        limit_request_pending: "Demande transmise le {{date}}, en attente de votre conseiller.",
        form_remove_date: "Retirer cette date",
        form_add_date: "Ajouter une date de départ",
        form_rachat_title: "Simuler un rachat de trimestres",
        form_rachat_desc:
          "Le rachat permet de « racheter » des trimestres manquants (années d'études, périodes incomplètes) pour partir plus tôt ou augmenter votre pension.",
        form_rachat_nb: "Combien de trimestres racheter ? (1 à 12)",
        form_rachat_type: "Quel type de rachat ?",
        form_opt1_title: "Améliorer mon taux",
        form_opt1_desc: "Réduit la décote : votre pension est calculée à un meilleur taux.",
        form_opt2_title: "Améliorer mon taux et ma durée",
        form_opt2_desc:
          "Compte aussi dans la durée d'assurance : effet plus fort, coût plus élevé.",
        preview_unavailable:
          "Coût indisponible (barème CNAV non renseigné pour votre situation). Il sera précisé par votre conseiller.",
        preview_cost_one: "Coût estimé ({{count}} trimestre)",
        preview_cost_other: "Coût estimé ({{count}} trimestres)",
        desc_scenarios_one: "{{count}} situation comparée",
        desc_scenarios_other: "{{count}} situations comparées",
        desc_dates_one: "{{count}} date de départ testée",
        desc_dates_other: "{{count}} dates de départ testées",
        desc_rachat_one: "rachat de {{count}} trimestre",
        desc_rachat_other: "rachat de {{count}} trimestres",
        desc_none: "Aucun paramètre (départ à taux plein par défaut)",
      },
      breakdown: {
        composition: "Composition de votre pension (brut)",
        etage_base: "Régime de base",
        etage_compl: "Complémentaire",
        etage_suppl: "Supplémentaire",
        reversion_label: "Réversion estimée (conjoint)",
        reversion_hint: "Pension qui pourrait être versée à votre conjoint.",
        baisse_label: "Baisse de revenus à la retraite",
        baisse_hint: "Écart entre vos revenus de fin de carrière et votre pension.",
        per_month: "{{amount}} / mois",
        per_month_minus: "− {{amount}} / mois",
        regimes_detail: "Détail par caisse de retraite ({{n}})",
        caisse_fallback: "Caisse",
        mini_points: "Points",
        mini_point_value: "Valeur du point",
        mini_trim: "Trim. validés",
        mini_trim_cotises: "Trim. cotisés",
        mini_trim_reputes: "Trim. réputés cotisés",
        mini_ram: "Revenu annuel moyen",
        mini_majoration: "Majoration enfants",
        regime_base: "Base",
        regime_compl: "Complémentaire",
        regime_suppl: "Supplémentaire",
        surcote: "Surcote",
        decote: "Décote",
        surcote_title: "Majoration pour départ après le taux plein",
        decote_title: "Minoration pour départ anticipé",
        bubble_decote_base:
          "Décote du régime de base : 1,25 % par trimestre manquant, dans la limite de 20 trimestres (25 %), ici {{n}} trimestres, soit {{pct}} %.",
        bubble_decote_base_short:
          "Décote du régime de base : 1,25 % par trimestre manquant, dans la limite de 20 trimestres (25 %).",
        bubble_decote_agirc:
          "Coefficient d'anticipation Agirc-Arrco : minoration appliquée quand vous partez avant d'avoir le taux plein, selon le nombre de trimestres manquants, ici un coefficient de {{coeff}}.",
        bubble_surcote:
          "Surcote : 1,25 % par trimestre supplémentaire au-delà du taux plein et de l'âge légal, ici +{{pct}} %.",
      },
      progressive: {
        title: "Retraite progressive",
        desc: "Travaillez à temps partiel en fin de carrière tout en percevant une partie de votre pension. Choisissez une quotité de travail pour visualiser vos revenus.",
        ineligible:
          "Vous n'êtes pas éligible à la retraite progressive : {{trimestres}} trimestres validés à la date d'entrée, alors que {{min}} sont requis.",
        non_estime:
          "Montant non estimé : le moteur de calcul ne simule pas la retraite progressive avant l'âge légal. À confirmer auprès de votre caisse.",
        trim_unknown: "un nombre insuffisant de",
        date_debut: "Entrée possible dès le",
        date_fin: "Départ définitif estimé",
        quotite_label: "Quotité de travail à temps partiel",
        salaire_partiel: "Salaire temps partiel ({{pct}} %)",
        pension_base: "Pension de base ({{pct}} %)",
        pension_compl: "Complémentaire ({{pct}} %)",
        total: "Revenu mensuel total",
        note_net:
          "Montants nets estimés : le salaire à temps partiel est approché à partir de votre revenu brut (environ 78 %).",
        detail_title: "Méthode de calcul — complémentaire Agirc-Arrco",
        detail_points: "Points acquis à l'entrée",
        detail_vp: "Valeur du point",
        detail_coeff: "Coefficient Agirc-Arrco",
        detail_minoration: "minoration de {{pct}} %",
        detail_majoration: "majoration de {{pct}} %",
        detail_taux_plein: "taux plein",
        detail_formula:
          "Pension complémentaire à l'entrée = points × valeur du point × coefficient ; la fraction servie est proratisée par (100 % − quotité de travail).",
        detail_unverified:
          "Écart constaté entre ce recalcul et le montant du moteur de calcul : le montant du moteur est conservé.",
      },
      pdf: {
        title: "Votre simulation en PDF",
        desc: "Téléchargez le récapitulatif complet de votre simulation retraite (situation, droits, parcours, points d'attention et paramètres).",
        download: "Télécharger ma simulation",
        failed: "La génération du document a échoué.",
      },
      charts: {
        title: "Comparatif de vos scénarios",
        desc: "Pension mensuelle (brute et nette) par scénario, courbe du taux de remplacement, et repère de votre revenu actuel.",
        serie_brut: "Pension brute",
        serie_net: "Pension nette",
        serie_taux: "Taux de remplacement",
        axis_month: "€ / mois",
        axis_taux: "Taux",
        current_income: "Revenu actuel : {{amount}}",
        estimation: "Estimation",
        date_visee: "À la date souhaitée",
      },
      audit: {
        title: "Fiabilité de votre relevé",
        desc: "Nous analysons votre carrière pour repérer d'éventuels oublis ou incohérences avant le calcul.",
        run: "Vérifier ma carrière",
        rerun: "Relancer la vérification",
        failed: "La vérification a échoué.",
        hint: "Lancez la vérification pour détecter automatiquement les points à corriger (périodes manquantes, revenus nuls, baisses inhabituelles…).",
        clean: "Aucune anomalie détectée : votre relevé semble cohérent.",
        points_one: "{{count}} point à vérifier. Votre conseiller peut vous aider à le corriger.",
        points_other:
          "{{count}} points à vérifier. Votre conseiller peut vous aider à les corriger.",
        action_add: "À ajouter",
        action_modify: "À modifier",
        occurrences_one: "{{count}} occurrence",
        occurrences_other: "{{count}} occurrences",
        fallback: "Point à vérifier",
        code_serviceMilitaire: "Service militaire absent",
        code_avpfSansEnfant: "Période AVPF sans enfant",
        code_indiceFonct: "Indice de fin de carrière manquant",
        code_revenuNul: "Revenu nul sur une période",
        code_jeuneParent: "Écart d'âge parent / enfant inhabituel",
        code_baisseRevenu: "Baisse importante de revenus",
        code_tauxActivite: "Taux d'activité à vérifier",
        code_periodeJour: "Période d'une seule journée",
        code_periodeSansInformation: "Période sans information",
        code_periodeAnnuelleSansInformation: "Année sans information",
        fiche_toggle: "Comprendre et corriger",
        fiche_explication: "Explication",
        fiche_recommandation: "Démarche recommandée",
        fiche_pieces: "Pièces à réunir",
      },
      revenus: {
        title: "Évolution de vos revenus",
        desc: "Reconstitution de vos revenus professionnels, année par année, jusqu'à votre départ. Montants annuels exprimés en euros.",
        run: "Projeter mes revenus",
        rerun: "Recalculer",
        failed: "Le calcul a échoué.",
        hint: "Lancez la projection pour visualiser l'évolution de vos revenus professionnels au fil de votre carrière.",
        empty: "Aucun revenu exploitable n'a pu être projeté à partir de votre relevé.",
        serie_percu: "Revenus annuels perçus",
        serie_projete: "Revenus annuels projetés",
      },
      points: {
        title: "Vos points Agirc-Arrco",
        desc: "Points de retraite complémentaire acquis chaque année, d'après votre relevé de carrière.",
        points_unit: "points",
        drop_tooltip: "−{{pct}} % vs {{prev}} pts l'année précédente",
        table_year: "Année",
        table_points: "Points acquis",
        table_diff: "Écart (points)",
        table_diff_pct: "Écart (%)",
        table_flag: "Constat",
        table_drop: "Baisse marquée",
        table_expand: "Voir les {{count}} années précédentes",
        table_collapse: "Réduire le tableau",
        drop_legend:
          "Une baisse de points peut correspondre à une période de chômage, de temps partiel ou à une donnée manquante sur votre relevé. Votre conseiller la vérifie avec vous.",
      },
      rachatPanel: {
        unavailable_title: "Coût du rachat non disponible",
        unavailable_desc:
          "Le barème CNAV n'est pas encore renseigné pour votre situation (âge / tranche de revenu). Le coût exact vous sera précisé par votre conseiller Aon.",
        title: "Coût et rentabilité du rachat",
        subtitle_one: "Estimation pour {{count}} trimestre · option « {{option}} »",
        subtitle_other: "Estimation pour {{count}} trimestres · option « {{option}} »",
        option_taux_duree: "Taux + durée d'assurance",
        option_taux_seul: "Taux seul",
        cost: "Coût estimé",
        cost_hint: "{{amount}} / trimestre",
        gain: "Gain estimé",
        gain_value: "+{{amount}} / mois",
        gain_hint_year: "{{amount}} / an",
        gain_hint_base: "vs estimation de base",
        amort: "Amorti en",
        amort_year: "{{years}} an",
        amort_years: "{{years}} ans",
        amort_hint_yes: "puis gain net",
        amort_hint_no: "gain non déterminé",
        other_option: "Autre option « {{option}} » :",
        tax_note_1: "Montant ",
        tax_note_strong: "déductible de votre revenu imposable",
        tax_note_2:
          " : le coût réel après impôt est inférieur (selon votre tranche marginale d'imposition). Estimation indicative fondée sur le barème CNAV{{year}} ; votre conseiller Aon affinera le calcul.",
        c2_desc:
          "Vous n'avez pas besoin de racheter des trimestres : vous bénéficierez du taux plein dès l'âge légal.",
      },
      rachatTauxPlein: {
        option_taux_seul: "taux seul",
        option_taux_duree: "taux et durée",
        title: "Rachat de trimestres pour le taux plein",
        subtitle_one:
          "{{count}} trimestre racheté pour un départ à l'âge légal (option {{option}})",
        subtitle_other:
          "{{count}} trimestres rachetés pour un départ à l'âge légal (option {{option}})",
        plafond: "(plafond légal de 12 trimestres atteint)",
        sans_rachat: "Sans rachat",
        avec_rachat: "Avec rachat à l’âge légal",
        per_month: "pension nette / mois à l'âge légal",
        cout: "Coût estimé",
        cout_hint: "option {{option}}, barème indicatif",
        roi: "Retour sur investissement",
        roi_years: "{{years}} ans",
        gain_hint: "gain de {{amount}} / mois",
        taux_plein_ok:
          "Le taux plein est atteint à la date de départ grâce aux trimestres rachetés.",
        taux_plein_ko:
          "Les trimestres rachetés rapprochent du taux plein sans l'atteindre à cette date.",
        caution:
          "Les années effectivement rachetables (études, années incomplètes) restent à confirmer auprès de votre caisse.",
        c2_title: "Pas besoin de racheter",
        c2_desc:
          "Vous n'avez pas besoin de racheter des trimestres : vous bénéficierez du taux plein dès l'âge légal.",
      },
    },
    placeholder: {
      coming_soon: "Cette fonctionnalité arrive bientôt.",
    },
  },
  admin: {
    referentiels: {
      kicker: "Administration",
      title: "Actualité des référentiels",
      description:
        "Date de dernière mise à jour de chaque référentiel interne (barème de rachat et PASS, catalogues, grilles, bibliothèques), avec alerte au-delà du délai attendu.",
      table_title: "Référentiels internes",
      ref_rachat_bareme: "Barème de rachat de trimestres (millésime actif)",
      ref_document_types: "Types de documents",
      ref_controle_checklist: "Grille d'autocontrôle N1 / N2",
      ref_bri_annexes: "Annexes BRI",
      ref_email_templates: "Modèles d'emails",
      ref_content_library: "Bibliothèque de contenus",
      ref_anomalie_types: "Bibliothèque d'anomalies",
      ref_points_attention: "Bibliothèque de points d'attention",
      ref_conventions_collectives: "Conventions collectives (IDCC)",
      updated_on: "Dernière mise à jour : {{date}}",
      never_updated: "Jamais renseigné",
      badge_ok: "À jour",
      badge_stale: "À vérifier ({{days}} j)",
      badge_empty: "Vide",
      engine_note:
        "Le moteur de calcul de retraite est opéré par son éditeur, qui n'expose pas d'information de version exploitable : sa date de mise à jour n'est volontairement pas suivie ici.",
    },
    refprof: {
      kicker: "Administration",
      title: "Référentiel professions et régimes",
      description:
        "Correspondance entre les professions gérées par le moteur de calcul et leurs régimes de retraite (base, complémentaire, supplémentaire). Elle est déduite des calculs du moteur puis corrigeable manuellement : vos corrections sont conservées à chaque régénération.",
      actions_title: "Alimentation automatique",
      refresh: "Rafraîchir la liste",
      generate: "Générer le référentiel ({{count}} appels)",
      last_refresh: "Liste des professions mise à jour le {{date}}",
      never_refreshed:
        "Liste des professions jamais rafraîchie : lancez d'abord « Rafraîchir la liste ».",
      refreshed: "{{count}} professions récupérées depuis le moteur.",
      generated: "Référentiel généré pour {{count}} professions sur {{total}} en {{seconds}} s",
      failures: "professions sans résultat : {{codes}}",
      list_title: "Professions et régimes",
      search: "Rechercher une profession…",
      empty:
        "Aucune profession : lancez « Rafraîchir la liste » pour charger le référentiel depuis le moteur.",
      sans_famille: "Sans famille",
      no_regime: "Aucun régime enregistré pour cette profession.",
      add_regime: "Ajouter un régime",
      new_code: "Code caisse",
      new_libelle: "Libellé",
      rename: "Renommer",
      hide: "Masquer",
      show: "Réafficher",
      badge_auto: "auto",
      badge_manuel: "manuel",
      badge_masque: "masqué",
      classif_base: "régime de base",
      classif_complementaire: "complémentaire",
      classif_supplementaire: "supplémentaire",
    },
    conv: {
      kicker: "Administration",
      title: "Conventions collectives",
      description:
        "Référentiel des conventions collectives (IDCC), chargé depuis la liste officielle DILA et enrichissable par import Excel/CSV ou saisie. Donnée conservée pour la prévoyance : elle n'a aucun effet sur le calcul de la retraite.",
      list_title: "Référentiel",
      search_title: "Conventions",
      search: "Rechercher par libellé ou IDCC…",
      import: "Importer (Excel/CSV)",
      import_empty: "Aucune ligne valide dans le fichier.",
      imported: "Import terminé : {{added}} ajoutées, {{modified}} modifiées sur {{total}} lignes.",
      duplicates: "{{count}} doublons d'IDCC ignorés",
      add: "Ajouter",
      new_idcc: "IDCC",
      new_libelle: "Libellé",
      rename: "Renommer",
      activate: "Réactiver",
      deactivate: "Désactiver",
      active: "active",
      inactive: "inactive",
      source_dila: "DILA",
      source_import: "import",
      source_manuel: "manuel",
      count: "{{total}} conventions, {{active}} actives",
      empty: "Aucune convention ne correspond à la recherche.",
      col_idcc: "IDCC",
      col_label: "Libellé",
      col_status: "Statut",
      col_actions: "Actions",
      sort_by: "Trier par {{column}}",
      unit: "conventions",
    },
    dashboard: {
      kicker: "Administration",
      title: "Console admin Aon",
      description: "Vue d'ensemble de la plateforme : clients, opérations, utilisateurs.",
      overview: "Vue d'ensemble",
      quick_links: "Accès rapides",
      open: "Ouvrir",
      guided_start: "Démarrage guidé",
      onboard_title: "Embarquer une nouvelle entreprise",
      onboard_desc:
        "Un assistant pas-à-pas : entreprise, campagne BRI puis premiers salariés invités. La voie la plus simple pour tout mettre en place.",
      launch_wizard: "Lancer l'assistant",
      stat_groups: "Groupes clients",
      stat_societes: "Sociétés",
      stat_operations: "Opérations en cours",
      stat_dossiers: "Dossiers actifs",
      hint_salaries_total: "{{count}} salariés au total",
      hint_operations_total: "{{count}} au total (tous statuts)",
      hint_dossiers_production: "{{count}} en production",
      stat_urgents: "Dossiers urgents en cours",
      hint_urgents: "Non restitués, marqués prioritaires",
      stat_urgence_delai: "Délai moyen de restitution",
      stat_urgence_delai_suffix: "j ouvrés",
      hint_urgence_delai: "Sur {{count}} dossier(s) restitué(s) en 90 j",
      link_tenants_title: "Groupes & sociétés",
      link_tenants_desc: "Créer / éditer les clients, gérer la hiérarchie.",
      link_operations_title: "Opérations BRI",
      link_operations_desc: "Lancer une nouvelle campagne, piloter les en cours.",
      link_users_title: "Utilisateurs & rôles",
      link_users_desc: "Inviter, attribuer des rôles et des scopes.",
      link_branding_title: "Branding",
      link_branding_desc: "Logos, couleurs et libellés par société.",
    },
    tenants: {
      kicker: "Administration",
      title: "Groupes, sociétés & filiales",
      description:
        "Hiérarchie des clients : groupes → sociétés → filiales (BU & sites). Les opérations BRI sont gérées séparément.",
      add_groupe: "Nouveau groupe",
      add_societe: "Nouvelle société",
      search_placeholder: "Rechercher un groupe, une société, un SIREN…",
      empty_title: "Aucun client pour le moment",
      empty_description: "Créez votre premier groupe client ou société pour démarrer.",
      empty_action: "Créer un groupe",
      slug_label: "slug",
      inactive: "Inactif",
      confidential_badge: "Confidentielle",
      confidential_hint:
        "Les données personnelles des salariés de cette société ne sont visibles que des super-admins et des internes Aon autorisés.",
      societe_button: "Société",
      emails_button: "Emails",
      emails_title: "Bibliothèque d'emails du groupe",
      edit: "Modifier",
      delete: "Supprimer",
      no_societes_in_group: "Aucune société rattachée à ce groupe.",
      independent_societes: "Sociétés indépendantes",
      independent_description: "{{count}} société(s) sans groupe parent.",
      societes_count: "{{count}} société(s)",
      page: "Page {{page}} sur {{total}}",
      previous: "Précédent",
      next: "Suivant",
      drh_label: "DRH",
      group_delete_title: "Supprimer le groupe « {{name}} » ?",
      group_delete_description:
        "Les sociétés rattachées resteront mais seront détachées du groupe.",
      group_delete_confirm: "Supprimer le groupe",
      societe_delete_title: "Supprimer la société « {{name}} » ?",
      societe_delete_description:
        "Toutes les opérations et les salariés associés à cette société seront également supprimés.",
      irreversible: "Cette action est irréversible.",
      societe_delete_confirm: "Supprimer définitivement",
      logo_alt: "Logo {{name}}",
      subsidiaries: "Filiales",
      add_filiale: "Nouvelle filiale",
      no_filiales: "Aucune filiale rattachée à cette société.",
      siren: "SIREN",
      siret: "SIRET",
      bu: "BU",
      sites_count: "{{count}} site(s)",
      filiale_delete_title: "Supprimer la filiale « {{name}} » ?",
      filiale_delete_description:
        "{{business_units_count}} BU · {{sites_count}} site(s) seront également supprimés.",
      filiale_delete_confirm: "Supprimer définitivement",
    },
    tenantForms: {
      cancel: "Annuler",
      save: "Enregistrer",
      groupe: {
        new_title: "Nouveau groupe",
        edit_title: "Modifier le groupe « {{name}} »",
        new_description:
          "Un groupe est l'entité racine d'un client (ex. TotalEnergies, BNP Paribas).",
        edit_description: "Modification des informations du groupe client.",
        create: "Créer le groupe",
        siren_prefill_label: "Pré-remplissage par SIREN",
        siren_prefill_hint:
          "Saisissez le SIREN du groupe pour récupérer automatiquement nom et description.",
        siren_label: "SIREN",
        siren_hint: "9 chiffres. Rempli automatiquement par la recherche ci-dessus.",
        siren_error: "Le SIREN doit contenir 9 chiffres",
        nom_label: "Nom du groupe",
        nom_error: "Le nom doit contenir au moins 2 caractères",
        slug_label: "Identifiant URL (slug)",
        slug_error:
          "Le slug ne peut contenir que des lettres minuscules, des chiffres et des tirets",
        slug_hint:
          "Utilisé pour les URLs et les exports. Modifiable mais à éviter une fois en production.",
        description_label: "Description",
        description_placeholder: "Activité, périmètre, contexte…",
        logo_label: "Logo du groupe",
        logo_hint:
          "Le logo sera affiché dans l'en-tête de l'espace client (formats recommandés : SVG, PNG transparent).",
        logo_url_error: "URL invalide",
        active_label: "Groupe actif",
        active_description: "Désactivez pour masquer ce groupe sans le supprimer.",
        bri_title: "Paramétrage BRI",
        bri_description:
          "Configuration du support BRI souhaitée par le client au niveau du groupe.",
        simulations_label: "Simulations souhaitées",
        simulations_autres_label: "Autres simulations",
        simulations_autres_placeholder: "Ex. simulation expatriation, départ anticipé…",
        simulations_autres_hint: "Simulations supplémentaires non listées ci-dessus.",
        simulation_temps_partiel: "Temps partiel",
        simulation_retraite_progressive: "Retraite progressive",
        simulation_rachat_trimestres: "Rachat de trimestres",
        simulation_cumul_emploi_retraite: "Cumul emploi-retraite",
        simulation_carriere_longue: "Carrière longue",
        annexes_label: "Annexes type du support",
        annexes_hint: "Fiches de la bibliothèque composant le support BRI validé par le client.",
        annexes_empty: "Aucune fiche active dans la bibliothèque. Créez-en dans « Annexes BRI ».",
        annexes_precision_label: "Précisions sur les annexes",
        annexes_precision_placeholder:
          "Annexes spécifiques, mentions particulières demandées par le client…",
        diffusion_label: "Autorisation de diffusion",
        diffusion_hint: "Définit le partage des informations BRI entre le salarié et l'entreprise.",
        diffusion_souhait_salarie_label: "Au souhait du salarié",
        diffusion_souhait_salarie_description:
          "Le salarié choisit librement les informations partagées avec l'entreprise.",
        diffusion_accord_partiel_label: "Accord obligatoire — partiel",
        diffusion_accord_partiel_description:
          "Partage obligatoire de la date de taux plein naturel avec l'entreprise.",
        diffusion_accord_total_label: "Accord obligatoire — total",
        diffusion_accord_total_description:
          "Partage obligatoire du support BRI complet avec l'entreprise.",
      },
      societe: {
        new_title: "Nouvelle société cliente",
        edit_title: "Modifier « {{name}} »",
        new_description:
          "Une société est l'entité juridique cliente (SIREN/SIRET). Tenant principal pour les opérations BRI.",
        edit_description: "Modification des informations légales et de contact.",
        create: "Créer la société",
        siren_prefill_hint:
          "Saisissez le SIREN de la société pour pré-remplir nom, raison sociale, SIRET, code NAF et adresse du siège.",
        section_identification: "Identification",
        groupe_parent_label: "Groupe parent",
        option_no_groupe: "Aucun (société indépendante)",
        nom_commercial_label: "Nom commercial",
        nom_error: "Le nom doit contenir au moins 2 caractères",
        slug_label: "Slug",
        slug_error:
          "Le slug ne peut contenir que des lettres minuscules, des chiffres et des tirets",
        raison_sociale_label: "Raison sociale",
        raison_sociale_placeholder: "Société Anonyme TotalEnergies",
        siren_label: "SIREN",
        siren_error: "Le SIREN doit contenir 9 chiffres",
        siret_label: "SIRET du siège",
        siret_error: "Le SIRET doit contenir 14 chiffres",
        code_naf_label: "Code NAF",
        section_adresse: "Adresse du siège",
        adresse_label: "Rue",
        code_postal_label: "Code postal",
        ville_label: "Ville",
        pays_label: "Pays",
        section_contact_drh: "Contact DRH",
        drh_nom_label: "Nom",
        drh_email_label: "Email",
        email_error: "Email invalide",
        drh_phone_label: "Téléphone",
        section_accords_seniors: "Accords senior",
        accords_seniors_description:
          "Dispositifs seniors applicables (temps partiel senior, retraite progressive, aménagements de fin de carrière, indemnités de départ…). Ce contenu est transmis à l'IA pour personnaliser le bilan retraite des salariés.",
        accord_branche_label: "Accord de branche",
        accord_branche_placeholder:
          "Dispositions de la convention collective / branche relatives aux seniors…",
        accord_entreprise_label: "Accord d'entreprise",
        accord_entreprise_placeholder:
          "Dispositions négociées au sein de l'entreprise relatives aux seniors…",
        active_label: "Société active",
        active_description: "Désactivez pour masquer cette société sans la supprimer.",
        confidential_label: "Société confidentielle",
        confidential_description:
          "Masque les données personnelles des salariés pour les internes Aon non autorisés. La société, ses opérations et son paramétrage restent visibles.",
        confidential_readonly:
          "Société confidentielle : seul un super-admin peut modifier ce réglage.",
        confidential_access_title: "Accès confidentiels",
        confidential_access_hint:
          "Internes Aon autorisés à voir les données personnelles des salariés de cette société (les super-admins y ont toujours accès).",
        confidential_access_empty: "Aucun interne autorisé pour le moment.",
        confidential_access_add_label: "Ajouter un interne Aon",
        confidential_access_add_placeholder: "Choisir un utilisateur interne…",
        confidential_access_add: "Autoriser",
        confidential_access_remove: "Retirer cet accès",
        confidential_access_readonly:
          "La liste des accès confidentiels n'est visible que par un super-admin.",
      },
      filiale: {
        new_title: "Nouvelle filiale",
        edit_title: "Modifier la filiale « {{name}} »",
        description_with_parent: "Rattachée à la société {{societe}}.",
        description_without_parent:
          "Une filiale est une entité juridique rattachée à une société du groupe.",
        create: "Créer la filiale",
        finish: "Terminer",
        tab_identification: "Identification",
        tab_parametrage: "Paramétrage",
        siren_mismatch_title: "SIREN différent de la société parente",
        siren_mismatch_message:
          "Le SIRET fourni appartient au SIREN {{siren}}, différent de celui de la société parente ({{societe_siren}}).",
        siret_prefill_hint: "Saisissez le SIRET de la filiale pour pré-remplir nom et adresse.",
        section_identification: "Identification",
        nom_label: "Nom de la filiale",
        nom_error: "Le nom doit contenir au moins 2 caractères",
        slug_label: "Slug",
        slug_error:
          "Le slug ne peut contenir que des lettres minuscules, des chiffres et des tirets",
        siret_label: "SIRET",
        siret_hint: "14 chiffres. Optionnel — rempli automatiquement par la recherche ci-dessus.",
        siret_error: "Le SIRET doit contenir 14 chiffres",
        section_adresse: "Adresse",
        adresse_label: "Adresse",
        code_postal_label: "Code postal",
        ville_label: "Ville",
        pays_label: "Pays",
        active_label: "Filiale active",
        active_description: "Désactivez pour masquer cette filiale sans la supprimer.",
        info_create_parametrage:
          "Vous pourrez ajouter les Business Units et les sites géographiques dans l'onglet Paramétrage dès que la filiale aura été créée.",
        business_units_title: "Business Units",
        bu_empty: "Aucune Business Unit pour le moment.",
        bu_add_label: "Ajouter une Business Unit",
        bu_add_button: "Ajouter",
        bu_delete_confirm: "Supprimer la Business Unit « {{name}} » ?",
        bu_delete_confirm_description: "Les sites et salariés rattachés seront détachés.",
        bu_delete_button: "Supprimer",
        bu_edit_name_label: "Nom",
        bu_edit_slug_hint: "Slug actuel : {{slug}} (non modifiable)",
        bu_edit_active_label: "Business Unit active",
        sites_title: "Sites géographiques",
        sites_empty: "Aucun site pour le moment.",
        site_add_title: "Ajouter un site",
        site_nom_label: "Nom du site",
        site_adresse_label: "Rue",
        site_cp_label: "Code postal",
        site_ville_label: "Ville",
        site_add_button: "Ajouter le site",
        site_delete_confirm: "Supprimer le site « {{name}} » ?",
        site_delete_confirm_description: "Cette action est irréversible.",
        site_delete_button: "Supprimer",
        site_edit_nom_label: "Nom du site",
        site_edit_adresse_label: "Rue",
        site_edit_cp_label: "Code postal",
        site_edit_ville_label: "Ville",
        site_edit_active_label: "Site actif",
        site_edit_slug_hint: "Slug actuel : {{slug}} (non modifiable)",
        site_no_address: "Sans adresse",
        inactive_badge: "Inactif",
        edit_button_aria: "Modifier",
        delete_button_aria: "Supprimer",
      },
    },
    users: {
      kicker: "Administration",
      title: "Utilisateurs & accès",
      description: "Rôles fonctionnels et périmètres d'accès par société et opération.",
      tab_active: "Utilisateurs",
      tab_invitations: "Invitations",
      invite: "Inviter un utilisateur",
      edit_access: "Modifier les accès",
      resend: "Renvoyer",
      resend_title: "Ré-envoyer l'email d'invitation",
      revoke: "Révoquer",
      revoke_edit: "Modifier",
      resend_success: "Email ré-envoyé à {{recipient}}.",
      resend_error: "Erreur lors de l'envoi",
      revoke_success: "Invitation révoquée.",
      revoke_confirm: "Révoquer cette invitation ?",
      no_users: "Aucun utilisateur",
      no_users_desc:
        "Invitez un utilisateur depuis l'onglet « Invitations » : il recevra un email d'activation pour rejoindre la plateforme.",
      no_invitations: "Aucune invitation en attente",
      no_invitations_desc:
        "Toutes les invitations ont été acceptées ou aucune n'a encore été créée.",
      search_placeholder: "Nom, email, rôle…",
      last_login: "Dernière connexion",
      never_logged_in: "Jamais connecté",
      role: "Rôle",
      scope: "Périmètre",
      invited_at: "Invité le",
      invited_by: "Invité par",
      invitation_sent: "Invitation envoyée à {{recipient}}.",
      invitation_pending_count_one: "{{count}} invitation en attente",
      invitation_pending_count_other: "{{count}} invitations en attente",
      badge_disabled: "Désactivé",
      badge_expired: "Expirée",
      badge_expired_hint:
        "Invitation expirée : cliquez sur Renvoyer pour la prolonger de 30 jours et renvoyer le mail.",
      apply_error_label: "Échec à l'activation du compte :",
      societies_count_one: "{{count}} société",
      societies_count_other: "{{count}} sociétés",
      operations_count_one: "{{count}} opération",
      operations_count_other: "{{count}} opérations",
      region_scope: "Région : {{region}}",
      close: "Fermer",
      // InviteUserDrawer
      invite_drawer_title_new: "Inviter un utilisateur",
      invite_drawer_title_edit: "Inviter {{email}}",
      invite_drawer_desc_new:
        "L'email d'activation est envoyé immédiatement au destinataire. À la première connexion, ses rôles et périmètres seront appliqués automatiquement.",
      invite_drawer_desc_edit:
        "Mettre à jour l'invitation et renvoyer un email d'activation au destinataire.",
      invite_info:
        "Un email d'invitation contenant un lien d'activation sera envoyé immédiatement au destinataire après création.",
      section_contact: "Coordonnées",
      field_email: "Email",
      field_email_placeholder: "prenom.nom@entreprise.com",
      field_prenom: "Prénom (facultatif)",
      field_nom: "Nom (facultatif)",
      field_note: "Note interne (facultatif)",
      field_note_placeholder: "Contexte, équipe, etc.",
      section_roles: "Rôles à attribuer",
      roles_required: "Sélectionnez au moins un rôle pour pouvoir créer l'invitation.",
      roles_rules:
        "Les salariés ne s'invitent pas ici : créez-leur une fiche salarié. Un même compte ne peut pas cumuler DRH et équipe Aon.",
      roles_exclusive_hint: "Incompatible avec les rôles déjà sélectionnés (DRH ↔ équipe Aon).",
      salarie_conflict_title: "Cet email appartient à un salarié",
      salarie_conflict_desc:
        "L'adresse {{email}} est celle du salarié {{name}} (matricule {{matricule}}). Un salarié ne peut pas recevoir un compte de l'équipe Aon : utilisez une autre adresse ou retirez d'abord cet email de sa fiche. Un accès DRH, lui, peut être ajouté sur cette adresse.",
      section_options: "Options",
      option_create_salarie_label: "Autoriser la saisie manuelle d'un compte salarié",
      option_create_salarie_desc:
        "Permet à cet utilisateur de créer lui-même des comptes salariés dans son périmètre.",
      section_scope: "Périmètre d'accès",
      scope_hint:
        "Cocher un niveau donne accès à tout ce qu'il contient : une société couvre ses filiales, BU, sites et opérations ; une filiale seule restreint l'accès à cette filiale.",
      global_access_title: "Accès global automatique",
      global_access_desc:
        "Le rôle Administrateur Aon donne d'office accès à tous les groupes, sociétés, filiales, BU, sites et opérations. Aucun périmètre à cocher.",
      cancel: "Annuler",
      submit_new: "Créer & envoyer l'email",
      submit_edit: "Mettre à jour & renvoyer",
      // UserAccessDrawer
      access_drawer_title: "Accès de {{name}}",
      btn_impersonate: "Voir en tant que",
      impersonate_self: "Vous ne pouvez pas vous impersoner vous-même.",
      impersonate_inactive: "Ce compte est désactivé.",
      impersonate_title: "Se connecter en tant que cet utilisateur",
      impersonate_internal_disabled:
        "Impersonation impossible : ce compte porte un rôle interne Aon.",
      impersonate_denied:
        "Impersonation refusée : cet utilisateur est rattaché à une société confidentielle ou à un périmètre protégé.",
      mfa_enabled: "2FA activée",
      mfa_disabled: "2FA non activée",
      mfa_section: "Double authentification",
      mfa_reset_title: "Réinitialiser la double authentification",
      mfa_reset_disabled: "Aucune 2FA à réinitialiser.",
      mfa_reset_self: "Vous ne pouvez pas réinitialiser votre propre 2FA ici.",
      mfa_reset_button: "Réinitialiser la double authentification",
      mfa_reset_hint:
        "Supprime le facteur TOTP et les codes de secours du compte. L'utilisateur devra enrôler une nouvelle application à sa prochaine connexion.",
      mfa_reset_confirm_title: "Réinitialiser la 2FA de {{name}} ?",
      mfa_reset_confirm_desc:
        "Son application d'authentification et ses codes de secours seront supprimés. Il devra enrôler une nouvelle application à sa prochaine connexion. L'action est enregistrée dans le journal d'audit.",
      mfa_reset_confirm_button: "Réinitialiser",
      btn_deactivate: "Désactiver",
      btn_reactivate: "Réactiver",
      btn_delete: "Supprimer",
      delete_self_disabled: "Vous ne pouvez pas supprimer votre propre compte.",
      delete_admin_disabled:
        "Retirez d'abord le rôle admin_aon avant de pouvoir supprimer ce compte.",
      super_admin_readonly:
        "Compte super-admin : seul un super-admin peut modifier ses rôles, son statut ou le supprimer.",
      super_admin_only_hint:
        "Le rôle super_admin ne peut être attribué ou retiré que par un super-admin.",
      delete_title_default: "Supprimer définitivement le compte",
      save: "Enregistrer",
      section_functional_roles: "Rôles fonctionnels",
      delete_confirm_title: "Supprimer {{name}} ?",
      delete_confirm_desc:
        "Cette action est irréversible. Le compte sera supprimé définitivement, ainsi que ses rôles et périmètres.",
      delete_confirm_note:
        "L'historique (dossiers, documents, audit) reste conservé mais l'auteur sera anonymisé.",
      delete_confirm_button: "Supprimer définitivement",
      // ScopeSelector
      scope_groups: "Groupes",
      scope_companies: "Sociétés",
      scope_subsidiaries: "Filiales",
      scope_business_units: "Business Units",
      scope_sites: "Sites",
      scope_operations: "Opérations",
      scope_empty_groups: "Aucun groupe.",
      scope_empty_companies: "Aucune société. Crée-en une depuis l'onglet Tenants.",
      scope_empty_subsidiaries: "Aucune filiale.",
      scope_empty_bus: "Aucune BU.",
      scope_empty_sites: "Aucun site.",
      scope_empty_operations: "Aucune opération. Crée-en une depuis l'onglet Opérations.",
      scope_no_results: "Aucun résultat.",
      scope_selected_one: "{{count}} sélectionné",
      scope_selected_other: "{{count}} sélectionnés",
      scope_search: "Rechercher…",
    },
    operations: {
      kicker: "Administration",
      title: "Opérations BRI",
      description: "Toutes les campagnes (brouillon, planifiées, en cours, clôturées).",
      add: "Nouvelle opération",
      edit: "Modifier l'opération",
      no_operations: "Aucune opération créée.",
      search_placeholder: "Rechercher une opération…",
      year: "Année",
      societe: "Société",
      status: "Statut",
      dossiers_count: "Dossiers",
      start_date: "Date de début",
      end_date: "Date de fin",
      active: "Active",
      closed: "Clôturée",
      draft: "Brouillon",
      filter_search: "Rechercher",
      filter_placeholder: "Nom, slug, société…",
      filter_all_societes: "Toutes",
      filter_all_status: "Tous",
      empty_title_default: "Aucune opération créée",
      empty_title_filtered: "Aucun résultat pour ces filtres",
      empty_desc_default: "Créez votre première opération BRI pour démarrer.",
      empty_desc_filtered: "Modifiez vos filtres ou créez une nouvelle opération.",
      empty_action: "Créer une opération",
      count: "{{count}} opération(s)",
      group_label: "Groupe",
      date_from: "du {{date}}",
      date_to: "au {{date}}",
      edit_aria: "Modifier",
      delete_aria: "Supprimer",
      delete_title: "Supprimer l'opération « {{name}} » ?",
      delete_desc: "Tous les dossiers associés à cette opération seront également supprimés.",
      delete_irreversible: "Cette action est irréversible.",
      delete_confirm: "Supprimer définitivement",
      form: {
        title_new: "Nouvelle opération BRI",
        title_edit: "Modifier l'opération « {{name}} »",
        description_new:
          "Une opération est une campagne BRI rattachée à un groupe, une société ou une filiale.",
        description_edit: "Modification des paramètres de la campagne.",
        cancel: "Annuler",
        save: "Enregistrer",
        create: "Créer l'opération",
        scope_section: "Périmètre",
        management_section: "Pilotage",
        documents_section: "Documents demandés (selon le parcours)",
        documents_hint:
          "Les pièces socle (relevé de carrière, Agirc-Arrco, bulletin de salaire) sont toujours demandées. Activez ici les pièces propres à ce parcours, comme le relevé de retraite supplémentaire.",
        no_configurable_types: "Aucun type de document configurable.",
        required_checkbox: "Obligatoire",
        attachment_level: "Niveau de rattachement",
        client_group: "Groupe client",
        client_societe: "Société cliente",
        filiale: "Filiale",
        operation_name: "Nom de l'opération",
        slug: "Slug",
        campaign_year: "Année de campagne",
        start_date: "Date de début",
        end_date: "Date de fin",
        status: "Statut",
        chef_projet: "Chef de projet Aon",
        chef_projet_hint:
          "Interlocuteur Aon unique du DRH pour cette opération : il porte la messagerie DRH ↔ chef de projet.",
        search_chef_projet: "Rechercher un chef de projet…",
        bri_type_default: "Type de BRI",
        bri_type_hint:
          "S'applique à tous les dossiers de l'opération. En BRI flash, le salarié doit indiquer ses souhaits avant d'accéder à son BRI.",
        salary_band: "Catégorie de salaire",
        salary_band_placeholder: "Sélectionner une catégorie",
        salary_band_hint:
          "Les salariés d'une opération à catégorie unique en héritent ; en opération mixte, la catégorie est renseignée salarié par salarié.",
        formation_required_label: "Formation obligatoire avant le parcours",
        formation_required_hint:
          "Si activé, le salarié doit avoir participé à une formation pour accéder à son parcours retraite. Si désactivé, il accède directement au parcours digital.",
        parcours_section: "Parcours de simulation",
        parcours_hint:
          "Encadre ce que le salarié peut simuler en autonomie. Un conseiller Aon peut débrider un dossier précis depuis sa fiche.",
        parcours_type_label: "Type de parcours salarié",
        parcours_type_digital: "100% digital",
        parcours_type_digital_humain: "Digital et humain",
        parcours_type_vip: "VIP",
        parcours_type_digital_hint:
          "Salarié autonome, éloigné de la retraite : simulations dans le périmètre d'âge défini, assistant IA et messagerie. Ni rendez-vous, ni hotline, ni prise en charge par la production Aon.",
        parcours_type_digital_humain_hint:
          "Le salarié renseigne son parcours, Aon le traite, un rendez-vous est pris et le dossier est restitué (rachat de trimestres, retraite progressive, relevé d'anomalies).",
        parcours_type_vip_hint:
          "Parcours digital et humain, complété de questions sur les projets d'après, de l'analyse comparée des scénarios et de l'arbitrage / ROI Tranche C.",
        parcours_capabilities_title: "Ce que ce parcours ouvre au salarié",
        parcours_capabilities_locked:
          "Le type de parcours fixe les services inclus. La retraite progressive et le scénario chômage se règlent ci-dessous.",
        progressive_enabled_label: "Activer la retraite progressive",
        progressive_enabled_hint:
          "Disponible dans tous les types de parcours. Active le calcul et l'affichage dans les résultats et le prochain BRI. Les dossiers déjà calculés doivent être recalculés ; les montants non estimés restent soumis au contrôle du consultant.",
        progressive_disabled_hint:
          "La retraite progressive est désactivée pour cette opération. Un administrateur peut l'activer dans les réglages de l'opération.",
        parcours_capability_aonProduction: "Prise en charge par la production Aon",
        parcours_capability_appointments: "Prise de rendez-vous",
        parcours_capability_hotline: "Hotline téléphonique",
        parcours_capability_aiAssistant: "Assistant IA",
        parcours_capability_messaging: "Messagerie",
        parcours_capability_anomaliesBank: "Relevé d'anomalies de carrière",
        parcours_capability_rachatRestitution: "Restitution du rachat de trimestres",
        parcours_capability_retraiteProgressive: "Retraite progressive",
        parcours_capability_scenarioComparison: "Analyse comparée des scénarios",
        parcours_capability_vipQuestions: "Questions complémentaires VIP",
        parcours_capability_tranchecArbitrage: "Arbitrage et ROI Tranche C",
        parcours_capability_chomageScenario: "Scénario chômage",
        chomage_scenario_label: "Proposer le scénario chômage",
        chomage_scenario_hint:
          "Inclus d'office en parcours VIP. Pour les autres parcours, le service RH peut aussi le demander dossier par dossier.",
        rachat_enabled_label: "Autoriser la simulation avec rachat de trimestres",
        rachat_enabled_hint:
          "Si désactivé, l'option de rachat n'apparaît pas dans les simulations du salarié.",
        max_age_policy_label: "Date de départ maximale simulable",
        max_age_policy_hint:
          "Borne haute. Les départs plus précoces et le taux plein naturel restent toujours proposés.",
        max_age_tpn: "Taux plein naturel (aucune date libre)",
        max_age_65: "Jusqu'à 65 ans",
        max_age_67: "Jusqu'à 67 ans",
        max_age_libre: "Libre (aucune limite)",
        simulations_max_label: "Simulations max par salarié (12 mois)",
        simulations_max_placeholder: "Illimité",
        simulations_max_hint:
          "Nombre de calculs lancés par le salarié sur 12 mois glissants. Vide = illimité. L'équipe Aon n'est pas décomptée.",
        rdv_duration_label: "Durée d'un rendez-vous de restitution",
        rdv_duration_option: "{{minutes}} minutes",
        rdv_duration_hint:
          "Durée vendue au client. Les créneaux ouverts pour cette opération suivent cette durée et un salarié ne peut pas réserver plus long.",
        dates_imposees_label: "Dates de départ imposées par l'entreprise",
        dates_imposees_hint:
          "Jusqu'à 6 dates simulées pour tous les salariés de l'opération, en plus de leurs propres scénarios. Elles apparaissent dans la synthèse du BRI comme « date fixée par l'entreprise ».",
        dates_imposees_add: "Ajouter une date",
        dates_imposees_remove: "Retirer",
        bri_selection_section: "Simulations présentées dans le BRI par défaut",
        bri_selection_hint:
          "Fléchage client : scénarios présentés dans le BRI des dossiers de cette opération, dans cet ordre. Tout coché ou tout décoché = toutes les simulations ; le consultant peut affiner dossier par dossier.",
        bri_selection_progressive: "Retraite progressive : quotités présentées",
        annexes_section: "Fiches annexes du BRI",
        annexes_hint:
          "Fiches de la bibliothèque jointes en fin de BRI pour les dossiers de cette opération. Par défaut, la sélection du groupe client s'applique.",
        annexes_mode_inherit: "Hériter du groupe client",
        annexes_mode_custom: "Sélection propre à l'opération",
        annexes_empty: "Aucune fiche annexe active dans la bibliothèque.",
        population_cible: "Population cible",
        description: "Description (visible client)",
        notes_internes: "Notes internes (Aon uniquement)",
        placeholder_operation_name: "BRI Senior 2026",
        placeholder_slug: "bri-senior-2026",
        placeholder_population: "Ex : Seniors 58 ans et +, cadres dirigeants, BU France…",
        placeholder_description: "Objectifs, population cible, contexte…",
        placeholder_notes: "Engagement, contraintes, particularités…",
        attachment_group: "Groupe (toutes sociétés)",
        attachment_societe: "Société",
        attachment_filiale: "Filiale",
        bri_type_flash: "Flash",
        bri_type_standard: "Standard",
        bri_type_vip: "VIP / Dirigeants",
        search_group: "Rechercher un groupe…",
        search_societe: "Rechercher une société…",
        search_filiale: "Rechercher une filiale…",
        errors: {
          name_required: "Nom obligatoire",
          slug_format: "Slug : lettres minuscules, chiffres, tirets",
          group_required: "Groupe requis",
          societe_required: "Société requise",
          filiale_required: "Filiale requise",
          salary_band_required: "Catégorie de salaire requise",
        },
      },
    },
    aiCosts: {
      kicker: "Administration",
      title: "Coûts IA (OpenAI)",
      description:
        "Suivi précis de la consommation OpenAI : coût par requête, modèle, fonctionnalité et utilisateur.",
      period_days: "{{n}} jours",
      kpi_cost: "Coût total",
      kpi_requests: "Requêtes",
      kpi_avg: "Coût moyen / requête",
      kpi_cache: "Tokens en cache",
      chart_title: "Coût par jour",
      chart_desc: "Total {{usd}} $ sur la période, converti au taux configuré par modèle.",
      chart_cost: "Coût (EUR)",
      by_model: "Par modèle",
      by_feature: "Par fonctionnalité",
      by_user: "Top utilisateurs",
      pricing_title: "Barème de prix par modèle",
      pricing_desc:
        "Prix OpenAI (USD / 1M tokens) utilisés pour chiffrer chaque requête. À mettre à jour si OpenAI change ses tarifs.",
      col_model: "Modèle",
      edit_pricing: "Modifier le barème : {{model}}",
      field_rate: "Taux de conversion USD vers EUR",
    },
    usageStats: {
      kicker: "Administration",
      title: "Statistiques d'usage",
      description:
        "Volume d'appels à l'API de calcul retraite (calculs et imports RIS), avec unité de temps réglable.",
      period_days: "{{n}} jours",
      unit_label: "Unité",
      unit_day: "Jour",
      unit_week: "Semaine",
      unit_month: "Mois",
      kpi_harvest_calls: "Appels API",
      kpi_harvest_calls_hint: "{{calc}} calculs · {{ris}} imports RIS",
      kpi_success: "Taux de succès",
      kpi_duration: "Durée moyenne",
      kpi_failures: "Échecs",
      harvest_chart_title: "Appels dans le temps",
      harvest_chart_desc:
        "Calculs réussis / en échec, imports RIS et durée moyenne d'un calcul par période.",
      harvest_ok: "Calculs réussis",
      harvest_ko: "Calculs en échec",
      harvest_ris: "Imports RIS",
      harvest_duration: "Durée moyenne",
      harvest_mix_title: "Répartition des appels",
      harvest_mix_desc: "Origine des calculs sur la période.",
      harvest_parcours: "Parcours (estimation)",
      harvest_simulations: "Simulations à la demande",
    },
    settings: {
      kicker: "Administration",
      title: "Paramètres",
      description: "Réglages globaux de la plateforme, appliqués à tous les espaces.",
      parcours_title: "Paramétrage du parcours de simulation",
      parcours_desc: "Ces réglages sont désormais définis opération par opération.",
      parcours_item_max_age:
        "Date de départ maximale simulable (taux plein naturel, 65 ou 67 ans).",
      parcours_item_rachat: "Simulation avec ou sans rachat de trimestres.",
      parcours_item_formation: "Formation obligatoire ou non avant l'accès au parcours.",
      parcours_item_quota: "Nombre de simulations autorisées par salarié sur 12 mois glissants.",
      parcours_hint:
        "Ouvrez une opération puis la section « Parcours de simulation » du formulaire. Un conseiller Aon peut en plus débrider un dossier précis depuis sa fiche.",
      parcours_cta: "Aller aux opérations",
      urgence_title: "Dossiers urgents",
      urgence_desc:
        "Marquage automatique selon la proximité du départ, et délai cible de traitement.",
      urgence_auto_mois_label: "Marquage automatique (mois avant le départ)",
      urgence_auto_mois_hint:
        "Un dossier non restitué devient urgent quand la date de départ visée ou la date de sortie connue est à moins de ce nombre de mois (1 à 24).",
      urgence_delai_label: "Délai cible de traitement (jours ouvrés)",
      urgence_delai_hint:
        "Au-delà, une alerte « délai dépassé » est émise au chef de projet et au consultant (1 à 60, lundi à vendredi).",
      saved: "Paramètres enregistrés.",
      bri_legal_title: "Texte juridique du BRI",
      bri_legal_desc:
        "Mention apposée au bas des pages de résultats du support BRI (synthèse, régimes, hypothèses). À faire valider par le juridique Aon ; applicable immédiatement aux prochains documents générés.",
      bri_legal_lang_fr: "Français",
      bri_legal_lang_en: "Anglais",
      bri_legal_lang_es: "Espagnol",
      bri_legal_hint:
        "Laissez un champ vide pour utiliser le texte par défaut (affiché en grisé). Deux à trois lignes maximum : au-delà, le texte est tronqué dans le PDF.",
      bri_legal_save: "Enregistrer le texte juridique",
      calc_title: "Hypothèses de calcul",
      calc_desc: "Dérives de projection appliquées par le moteur de calcul.",
      calc_pass_label: "Dérive annuelle du PASS (%)",
      calc_salaires_label: "Revalorisation annuelle du salaire par défaut (%)",
      calc_salaires_help: "Valeur proposée au salarié, qu'il peut ajuster dans son parcours.",
      calc_point_service:
        "Valeur de service du point : 0 % (valeur en vigueur à la date du calcul)",
      calc_point_achat: "Valeur d'achat du point : selon le moteur de calcul",
      calc_hint:
        "Ces réglages s'appliquent aux prochains calculs : les dossiers déjà calculés ne sont pas recalculés.",
      calc_save: "Enregistrer les hypothèses",
      drh_reporting_title: "Reporting DRH",
      drh_reporting_desc: "Réglages du reporting agrégé et anonymisé mis à disposition des DRH.",
      drh_seuil_label: "Seuil d'anonymat (nombre minimum de salariés)",
      drh_seuil_help: "En dessous de ce nombre, les effectifs sont masqués dans le reporting DRH.",
      drh_reporting_save: "Enregistrer le seuil",
      bri_calc_title: "Calculs du BRI",
      bri_calc_desc:
        "Taux de prélèvements affichés dans le document BRI et seuil de la mention « petite pension ». À mettre à jour chaque 1er janvier.",
      bri_calc_charges_label: "Charges sociales sur salaire (%)",
      bri_calc_charges_help:
        "Affiché dans le BRI et appliqué à l'estimation du salaire net à temps partiel (retraite progressive).",
      bri_calc_suppl_label: "Prélèvements sur la retraite supplémentaire (%)",
      bri_calc_source_label: "Source des taux",
      bri_calc_date_label: "Taux en vigueur au",
      bri_calc_seuil_label: "Seuil de petite pension (€ brut / mois)",
      bri_calc_seuil_help:
        "En dessous de ce montant, le BRI mentionne le versement forfaitaire unique possible.",
      bri_calc_hint:
        "Les taux de prélèvements des retraites de base et complémentaire ne se règlent pas ici : ils sont recalculés par le moteur à partir des montants bruts et nets de chaque dossier.",
      bri_calc_save: "Enregistrer les réglages du BRI",
      legal_privacy_title: "Engagement de confidentialité Aon",
      legal_privacy_desc:
        "Texte présenté au salarié dans une fenêtre bloquante à sa première connexion, puis à chaque nouvelle version exigeant une réacceptation.",
      legal_ia_conditions_title: "Conditions d'utilisation de l'IA",
      legal_ia_conditions_desc:
        "Texte de la section « Intelligence artificielle » de la page Confidentialité (publique).",
      legal_ia_mention_title: "Mention courte IA",
      legal_ia_mention_desc:
        "Phrase affichée sous l'analyse Noa et l'assistant, avec un lien « En savoir plus » vers la page Confidentialité.",
      legal_version: "Version {{version}}",
      legal_published_at: "Publiée le {{date}} par {{author}}",
      legal_lang_fr: "Français",
      legal_lang_en: "Anglais",
      legal_lang_es: "Espagnol",
      legal_minor_fix: "Correction mineure : ne pas redemander l'acceptation aux salariés",
      legal_publish: "Publier la version {{version}}",
      legal_publish_confirm_title: "Publier la version {{version}} ?",
      legal_publish_confirm_desc:
        "Les salariés devront relire ce texte et l'accepter de nouveau à leur prochaine connexion pour accéder à leur espace.",
      legal_versions: "Versions précédentes",
      legal_reaccept_yes: "Réacceptation requise",
      legal_reaccept_no: "Correction mineure",
      nav_sections: "Sections des paramètres",
      last_modified: "Modifié le {{date}} à {{time}} par {{author}}",
      section_parcours: "Parcours salarié",
      section_calculs: "Calculs",
      section_bri: "BRI",
      section_textes_legaux: "Consentements et textes légaux",
      section_ia: "Intelligence artificielle",
      section_reporting_drh: "Reporting DRH",
      section_securite: "Sécurité",
      mfa_title: "Double authentification",
      mfa_desc:
        "Populations pour lesquelles la double authentification (application TOTP) est obligatoire.",
      mfa_aon_label: "Internes Aon",
      mfa_aon_desc: "Administrateurs, chefs de projet et consultants Aon.",
      mfa_drh_label: "DRH",
      mfa_drh_desc: "Utilisateurs côté client avec le rôle DRH.",
      mfa_salarie_label: "Salariés",
      mfa_salarie_desc: "Désactivé par défaut : ils peuvent l'activer depuis leur profil.",
      mfa_warning:
        "Activer une population oblige tous ses utilisateurs à enrôler une application d'authentification à la prochaine page chargée. Prévenez-les avant d'activer.",
      mfa_save: "Enregistrer les réglages de sécurité",
      bri_taux_title: "Taux de prélèvements sociaux",
      bri_taux_desc:
        "Taux affichés dans le document BRI pour les prélèvements sur salaire et sur la retraite supplémentaire.",
      bri_taux_save: "Enregistrer les taux",
      bri_petite_pension_title: "Mention des très petites pensions",
      bri_petite_pension_desc:
        "Seuil en dessous duquel le BRI signale le versement forfaitaire unique possible, selon les règles de la caisse.",
      bri_petite_pension_save: "Enregistrer le seuil",
      noa_facts_title: "Le saviez-vous ?",
      noa_facts_desc:
        "Phrases affichées pendant la génération de l'analyse Noa. Toute modification est visible immédiatement par tous les utilisateurs.",
      noa_facts_hint:
        "Seules les phrases actives défilent, dans l'ordre affiché. Les traductions vides retombent sur le français.",
      noa_facts_empty: "Aucune phrase : le bloc ne s'affiche pas pendant l'analyse.",
      noa_facts_add: "Ajouter une phrase",
      noa_facts_edit: "Modifier",
      noa_facts_delete: "Supprimer",
      noa_facts_move_up: "Monter",
      noa_facts_move_down: "Descendre",
      noa_facts_translations: "Traductions (EN, ES)",
      noa_facts_active: "Visible pendant l'analyse",
      noa_facts_fr_label: "Français (obligatoire)",
      noa_facts_en_label: "Anglais",
      noa_facts_es_label: "Espagnol",
      noa_facts_edit_title: "Modifier la phrase",
      noa_facts_new_title: "Nouvelle phrase",
      noa_facts_save: "Enregistrer la phrase",
      noa_facts_delete_title: "Supprimer cette phrase ?",
      noa_facts_delete_desc:
        "Elle ne sera plus affichée pendant la génération des analyses. Cette action est définitive.",
    },
    audit: {
      kicker: "Administration",
      title: "Journal d'audit",
      description: "Traçabilité des accès et actions sur les dossiers, salariés et accès (RGPD).",
      search_placeholder: "Action, email, entité…",
      export: "Exporter (CSV)",
      exporting: "Export…",
      no_events: "Aucun événement",
      empty_title: "Journal vide pour l'instant",
      empty_description:
        "Les actions sensibles (création, modification, suppression sur les dossiers, salariés et accès) seront journalisées ici dès qu'elles surviennent.",
      no_events_description: "Aucun événement ne correspond à ces filtres.",
      category: "Catégorie",
      category_auth: "Authentification",
      category_read: "Consultation",
      category_write: "Écriture",
      category_export: "Export",
      category_delete: "Suppression",
      category_system: "Système",
      category_help_auth: "Connexions et déconnexions à la plateforme.",
      category_help_read: "Consultations d'informations (simple lecture).",
      category_help_write: "Créations et modifications d'informations.",
      category_help_export: "Téléchargements et exports de données (ex. fichiers CSV).",
      category_help_delete: "Suppressions d'informations.",
      category_help_system: "Actions techniques automatiques de la plateforme.",
      outcome: "Résultat",
      outcome_success: "Succès",
      outcome_failure: "Échec",
      outcome_denied: "Refusé",
      actor: "Acteur",
      entity: "Entité",
      action: "Action",
      timestamp: "Date et heure",
      from: "Du",
      to: "Au",
      events: "événements",
      help_title: "À quoi sert cette page ?",
      help_description:
        "Ce journal liste, de façon lisible, qui a fait quoi et quand sur la plateforme : connexions, créations, modifications, suppressions et exports. Cliquez sur une ligne pour voir le détail. Aucune donnée personnelle sensible n'y est conservée.",
      show_legend: "Comprendre les catégories",
      hide_legend: "Masquer la légende",
      no_detail: "Aucun détail disponible.",
      status_change: "Changement de statut :",
      affected_fields: "Informations concernées ({{count}})",
      tech_ref: "Référence technique",
      collapse: "Replier",
      expand: "Déplier",
      system: "Système",
      action_login: "S'est connecté(e) à la plateforme",
      action_logout: "S'est déconnecté(e)",
      action_auth_generic: "Action d'authentification",
      action_mfa_codes_generated: "A régénéré ses codes de secours (2FA)",
      action_mfa_recovery_used: "S'est reconnecté(e) avec un code de secours (2FA)",
      action_mfa_recovery_failed: "Code de secours 2FA refusé",
      action_mfa_reset: "A réinitialisé la double authentification d'un utilisateur",
      action_export: "A exporté des données",
      action_read: "A consulté {{entity}}",
      action_create: "A créé {{entity}}",
      action_update: "A modifié {{entity}}",
      action_delete: "A supprimé {{entity}}",
      entity_dossier_indef: "un dossier",
      entity_dossier_def: "le dossier",
      entity_salarie_indef: "un salarié",
      entity_salarie_def: "le salarié",
      entity_bri_indef: "un bilan retraite",
      entity_bri_def: "le bilan retraite",
      entity_document_indef: "un document",
      entity_document_def: "le document",
      entity_user_role_indef: "un rôle utilisateur",
      entity_user_role_def: "le rôle utilisateur",
      entity_user_scope_indef: "un périmètre d'accès",
      entity_user_scope_def: "le périmètre d'accès",
      entity_operation_indef: "une opération",
      entity_operation_def: "l'opération",
      entity_societe_indef: "une société",
      entity_societe_def: "la société",
      entity_groupe_indef: "un groupe",
      entity_groupe_def: "le groupe",
      entity_settings_indef: "un paramètre",
      entity_settings_def: "le paramètre",
      entity_noa_fact_indef: "une phrase « Le saviez-vous ? »",
      entity_noa_fact_def: "la phrase « Le saviez-vous ? »",
      value_empty: "vide",
      field_actif: "Actif",
      field_position: "Position",
      field_assigned_consultant: "Consultant assigné",
      field_assigned_chef_projet: "Chef de projet assigné",
      field_assigned_reviewer: "Relecteur assigné",
      field_assigned_restitution_consultant: "Consultant de restitution assigné",
      field_prenom: "Prénom",
      field_email_pro: "E-mail professionnel",
      field_email_correspondance: "E-mail de correspondance",
      field_email_perso: "E-mail personnel",
      field_date_naissance: "Date de naissance",
      field_civilite: "Civilité",
      field_code_postal: "Code postal",
      field_adresse: "Adresse",
      field_ville: "Ville",
      field_salaire_annuel_declare: "Salaire annuel déclaré",
      field_salaire_annuel_confirme: "Salaire annuel confirmé",
      field_nombre_enfants: "Nombre d'enfants",
      field_role: "Rôle",
      field_scope_type: "Type de périmètre",
      field_scope_id: "Périmètre concerné",
      field_nom_commercial: "Nom commercial",
      field_raison_sociale: "Raison sociale",
      field_siren: "SIREN",
      field_bri_type: "Type de bilan",
      field_is_active: "Actif",
      gdpr_notice:
        "Journal RGPD : seules les colonnes modifiées sont conservées, jamais les valeurs métier. Accès réservé à l'administration Aon.",
    },
    pappers: {
      label_default: "Pré-remplissage par SIREN/SIRET",
      aria_label: "Recherche d'entreprise par SIREN/SIRET",
      field_siren: "SIREN (9 chiffres)",
      field_siret: "SIRET (14 chiffres)",
      search: "Rechercher",
      success: "Données récupérées : {{name}}",
      hint_siren:
        "Saisissez le SIREN de la société pour pré-remplir nom, raison sociale, SIRET, code NAF et adresse du siège.",
      hint_siret:
        "Saisissez le SIRET (14 chiffres) de la filiale pour récupérer son nom et vérifier sa rattachée à la société parente.",
    },
    branding: {
      kicker: "Administration",
      title: "Branding par tenant",
      description:
        "Cobranding Aon x Société. Hérite par cascade : Opération > Site > BU > Filiale > Société > Groupe > Aon.",
      search_placeholder: "Nom, slug…",
      overrides_count_one: "override de branding actif sur la plateforme.",
      overrides_count_other: "overrides de branding actifs sur la plateforme.",
      entities_count_one: "{{count}} entité",
      entities_count_other: "{{count}} entités",
      tabs: {
        societes: "Sociétés",
        groupes: "Groupes",
        operations: "Opérations",
      },
      empty: {
        societes_title: "Aucune société",
        societes_hint:
          "Créez une société depuis l'onglet Tenants pour pouvoir éditer son branding.",
        groupes_title: "Aucun groupe",
        groupes_hint: "Créez un groupe depuis l'onglet Tenants pour pouvoir éditer son branding.",
        operations_title: "Aucune opération",
        operations_hint:
          "Créez une opération depuis l'onglet Opérations pour pouvoir éditer son branding.",
      },
      status: {
        active: "Branding actif",
        inherit: "Hérite",
      },
      actions: {
        configure: "Configurer",
        edit: "Modifier",
        details: "Détails",
        delete: "Supprimer",
        delete_aria: "Supprimer le branding",
      },
      delete_confirm: {
        title: "Supprimer ce branding ?",
        description: "Le scope reviendra aux valeurs héritées du parent.",
      },
      scope_labels: {
        groupe: "Groupe",
        societe: "Société",
        filiale: "Filiale",
        business_unit: "Business Unit",
        site: "Site",
        operation: "Opération",
      },
      fields: {
        product_name: "Nom produit",
        product_tagline: "Tagline",
        font_sans: "Font sans",
        font_display: "Font display",
        footer_legal: "Footer légal",
        brand: "Brand",
        brand_foreground: "Texte sur brand",
        brand_hover: "Brand hover",
        brand_muted: "Brand muted",
        accent: "Accent",
        accent_foreground: "Texte sur accent",
      },
      drawer: {
        title: "Branding · {{scope}}",
        description: "Niveau {{level}}. Les valeurs vides hériteront du parent.",
        identity_title: "Identité produit",
        identity_name_label: "Nom produit affiché",
        identity_name_placeholder: "ex. BRI TotalEnergies",
        identity_tagline_label: "Tagline / sous-titre",
        identity_tagline_placeholder: "Le BRI personnalisé Aon x {Société}",
        colors_title: "Couleurs",
        preview_title: "Aperçu",
        preview_primary: "Bouton principal",
        preview_secondary: "Bouton secondaire",
        preview_session: "Prévisualiser sur ma session",
        preview_restore: "Restaurer le branding actuel",
        logos_title: "Logos & favicon",
        logo_light_label: "Logo (fond clair)",
        logo_light_hint: "Affiché dans la barre latérale et l'en-tête · PNG, JPG, WEBP ou SVG",
        logo_dark_label: "Logo (fond sombre)",
        logo_dark_hint: "Variante claire pour les fonds sombres (optionnel)",
        favicon_label: "Favicon",
        favicon_hint: "Icône de l'onglet navigateur · PNG, SVG ou ICO",
        typography_title: "Typographie",
        font_sans_label: "Font sans-serif (CSS stack)",
        font_sans_placeholder: '"Inter", system-ui, sans-serif',
        font_display_label: "Font display (CSS stack)",
        font_display_placeholder: '"Helvetica Now Display", "Helvetica Neue", sans-serif',
        legal_title: "Mentions légales (footer PDF)",
        footer_label: "Texte du footer",
        footer_placeholder: "Mentions spécifiques (siège, ORIAS, etc.)",
        color_format_error: "Format attendu : #RRGGBB ou triplet HSL (ex. 354 100% 46%)",
        hsl_detected: "Triplet HSL détecté",
        cancel: "Annuler",
        save: "Enregistrer",
      },
    },
    email_templates: {
      kicker: "Administration",
      title: "Templates emails",
      description: "Gérez les modèles d'emails envoyés par la plateforme.",
      add: "Nouveau template",
      edit: "Modifier le template",
      kind: "Type",
      subject: "Objet",
      body: "Corps",
      preview: "Aperçu",
      no_templates: "Aucun template configuré.",
      variables: "Variables disponibles",
    },
    onboarding: {
      kicker: "Administration · Embarquement",
      title: "Lancer une nouvelle entreprise",
      description:
        "En 4 étapes guidées : on crée l'entreprise (et son groupe), sa structure interne (BU, sites), sa campagne BRI et ses options, puis on invite les premiers salariés. Tout est pré-rempli au maximum — vous pourrez tout affiner ensuite.",
      step_company: "Entreprise",
      step_structure: "BU & sites",
      error_create_group: "Échec de la création du groupe.",
      error_create_structure: "Échec de la création des BU / sites.",
      field_group_new: "Ou créer un nouveau groupe",
      field_group_new_placeholder: "Nom du groupe (ex. Groupe Bouygues)",
      field_group_new_hint: "Facultatif : le groupe sera créé et la société y sera rattachée.",
      structure_section_title: "Structure interne (facultatif)",
      structure_section_desc:
        "Déclarez les Business Units et les sites géographiques de {{company}} : ils servent au rattachement des salariés et aux périmètres d'accès RH.",
      bu_title: "Business Units",
      bu_hint: "Directions, divisions ou BU utilisées pour segmenter la population.",
      bu_add: "Ajouter une BU",
      bu_name_placeholder: "Ex. Direction Industrielle",
      sites_title: "Sites géographiques",
      sites_hint: "Établissements ou sites physiques de rattachement des salariés.",
      site_add: "Ajouter un site",
      site_name_placeholder: "Ex. Siège — La Défense",
      site_ville_placeholder: "Ville",
      structure_field_name: "Nom",
      structure_field_ville: "Ville",
      structure_created: "Créé",
      structure_remove: "Retirer la ligne",
      structure_skip_hint:
        "Cette étape est facultative : vous pouvez continuer sans BU ni site et les ajouter plus tard depuis la fiche client.",
      options_section_title: "Options du parcours",
      step_operation: "Opération BRI",
      step_employees: "Salariés",
      step_summary: "C'est prêt",
      back: "Retour",
      continue: "Continuer",
      finish_without_employee: "Terminer sans salarié",
      create_employees: "Créer {{count}} salarié",
      create_employees_plural: "Créer {{count}} salariés",
      onboard_another: "Embarquer une autre entreprise",
      see_operations: "Voir les opérations",
      company_section_title: "L'entreprise cliente",
      company_section_desc:
        "Saisissez le SIREN pour pré-remplir automatiquement, ou renseignez le nom à la main.",
      pappers_hint:
        "Pré-remplit le nom, la raison sociale, le SIRET, le code NAF et l'adresse du siège.",
      field_company_name: "Nom de l'entreprise",
      field_slug: "Identifiant",
      field_group: "Rattacher à un groupe (optionnel)",
      field_group_placeholder: "Aucun groupe",
      field_group_search: "Rechercher un groupe…",
      field_siren: "SIREN",
      field_raison_sociale: "Raison sociale",
      field_adresse: "Adresse",
      field_code_postal: "Code postal",
      field_ville: "Ville",
      drh_section_title: "Contact RH / DRH (optionnel)",
      field_drh_nom: "Nom du contact",
      field_drh_email: "Email",
      field_drh_tel: "Téléphone",
      operation_section_title: "La campagne BRI",
      operation_section_desc:
        "Une opération est la campagne de bilans retraite rattachée à {{company}}.",
      operation_section_desc_default: "l'entreprise",
      field_operation_name: "Nom de l'opération",
      field_operation_year: "Année",
      field_bri_type: "Type de BRI",
      bri_type_hint:
        "S'applique à tous les dossiers de l'opération. En BRI flash, le salarié doit indiquer ses souhaits avant d'accéder à son BRI.",
      field_salary_band: "Catégorie de salaire",
      salary_band_placeholder: "Sélectionner une catégorie",
      salary_band_hint:
        "Les salariés d'une opération à catégorie unique en héritent ; en opération mixte, la catégorie est renseignée salarié par salarié.",
      field_status: "Statut",
      field_population: "Population cible (optionnel)",
      population_placeholder: "Ex : Seniors 58 ans et +, cadres dirigeants…",
      bri_type_flash: "Flash",
      bri_type_standard: "Standard",
      bri_type_vip: "VIP / Dirigeants",
      status_draft: "Brouillon",
      status_planned: "Planifiée",
      status_ongoing: "En cours",
      employees_section_title: "Les premiers salariés",
      employees_section_desc:
        "Ajoutez quelques salariés rattachés à {{operation}}. Vous pourrez en importer en masse plus tard depuis l'écran Salariés.",
      field_firstname: "Prénom",
      field_lastname: "Nom",
      field_email: "Email",
      email_placeholder: "prenom.nom@entreprise.fr",
      add_employee: "Ajouter un salarié",
      remove_employee: "Retirer ce salarié",
      send_invitation_label: "Envoyer l'invitation par email",
      send_invitation_desc:
        "Chaque salarié avec un email recevra un lien sécurisé pour accéder à son parcours retraite.",
      done_title: "Entreprise embarquée !",
      done_desc: "{{company}} et sa campagne {{operation}} sont créées.",
      done_tile_company: "Entreprise",
      done_tile_operation: "Opération",
      done_tile_employee: "Salarié",
      done_tile_employees: "Salariés",
      done_invited_one: "{{count}} invité",
      done_invited_plural: "{{count}} invités",
      done_link_intro: "Retrouvez l'entreprise dans",
      done_link_clients: "Clients",
      done_link_and: "et la campagne dans",
      done_link_operations: "Opérations",
      error_company_name: "Le nom de l'entreprise est obligatoire.",
      error_slug_format:
        "L'identifiant (slug) doit contenir uniquement des lettres minuscules, chiffres et tirets.",
      error_company_missing: "Veuillez d'abord créer l'entreprise.",
      error_operation_name: "Le nom de l'opération est obligatoire.",
      error_operation_salary_band: "Choisissez une catégorie de salaire pour l'opération.",
      error_email_required:
        "Un email est requis pour inviter {{name}}. Désactivez les invitations ou renseignez l'email.",
      error_create_company: "Échec de la création de l'entreprise.",
      error_create_operation: "Échec de la création de l'opération.",
      error_create_employee: "Échec de la création d'un salarié.",
      error_company_incomplete: "Entreprise manquante.",
    },
    formations: {
      kicker: "Administration",
      title: "Formations",
      description: "Gérez les sessions de formation et l'émargement.",
    },
    document_types: {
      kicker: "Administration",
      title: "Types de documents",
      description:
        "Catalogue des pièces demandables dans un dossier. Les types « socle » sont proposés à chaque salarié ; les autres s'activent par parcours dans la fiche opération.",
      new_type: "Nouveau type",
      catalogue: "Catalogue",
      empty: "Aucun type de document.",
      badge_core: "Socle",
      badge_required: "Obligatoire",
      badge_inactive: "Inactif",
      aria_edit: "Modifier",
      aria_delete: "Supprimer",
      core_no_delete: "Type socle non supprimable",
      dialog_title_new: "Nouveau type de document",
      dialog_title_edit: "Modifier le type de document",
      field_label: "Libellé",
      field_label_placeholder: "Ex. : Relevé de retraite supplémentaire",
      field_slug: "Identifiant (slug)",
      field_slug_hint: "Non modifiable : référencé par les parcours et les documents déposés.",
      field_kind: "Catégorie de stockage",
      field_description: "Description (aide au dépôt)",
      field_description_placeholder: "Expliquez au salarié quelle pièce déposer et où la trouver.",
      field_position: "Position",
      translations_title: "Traductions (EN / ES)",
      translations_hint:
        "Facultatif : libellé et description affichés aux salariés selon leur langue. À défaut, le français est utilisé.",
      field_label_en: "Libellé (anglais)",
      field_label_es: "Libellé (espagnol)",
      field_description_en: "Description (anglais)",
      field_description_es: "Description (espagnol)",
      check_core: "Socle (toujours proposé dans chaque parcours)",
      check_required: "Obligatoire par défaut",
      check_multiple: "Plusieurs fichiers autorisés",
      check_active: "Actif",
      delete_title: "Supprimer le type de document",
      delete_description:
        "Supprimer « {{label}} » ? Les parcours qui le demandent ne le proposeront plus. Les documents déjà déposés ne sont pas supprimés.",
      kind_ris: "Relevé de carrière (RIS)",
      kind_agirc_arrco: "Relevé Agirc-Arrco",
      kind_bulletin_salaire: "Bulletin de salaire",
      kind_justificatif_retraite_supp: "Retraite supplémentaire (PER, art. 83/39)",
      kind_justificatif_carriere: "Justificatif de carrière",
      kind_justificatif_penibilite: "Justificatif de pénibilité",
      kind_justificatif_handicap: "Justificatif de handicap",
      kind_autre: "Autre",
    },
    controle_qualite: {
      kicker: "Administration",
      title: "Fiche d'autocontrôle",
      description:
        "Grille de relecture à deux niveaux (N1 production / N2 chef de projet) à compléter avant la génération du BRI. Les points requis bloquent la validation du niveau.",
      info: "Ces points de contrôle apparaissent dans la fiche dossier (espace production) sous forme de cases à cocher. Un point marqué requis empêche la validation du niveau tant qu'il n'est pas coché.",
      level_n1_label: "N1 — Production",
      level_n2_label: "N2 — Chef de projet",
      level_n1_description: "Revue croisée (peer to peer) réalisée par un pair de la production.",
      level_n2_description: "Contrôle final du chef de projet avant mise à disposition.",
      add: "Ajouter",
      empty: "Aucun point de contrôle pour ce niveau.",
      badge_required: "Requis",
      badge_optional: "Optionnel",
      badge_inactive: "Inactif",
      dialog_title_new: "Nouveau point de contrôle",
      dialog_title_edit: "Modifier le point de contrôle",
      field_level: "Niveau",
      field_position: "Position",
      field_label: "Libellé",
      field_label_placeholder: "Ex. : RIS importé & carrière vérifiée",
      field_description: "Description (aide à la relecture)",
      field_description_placeholder: "Précisez ce que le contrôleur doit vérifier.",
      check_required: "Point requis (bloque la validation)",
      check_active: "Actif",
      cancel: "Annuler",
      save: "Enregistrer",
      delete_title: "Supprimer le point de contrôle",
      delete_description:
        "Supprimer « {{label}} » ? Les réponses déjà enregistrées sur les dossiers seront également supprimées.",
      delete_confirm: "Supprimer",
    },
    annexes_bri: {
      kicker: "Administration",
      title: "Annexes BRI",
      description:
        "Bibliothèque de fiches annexes (lexique, régimes, fiscalité...) insérables dans les supports BRI et sélectionnables comme annexes-type au niveau d'un groupe client.",
      new_annexe: "Nouvelle fiche",
      stat_total: "Fiches",
      stat_actives: "Actives",
      stat_avec_fichier: "Avec fichier",
      search_placeholder: "Rechercher un titre, un thème, un tag...",
      filter_all: "Toutes les thématiques",
      empty_title: "Aucune fiche",
      empty_filtered: "Aucun résultat pour ces filtres.",
      empty_description: "Créez votre première fiche annexe pour enrichir la bibliothèque.",
      create_first: "Créer une fiche",
      badge_inactive: "Inactive",
      action_open_file: "Ouvrir le fichier",
      action_deactivate: "Désactiver",
      action_activate: "Activer",
      action_edit: "Modifier",
      action_delete: "Supprimer",
      delete_title: "Supprimer cette fiche",
      delete_description: "« {{titre}} » sera définitivement supprimée.",
      delete_body:
        "La fiche disparaîtra de la bibliothèque et des sélections d'annexes-type des groupes.",
      delete_confirm: "Supprimer",
      drawer_title_new: "Nouvelle fiche annexe",
      drawer_title_edit: "Modifier la fiche annexe",
      drawer_description:
        "Fiche réutilisable insérée dans les supports BRI (lexique, régimes, fiscalité...).",
      field_titre: "Titre",
      field_slug: "Slug",
      field_slug_hint: "Identifiant unique.",
      field_thematique: "Thématique",
      field_description: "Description",
      field_description_hint: "Résumé du contenu de la fiche.",
      field_file: "Fichier de la fiche",
      field_file_hint_replace:
        "Un fichier est déjà associé. Sélectionnez-en un nouveau pour le remplacer.",
      field_file_hint_new: "PDF ou image (max 200 Mo). Optionnel - peut être ajouté plus tard.",
      file_replace: "Remplacer le fichier...",
      file_choose: "Choisir un fichier...",
      field_cover: "Image d'aperçu",
      field_cover_hint: "Optionnel. PNG, JPG, WEBP ou SVG · max 5 Mo.",
      field_tags: "Tags",
      field_tags_hint: "Séparés par des virgules.",
      switch_active_label: "Fiche active",
      switch_active_description: "Désactivez pour la retirer de la sélection sans la supprimer.",
      cancel: "Annuler",
      save: "Enregistrer",
      create: "Créer la fiche",
      thematique_lexique: "Lexique",
      thematique_regimes_speciaux: "Régimes spéciaux",
      thematique_fiscalite: "Fiscalité",
      thematique_cas_particuliers: "Cas particuliers",
      thematique_infographie: "Infographie",
      thematique_autre: "Autre",
    },
    rachat: {
      kicker: "Référentiel",
      title: "Barème rachat de trimestres",
      description:
        "Barème CNAV du versement pour la retraite (VPLR / dispositif Fillon), versionné par millésime. Le coût d'un trimestre dépend de l'âge, de la tranche de revenu (indexée sur le PASS) et de l'option. Ce barème alimente l'estimation de coût et de rentabilité dans le parcours retraite.",
      new_millesime: "Nouveau millésime",
      info_stable:
        "Le barème de coût est stable dans le temps (inchangé depuis ~11 ans) ; seuls les seuils de revenu évoluent chaque année (indexés sur le PASS). Mettez à jour le PASS/les seuils sur le millésime, et importez la grille de coûts officielle (circulaire CNAV) ci-dessous.",
      empty_title: "Aucun millésime",
      empty_description:
        "Créez un premier millésime (année + PASS + seuils de tranches) pour commencer.",
      active_badge: "Actif",
      activate: "Activer",
      pass: "PASS",
      tranche_label: "Tranche {{n}} / {{m}}",
      edit: "Modifier",
      delete_millesime_title: "Supprimer le millésime {{annee}} ?",
      delete_millesime_description:
        "Toutes les cellules de barème de ce millésime seront définitivement supprimées.",
      delete_confirm: "Supprimer",
      cancel: "Annuler",
      millesime_dialog_new: "Nouveau millésime",
      millesime_dialog_edit: "Millésime {{annee}}",
      millesime_dialog_description:
        "PASS et seuils de tranches de revenu (tranche 1 < seuil1 ≤ tranche 2 ≤ seuil2 < tranche 3).",
      field_annee: "Année",
      field_pass: "PASS (€)",
      field_seuil1: "Seuil tranche 1 (€)",
      field_seuil2: "Seuil tranche 2 (€)",
      field_libelle: "Libellé",
      field_source: "Source",
      libelle_placeholder: "Barème CNAV 2025",
      source_placeholder: "CNAV — Circulaire 2025-01",
      save: "Enregistrer",
      create: "Créer",
      error_annee: "Année invalide.",
      error_pass_seuils: "PASS et seuils doivent être des montants positifs.",
      error_seuil_order: "Le seuil tranche 1 doit être inférieur ou égal au seuil tranche 2.",
      bareme_title: "Barème {{annee}}",
      bareme_description: "Coût d'un trimestre par âge, tranche de revenu et option.",
      cells_filled_one: "{{count}} cellule renseignée",
      cells_filled_other: "{{count}} cellules renseignées",
      cells_total: " / {{total}}",
      import: "Importer",
      export_csv: "Exporter CSV",
      col_age: "Âge",
      col_tranche: "Tranche {{n}}",
      age_years: "{{age}} ans",
      option_taux_seul: "Taux seul",
      option_taux_duree: "Taux + durée",
      test_title: "Tester le coût (millésime actif)",
      test_field_age: "Âge",
      test_field_revenu: "Revenu annuel (€)",
      test_tranche: "Tranche",
      test_taux_seul: "Taux seul",
      test_taux_duree: "Taux + durée",
      test_per_trim: "{{value}} / trim.",
      test_no_active: "Aucun millésime actif.",
      test_not_found: "Barème non renseigné pour cette cellule (âge / tranche).",
      test_active_mismatch:
        "Note : le test utilise le millésime actif ({{active}}), pas {{current}}.",
      cell_dialog_title: "Coût d'un trimestre",
      cell_dialog_context: "{{age}} ans · Tranche {{tranche}} · {{option}}",
      cell_field_percent: "Pourcentage du revenu (%)",
      cell_field_euro: "Coût par trimestre (€)",
      cell_tranche2_hint:
        "Tranche 2 (revenu entre 75 % et 100 % du PASS) : le coût est un pourcentage appliqué au revenu moyen.",
      import_dialog_title: "Importer le barème {{annee}}",
      import_dialog_description:
        "Format CSV : une ligne par cellule — age;tranche;option;cout. Option = taux_seul ou taux_duree (ou OPTION_1 / OPTION_2).",
      import_example_title: "Exemple",
      import_tranche2_hint:
        "Pour la tranche 2 (revenu entre 75 % et 100 % du PASS), la valeur est un pourcentage du revenu (ex. 10.73), pas un montant en €.",
      import_field_csv: "Données CSV",
      import_placeholder: "Collez ici le barème officiel (age;tranche;option;cout)…",
      import_replace:
        "Remplacer entièrement le barème de ce millésime (sinon, fusion / mise à jour)",
      import_errors_more: "… et {{count}} autres.",
      import_button: "Importer",
      import_button_count: "Importer ({{count}})",
      import_error_empty: "Aucune cellule valide à importer.",
    },
    rgpd: {
      kicker: "Administration",
      title: "Demandes RGPD",
      description:
        "Suivi des demandes d'exercice des droits, conservation des données et réversibilité, conformément au RGPD.",
      tab_requests: "Demandes",
      tab_retention: "Conservation & réversibilité",
      requests: {
        export_csv: "Exporter (CSV)",
        stat_pending: "À traiter",
        stat_in_review: "En cours",
        stat_fulfilled: "Satisfaites",
        stat_overdue: "En retard",
        search_label: "Recherche",
        search_placeholder: "Email du demandeur, motif…",
        kind_label: "Type de droit",
        status_label: "Statut",
        reset: "Réinitialiser",
        empty_title_filtered: "Aucune demande",
        empty_title: "Aucune demande RGPD",
        empty_desc_filtered: "Aucune demande ne correspond à ces filtres.",
        empty_desc:
          "Les demandes d'exercice des droits déposées par les salariés ou leurs représentants apparaîtront ici pour traitement.",
        table_received: "Reçue le",
        table_requester: "Demandeur",
        table_kind: "Type de droit",
        table_status: "Statut",
        table_due: "Échéance",
        table_actions: "Actions",
        aria_expand: "Déplier",
        aria_collapse: "Replier",
        detail_reason: "Motif de la demande",
        detail_salarie: "Salarié concerné",
        detail_not_linked: "Non rattaché",
        detail_created: "Créée le",
        detail_due: "Échéance légale",
        detail_handled_by: "Pris en charge par",
        detail_handled_at: "Pris en charge le",
        detail_fulfilled_at: "Satisfaite le",
        detail_rejected_at: "Rejetée le",
        detail_rejection_reason: "Motif du rejet",
        salarie_label: "Salarié : {{name}}",
        action_generate_export: "Générer l'export",
        action_download: "Télécharger",
        action_take_in_charge: "Prendre en charge",
        action_fulfill: "Satisfaire",
        action_reject: "Rejeter",
        action_reopen: "Rouvrir",
        footer_note:
          "Conformément au RGPD, les demandes doivent être traitées sous un mois (échéance affichée). Le droit à l'effacement est encadré par les obligations légales de conservation des données.",
        reject_dialog_title: "Rejeter la demande",
        reject_dialog_desc:
          "Indiquez le motif du rejet (communiqué au demandeur). Cette action peut être annulée en rouvrant la demande.",
        reject_dialog_reason_label: "Motif du rejet",
        reject_dialog_reason_placeholder:
          "Ex. : demande hors périmètre, obligation légale de conservation…",
        reject_dialog_confirm: "Rejeter",
        kind_export: "Droit d'accès / portabilité",
        kind_effacement: "Droit à l'effacement",
        kind_rectification: "Droit de rectification",
        kind_opposition: "Droit d'opposition",
        kind_limitation: "Limitation du traitement",
        status_pending: "À traiter",
        status_in_review: "En cours",
        status_fulfilled: "Satisfaite",
        status_rejected: "Rejetée",
        csv_header_created_at: "created_at",
        csv_header_requester_email: "requester_email",
        csv_header_salarie: "salarie",
        csv_header_kind: "kind",
        csv_header_status: "status",
        csv_header_due_at: "due_at",
        csv_header_reason: "reason",
        csv_header_handled_by: "handled_by",
        csv_header_rejection_reason: "rejection_reason",
        csv_filename: "rgpd_{{date}}.csv",
      },
      retention: {
        title: "Conservation des données",
        description:
          "Durées de conservation par catégorie de donnée (RGPD — limitation de la conservation).",
        add: "Ajouter",
        empty: "Aucune politique définie.",
        edit_aria: "Modifier",
        delete_aria: "Supprimer",
        dialog_new: "Nouvelle politique de conservation",
        dialog_edit: "Modifier la politique",
        field_label: "Libellé",
        field_label_placeholder: "Ex. : Dossiers retraite",
        field_category: "Catégorie (clé)",
        field_category_placeholder: "Ex. : dossier_actif",
        field_months: "Durée de conservation (mois)",
        field_basis: "Base légale",
        field_basis_placeholder: "Ex. : Obligation légale",
        field_description: "Description",
        active_label: "Politique active",
        months_none: "Aucune conservation",
        months_year_one: "{{count}} an",
        months_year_other: "{{count}} ans",
        months_months_one: "{{count}} mois",
        months_months_other: "{{count}} mois",
        delete_title: "Supprimer la politique",
        delete_desc: "Supprimer la politique « {{label}} » ? Cette action est définitive.",
        delete_confirm: "Supprimer",
        reversibility_title: "Réversibilité des dossiers",
        reversibility_desc:
          "Restitution des données d'une société (export complet des salariés et dossiers, CDC §17d). Le fichier est généré au format JSON dans un stockage sécurisé.",
        export: "Exporter",
        no_societes: "Aucune société.",
        export_failed: "Échec de l'export",
      },
    },
    salaries: {
      kicker: "Administration",
      title: "Salariés",
      description: "Gestion complète des fiches salariés.",
      add: "Nouveau salarié",
      import: "Importer des salariés",
      search_placeholder: "Rechercher un salarié…",
      no_salaries: "Aucun salarié trouvé.",
      matricule: "Matricule",
      nom: "Nom",
      prenom: "Prénom",
      email: "Email",
      societe: "Société",
      operation: "Opération",
      status: "Statut",
      vip: "VIP",
      send_invitation: "Envoyer l'invitation",
      delete_confirm: "Supprimer ce salarié ?",
      parcours: "Parcours retraite",
      detail: "Fiche salarié",
    },
    roadmap: {
      kicker: "Administration",
      title: "Roadmap",
      description: "Suivi des fonctionnalités et de l'avancement du projet.",
    },
    controle: {
      kicker: "Administration",
      title: "Fiche d'autocontrôle",
      description: "Checklist qualité pour valider un dossier avant production.",
    },
    content_library: {
      views_title: "Consultations de la fiche",
      views_label_one: "{{count}} vue · dernière : {{last}}",
      views_label_other: "{{count}} vues · dernière : {{last}}",
      views_none: "Aucune vue",
      kicker: "Administration",
      title: "Bibliothèque de contenu",
      description:
        "Fiches, vidéos, articles et liens diffusés en lecture seule dans les espaces salarié, DRH et Aon selon leur ciblage.",
      new_button: "Nouveau contenu",
      stat_total: "Contenus",
      stat_published: "Publiés",
      stat_featured: "À la une",
      search_placeholder: "Rechercher un titre, un thème, un tag…",
      filter_all_types: "Tous les types",
      empty_title: "Aucun contenu",
      empty_filtered: "Aucun résultat pour ces filtres.",
      empty_none: "Créez votre premier contenu pour alimenter les espaces.",
      empty_create: "Créer un contenu",
      row_unpublish: "Dépublier",
      row_publish: "Publier",
      row_edit: "Modifier",
      row_delete: "Supprimer",
      row_draft: "Brouillon",
      row_featured: "À la une",
      delete_title: "Supprimer ce contenu",
      delete_description: "« {{title}} » sera définitivement supprimé.",
      delete_confirm: "Supprimer",
      delete_body: "Le contenu disparaîtra immédiatement des espaces qui le diffusent.",
      drawer_title_create: "Nouveau contenu",
      drawer_title_edit: "Modifier le contenu",
      drawer_description:
        "Fiche, vidéo, article ou lien — visible en lecture seule dans les espaces ciblés.",
      drawer_cancel: "Annuler",
      drawer_save: "Enregistrer",
      drawer_create: "Créer le contenu",
      drawer_error_unknown: "Erreur inconnue",
      tab_edit: "Édition",
      tab_preview: "Aperçu",
      field_title: "Titre",
      field_slug: "Slug",
      field_slug_hint: "Identifiant unique (URL).",
      field_duration: "Durée (min)",
      field_duration_hint: "Lecture / visionnage indicatif.",
      field_kind: "Type",
      field_category: "Catégorie",
      field_audiences: "Visible dans les espaces",
      field_audiences_hint: "Au moins un espace.",
      field_summary: "Résumé",
      field_summary_hint: "Une phrase affichée sur la carte.",
      field_body: "Contenu (markdown)",
      field_body_hint: "## Titres, **gras**, listes (-), citations (>), [liens](url).",
      field_url_video: "URL de la vidéo",
      field_url_video_hint: "YouTube ou Vimeo (embed automatique).",
      field_url_link: "URL du lien",
      field_url_link_hint: "Lien externe (service public, partenaire…).",
      field_file: "Fichier",
      field_file_optional: "Fichier vidéo (optionnel)",
      field_file_hint_doc: "PDF, Word, Excel ou PowerPoint (max 200 Mo).",
      field_file_hint_video: "Si pas d'URL YouTube/Vimeo, téléversez un mp4.",
      field_file_existing:
        "Un fichier est déjà associé. Sélectionnez-en un nouveau pour le remplacer.",
      field_file_replace: "Remplacer le fichier…",
      field_file_choose: "Choisir un fichier…",
      field_cover: "Image de couverture",
      field_cover_hint: "Optionnel. PNG, JPG, WEBP ou SVG · max 5 Mo.",
      field_tags: "Tags",
      field_tags_hint: "Séparés par des virgules.",
      switch_featured: "À la une",
      switch_featured_desc: "Mise en avant en tête de bibliothèque.",
      switch_published: "Publié",
      switch_published_desc: "Décochez pour masquer la ressource dans les espaces.",
      preview_hint: "Aperçu de la carte telle qu'elle apparaîtra dans les espaces ciblés.",
    },
    emailTemplates: {
      kicker: "Administration",
      title: "Templates emails",
      description:
        "Emails réellement envoyés par la plateforme : invitations, connexion par lien magique (OTP), réinitialisation de mot de passe et relances de dossier.",
      new_button: "Nouveau template",
      search_placeholder: "Rechercher un template, un mot dans l'objet…",
      all_kinds: "Tous les types",
      count_label: "{{count}} template",
      count_label_plural: "{{count}} templates",
      empty_title: "Aucun template",
      empty_filtered: "Aucun résultat pour ces filtres.",
      empty_create_first:
        "Créez votre premier template pour démarrer les communications automatiques.",
      empty_create_button: "Créer un template",
      edit_tooltip: "Modifier",
      delete_tooltip: "Supprimer",
      delete_title: "Supprimer ce template",
      delete_confirm: "Supprimer",
      delete_description: "« {{slug}} » sera définitivement supprimé.",
      delete_history_note:
        "Si ce template est référencé dans des envois passés, l'historique reste conservé mais le template ne sera plus utilisable.",
      badge_system: "Système",
      badge_inactive: "Inactif",
      kinds: {
        invitation: "Invitation (système)",
        otp_login: "Connexion OTP (système)",
        password_reset: "Réinitialisation mot de passe (système)",
        relance: "Relance dossier",
        evaluation_invitation: "Invitation à l'évaluation de la prestation",
        evaluation_relance: "Relance d'évaluation de la prestation",
      },
      variables: {
        prenom: "Prénom du destinataire",
        nom: "Nom du destinataire",
        magic_link: "Lien magique (invitation / OTP)",
        reset_link: "Lien de réinitialisation (mot de passe)",
        roles_label: "Rôles attribués (invitation utilisateur)",
        inviter_name: "Nom de l'invitant (invitation utilisateur)",
        societe: "Nom de la société (relance)",
        lien_dossier: "URL vers l'espace du salarié (relance)",
        consultant_nom: "Nom du consultant (relance)",
      },
      drawer: {
        new_title: "Nouveau template d'email",
        edit_title: "Modifier le template",
        description:
          "Emails système envoyés automatiquement par la plateforme (invitation, connexion OTP, réinitialisation de mot de passe)",
        cancel: "Annuler",
        save: "Enregistrer",
        create: "Créer le template",
        tab_edit: "Éditeur",
        tab_preview: "Aperçu",
        field_slug: "Slug",
        field_kind: "Type",
        field_langue: "Langue",
        field_langue_fr: "Français",
        field_langue_en: "English",
        field_scope: "Portée",
        scope_system: "Système",
        scope_operation: "Opération",
        scope_operation_disabled_title: "Lien à une opération à venir",
        field_subject: "Objet",
        field_subject_placeholder: "Bonjour {{prenom}}, votre BRI est disponible",
        field_body_html: "Corps HTML",
        field_body_html_hint:
          "Vous pouvez utiliser du HTML simple. Cliquez sur une variable pour l'insérer.",
        field_body_html_placeholder: "<p>Bonjour {{prenom}},</p>\n<p>Votre BRI…</p>",
        variables_available: "Variables disponibles",
        variables_hint: "Cliquez pour insérer dans le corps.",
        field_body_text: "Version texte (fallback)",
        field_body_text_hint: "Optionnel. Si vide, généré automatiquement à l'envoi.",
        preview_subject_label: "Objet",
        preview_rendered_label: "Aperçu rendu (variables remplacées)",
        preview_empty: "(vide)",
        preview_disclaimer: "Aperçu basé sur des données fictives ({{count}} variables).",
      },
    },
    messageTracking: {
      kicker: "Administration",
      title: "Suivi des messages",
      description:
        "Toutes les conversations en attente de réponse, triées par ancienneté. Un email de notification part déjà à chaque message : cet écran garantit qu'aucun échange ne reste en suspens.",
      badge_critical_one: "{{count}} conversation sans réponse depuis plus de 48 h",
      badge_critical_other: "{{count}} conversations sans réponse depuis plus de 48 h",
      stat_total: "Conversations actives",
      stat_aon: "Réponse attendue côté Aon",
      stat_client: "En attente du client",
      filter_aon: "À traiter par Aon ({{count}})",
      filter_client: "En attente du client ({{count}})",
      filter_all: "Toutes ({{count}})",
      empty_title: "Rien en attente",
      empty_description:
        "Toutes les conversations de ce filtre ont reçu une réponse. Beau travail.",
      list_title_one: "{{count}} conversation",
      list_title_other: "{{count}} conversations",
      channel_salarie_production: "Salarié ↔ Production",
      channel_drh_chefprojet: "RH ↔ Chef de projet",
      awaiting_aon: "Équipe Aon doit répondre",
      awaiting_client: "En attente du client",
      no_subject: "Conversation sans objet",
      waiting_less_than_hour: "moins d'une heure",
      waiting_hours: "{{count}} h",
      waiting_days_one: "{{count}} jour",
      waiting_days_other: "{{count}} jours",
      waiting_since: "Sans réponse depuis {{when}}",
      open: "Ouvrir",
    },
  },
  aon: {
    anomalies: {
      kicker: "Équipe Aon",
      title: "Bibliothèque d'anomalies",
      description:
        "Fiches d'anomalies de carrière réutilisables : explication destinée au salarié, démarche recommandée et pièces à demander. Rapprochées automatiquement des anomalies détectées par l'audit de carrière.",
      ia_hint:
        "Les fiches actives servent de base de connaissances à l'analyse Noa : l'IA reprend les formulations validées ici plutôt que d'improviser.",
      new_fiche: "Nouvelle fiche",
      catalogue: "Fiches",
      empty: "Aucune fiche d'anomalie.",
      badge_inactive: "Inactive",
      aria_edit: "Modifier",
      aria_delete: "Supprimer",
      dialog_title_new: "Nouvelle fiche d'anomalie",
      dialog_title_edit: "Modifier la fiche d'anomalie",
      field_label: "Libellé",
      field_label_placeholder: "Ex. : Baisse de rémunération inexpliquée",
      field_code: "Code",
      field_code_hint:
        "Utilisez le code du moteur d'audit (baisseRevenu, revenuNul…) pour le rapprochement automatique ; libre sinon.",
      field_position: "Position",
      field_explication: "Explication destinée au salarié",
      field_explication_placeholder:
        "Expliquez l'anomalie en langage clair, comme elle sera présentée au salarié.",
      field_recommandation: "Recommandation d'action",
      field_recommandation_placeholder: "Démarche validée à suivre pour corriger l'anomalie.",
      field_pieces: "Pièces à demander",
      field_pieces_placeholder: "Justificatifs à demander au salarié (bulletins, attestations…).",
      translations_title: "Traductions (EN / ES)",
      translations_hint:
        "Facultatif : contenus affichés selon la langue du salarié. À défaut, le français est utilisé.",
      field_label_tr: "Libellé traduit",
      field_explication_tr: "Explication traduite",
      field_recommandation_tr: "Recommandation traduite",
      field_pieces_tr: "Pièces traduites",
      check_active: "Fiche active (proposée aux consultants et à l'analyse IA)",
      delete_title: "Supprimer la fiche",
      delete_description:
        "Supprimer « {{label}} » ? La fiche ne sera plus proposée ni utilisée par l'analyse IA.",
      frequency_title: "Anomalies les plus fréquentes",
      frequency_hint:
        "Restitution consolidée sur l'ensemble des dossiers : anomalies détectées par l'audit de carrière et anomalies déclarées par les consultants.",
      frequency_count_one: "{{count}} dossier",
      frequency_count_other: "{{count}} dossiers",
    },
    alertes: {
      title: "Alertes automatiques & points Agirc-Arrco",
      description:
        "Signaux calculés à partir du relevé, des revenus et du profil : à qualifier, puis à verser au registre anomalies & vigilance si pertinent.",
      points_title: "Points Agirc-Arrco par année",
      points_drops: "{{count}} décrochage(s)",
      points_empty: "Aucune série de points dans le dernier relevé importé.",
      points_unit: "points",
      drop_tooltip: "−{{pct}} % vs {{prev}} pts l'année précédente",
      table_year: "Année",
      table_points: "Points acquis",
      table_diff: "Écart (points)",
      table_diff_pct: "Écart (%)",
      table_flag: "Signal",
      table_drop: "Décrochage",
      table_expand: "Voir les {{count}} années précédentes",
      table_collapse: "Réduire le tableau",
      list_title: "Alertes",
      empty: "Aucune alerte automatique sur ce dossier.",
      tracked: "Au registre",
      add_to_registre: "Verser au registre",
      niveau_info: "Info",
      niveau_important: "Important",
      niveau_critique: "Critique",
      code_service_militaire_absent: "Service national déclaré mais absent du relevé",
      msg_service_militaire_absent:
        "Le salarié déclare un service national ; aucune période militaire ne figure sur le RIS. Réclamer l'état signalétique des services et la régularisation.",
      code_service_militaire_dates: "Dates du service national divergentes",
      msg_service_militaire_dates:
        "Déclaré : {{declare}} — relevé : {{ris}}. Vérifier la période retenue par la caisse.",
      code_baisse_revenu: "Baisse de revenu d'au moins 30 %",
      msg_baisse_revenu:
        "{{count}} année(s) présentent un revenu inférieur d'au moins 30 % à l'année précédente. Qualifier la cause (chômage, temps partiel, maladie…) et vérifier les trimestres assimilés.",
      code_revenu_nul: "Année(s) sans revenu au milieu de la carrière",
      msg_revenu_nul:
        "{{count}} année(s) sans aucun revenu déclaré alors que la carrière est engagée. Trimestres et points de la période à contrôler.",
      code_baisse_points: "Décrochage de points Agirc-Arrco",
      code_points_salaire: "Points et rémunération : écart à vérifier",
      msg_points_salaire:
        "En {{annee}}, {{points}} points figurent au relevé, contre un repère de {{attendu}} points calculé sur le salaire déclaré et le barème annuel standard. Vérifier l'assiette, les plafonds proratisés, les taux employeur et les périodes particulières auprès de la caisse. Ce contrôle indicatif ne prouve pas un droit manquant.",
      msg_baisse_points:
        "{{count}} année(s) avec au moins moitié moins de points que l'année précédente (ex. {{exemple}}). Vérifier la déclaration de l'employeur et le régime de cotisation.",
      code_points_sans_trimestre: "Points complémentaires sans trimestre de base",
      msg_points_sans_trimestre:
        "{{count}} année(s) créditent des points Agirc-Arrco sans aucun trimestre validé au régime de base : une activité salariée est bien présente, la CNAV doit être régularisée.",
      code_trimestres_sans_points: "Trimestres validés sans points complémentaires",
      msg_trimestres_sans_points:
        "{{count}} année(s) valident 4 trimestres sans aucun point Agirc-Arrco alors que les années voisines en comptent. Vérifier l'affiliation complémentaire de l'employeur.",
      code_creux_carriere: "Années sans information sur le relevé",
      msg_creux_carriere:
        "{{count}} année(s) sans aucune période entre le début et la fin de la carrière connue. Demander au salarié ce qu'il faisait à ces dates (études, étranger, activité non déclarée…).",
      code_arret_maladie: "Arrêt maladie / invalidité à contrôler",
      msg_arret_maladie:
        "{{count}} période(s) de maladie repérée(s) (ou arrêt longue maladie déclaré). Vérifier que les trimestres assimilés et les points gratuits ont bien été reportés.",
      code_chomage: "Périodes de chômage à contrôler",
      msg_chomage:
        "{{count}} période(s) de chômage sur le relevé. Vérifier les trimestres assimilés (indemnisé / non indemnisé) et les points Agirc-Arrco attribués.",
      code_expatriation: "Carrière à l'étranger",
      msg_expatriation:
        "{{count}} période(s) d'expatriation ou expatriation hors CFE déclarée. Vérifier les accords bilatéraux, les périodes à faire valider et le délai de récupération des relevés étrangers.",
      code_temps_partiel_recent: "Baisse récente : temps partiel ?",
      msg_temps_partiel_recent:
        "{{count}} année(s) depuis 2023 sous le niveau de 2022 (revenus non plafonnés). Demander au salarié s'il est à temps partiel, depuis quand, et son niveau de cotisation retraite.",
      code_carriere_longue_potentielle: "Carrière longue potentielle non déclarée",
      msg_carriere_longue_potentielle:
        "Début d'activité à {{age}} ans : le dispositif carrière longue peut ouvrir un départ anticipé. À instruire (trimestres cotisés avant 16, 18, 20 ou 21 ans).",
      code_majoration_enfants: "Majoration de trimestres pour enfants",
      msg_majoration_enfants:
        "{{count}} enfant(s) déclaré(s) : vérifier que les trimestres de majoration (maternité / éducation, adoption, enfant handicapé) figurent bien sur le relevé.",
      code_trimestres_manquants_faibles: "Taux plein à portée",
      msg_trimestres_manquants_faibles:
        "Il ne manque que {{count}} trimestre(s) pour le taux plein : quelques mois d'activité ou un rachat ciblé suffisent.",
      code_taux_plein_atteint: "Taux plein déjà atteint",
      msg_taux_plein_atteint:
        "La date de taux plein naturel ({{date}}) est dépassée : le salarié peut partir quand il le souhaite ; vérifier la surcote.",
      code_age_legal_proche: "Âge légal dans moins d'un an, dossier incomplet",
      msg_age_legal_proche:
        "Le salarié a {{age}} ans et son dossier n'est pas complet : la restitution doit être planifiée rapidement pour laisser le temps des démarches.",
      code_depart_anticipe_dispositif: "Dispositif de départ anticipé à instruire",
      msg_depart_anticipe_dispositif:
        "Exposition déclarée ({{dispositif}}) : vérifier les droits ouverts (points C2P, allocation amiante) et leur impact sur la date de départ.",
    },
    droits: {
      title: "Droits récupérés",
      description:
        "Trimestres rachetés ou gagnés, points Agirc-Arrco récupérés : ce que l'analyse a permis d'obtenir, avec le suivi de la régularisation. Agrégé dans le reporting DRH.",
      total_trimestres: "Trimestres obtenus",
      total_points: "Points Agirc-Arrco obtenus",
      empty: "Aucun droit récupéré consigné.",
      statut_label: "Statut",
      statut_identifie: "Identifié",
      statut_demande: "Demandé",
      statut_obtenu: "Obtenu",
      nature_trimestres_rachetes: "Trimestres rachetés",
      nature_trimestres_gagnes: "Trimestres gagnés",
      nature_points_agirc_arrco: "Points Agirc-Arrco",
      nature_autre: "Autre droit",
      field_nature: "Nature",
      field_quantite: "Quantité",
      field_annee: "Année",
      field_comment: "Commentaire",
      field_comment_placeholder: "Ex. : période 2004 régularisée auprès de la CNAV",
      field_motif: "Motif",
      motif_service_national: "Service national",
      motif_activite_salariee: "Activité salariée",
      motif_chomage: "Chômage",
      motif_enfant_handicape: "Enfant handicapé",
      motif_maternite: "Maternité",
      motif_autre: "Autre",
      motif_non_renseigne: "Non renseigné",
      field_gain: "Gain annuel estimé (€/an)",
      total_gain: "Gain annuel estimé (obtenu)",
      gain_format: "{{value}} €/an",
      proposals_title: "Propositions issues des alertes",
      proposal_use: "Utiliser",
      proposal_comment_prefix: "Proposition : ",
      completion_a_confirmer: "À confirmer",
      completion_saisis: "Confirmé : droits saisis",
      completion_aucun: "Confirmé : aucun droit récupéré",
      completion_at: "Confirmé le {{date}} par {{auteur}}",
      confirm_saisis: "Confirmer les droits saisis",
      confirm_aucun: "Aucun droit récupéré",
      completion_cancel: "Annuler la confirmation",
      completion_hint:
        "Confirmation requise avant la clôture du dossier : indiquez si des droits ont été saisis ou confirmez qu'aucun droit n'a été récupéré.",
      qty_trimestres: "{{count}} trimestre(s)",
      qty_points: "{{value}} points",
    },
    surcotisation: {
      title: "Surcotisation employeur",
      description:
        "Quand l'entreprise a cotisé plus que le taux normal pour ce salarié sur une période (par exemple un abondement sur la complémentaire), renseignez ici les taux réellement versés : ils sont transmis au moteur de calcul sur la période concernée et la pension complémentaire s'en trouve augmentée. Mentionné dans le BRI.",
      empty: "Aucune surcotisation renseignée sur ce dossier.",
      add: "Ajouter une surcotisation",
      field_period: "Période de carrière",
      field_period_placeholder: "Choisir une période",
      period_hint:
        "Les années passées sont déjà inscrites au relevé de points Agirc-Arrco : ce que l'employeur a versé y est déjà compté. La surcotisation s'applique à la période en cours, jusqu'au départ.",
      no_effect: "Sans effet sur le calcul (période passée)",
      field_caisse: "Caisse concernée",
      field_taux_ta: "Taux tranche A (%)",
      field_taux_tb: "Taux tranche B (%)",
      field_taux_tc: "Taux tranche C (%)",
      field_taux_activite: "Taux d'activité (%)",
      field_type_taux: "Type de taux (optionnel)",
      type_taux_contractuel: "Taux contractuels (barème conventionnel)",
      type_taux_appele: "Taux appelés (réellement versés, surcotisation incluse)",
      type_taux_hint:
        "Taux contractuel (recommandé) : taux qui génère des points. Taux appelé : taux réellement prélevé, qui inclut le pourcentage d'appel ; le moteur en déduit moins de points.",
      field_comment: "Commentaire",
      field_comment_placeholder: "Ex. : surcotisation employeur tranche B de 2010 à 2015",
      rates_hint:
        "Taux en pour cent du salaire de la tranche. Barème contractuel indicatif d'un cadre : tranche A 6,2 %, tranches B et C 17 % (listes du moteur : A de 6,2 à 8 %, B de 17 à 20 %).",
      caisse_AGIRC_ARRCO: "Agirc-Arrco",
      caisse_ARRCO: "Arrco",
      caisse_AGIRC: "Agirc (tranche B)",
      caisse_AGIRCTC: "Agirc (tranche C)",
      caisse_MSA_RCO: "MSA complémentaire",
      delete_confirm:
        "Supprimer cette surcotisation ? Le prochain calcul ne la prendra plus en compte.",
    },
    vigilance: {
      title: "Anomalies & points de vigilance",
      description:
        "Registre unique des anomalies du dossier, quelle que soit leur origine (audit automatique, saisie du consultant) : cycle de vie, commentaire et sélection de ce qui part dans le BRI.",
      empty:
        "Aucune anomalie détectée ni déclarée. Lancez l'audit de carrière depuis le parcours pour alimenter ce registre.",
      source_audit: "Audit automatique",
      source_consultant: "Consultant",
      statut_label: "Statut",
      statut_a_traiter: "À traiter",
      statut_en_cours: "En cours",
      statut_ecartee: "Écartée",
      statut_resolue: "Résolue",
      include_bri: "Inclure dans le BRI",
      comment_placeholder: "Commentaire (qui, quoi, pourquoi)…",
      field_titre: "Nouvelle anomalie (saisie libre)",
      field_titre_placeholder: "Ex. : Salaire 2012 non reporté par l'employeur X",
      field_comment: "Commentaire",
      field_comment_placeholder: "Précisions éventuelles…",
      bri_hint:
        "La page « Points d'attention » du BRI reprend les anomalies cochées « Inclure dans le BRI » ; une anomalie écartée ou résolue en disparaît automatiquement.",
    },
    points_attention: {
      title: "Points d'attention",
      description:
        "Points portés à l'attention du salarié par le consultant : titre, texte, niveau d'importance et ordre d'affichage. Une page dédiée est ajoutée au BRI uniquement si des points sont retenus.",
      empty: "Aucun point d'attention retenu : le BRI ne comportera pas de page dédiée.",
      preview_show: "Aperçu du rendu",
      preview_hide: "Masquer l'aperçu",
      preview_title_a: "Vos points",
      preview_title_b: " d'attention",
      field_model: "Reprendre un modèle de la bibliothèque",
      model_none: "— Saisie libre —",
      field_niveau: "Niveau d'importance",
      niveau_info: "À noter",
      niveau_important: "Important",
      niveau_critique: "Prioritaire",
      field_titre: "Titre",
      field_titre_placeholder: "Ex. : Régulariser l'année 2015 auprès de la CNAV",
      field_texte: "Texte",
      field_texte_placeholder:
        "Rédigez le point tel qu'il apparaîtra dans le BRI remis au salarié.",
      add: "Ajouter au dossier",
      save_model: "Enregistrer comme modèle",
      saved_model: "Modèle enregistré",
      move_up: "Monter",
      move_down: "Descendre",
      bri_hint:
        "La page « Points d'attention » du BRI reprend ces points dans l'ordre ci-dessus, dans le respect du gabarit du support (logo, en-tête, couleurs).",
    },
    trimestres: {
      title: "Trimestres manquants & récupérés",
      description:
        "Trimestres manquants au taux plein selon le dernier calcul, et trimestres récupérables identifiés par le consultant (repris dans le BRI).",
      missing_label: "Trimestres manquants (taux plein)",
      missing_no_calc: "Aucun calcul disponible : lancez un calcul depuis le parcours.",
      recovered_label: "Trimestres récupérables renseignés",
      empty: "Aucun trimestre récupérable renseigné pour ce dossier.",
      field_motif: "Motif",
      field_nb: "Nombre",
      field_comment: "Commentaire",
      field_comment_placeholder: "Référence RIS, période concernée…",
      motif_periode_salariee: "Période salariée non reportée",
      motif_periode_chomage: "Période de chômage",
      motif_enfant_handicap: "Enfant handicapé",
      motif_etranger: "Période à l'étranger",
      motif_service_national: "Service national",
      motif_autre: "Autre motif",
      bri_hint: "Ces trimestres sont repris dans la page « Points d'attention » du BRI généré.",
    },
    vip: {
      answers_title: "Questions complémentaires VIP",
      answers_desc: "Projets déclarés par le salarié dans son parcours.",
      answers_empty: "Questionnaire non renseigné",
      answers_empty_desc:
        "Le salarié n'a pas encore répondu aux questions complémentaires de son parcours.",
    },
    tranche_c: {
      title: "Arbitrage et ROI Tranche C",
      desc: "Calcul déterministe : coût des cotisations, rente générée et point mort.",
      computed_at: "Calculé le {{date}}",
      salaire: "Assiette Tranche C (€/an)",
      taux: "Taux de cotisation (%)",
      annees: "Années de cotisation",
      points: "Points acquis estimés",
      valeur_point: "Valeur du point",
      esperance: "Durée de perception (années)",
      out_cout: "Coût total",
      out_rente: "Rente annuelle",
      out_roi_annees: "Point mort",
      out_ratio: "Ratio rente / coût",
      years: "{{value}} ans",
      verdict_favorable: "Arbitrage favorable : la rente perçue dépasse nettement le coût.",
      verdict_neutre: "Arbitrage à l'équilibre : la rente compense à peu près le coût.",
      verdict_defavorable: "Arbitrage défavorable : le coût n'est pas amorti sur la durée retenue.",
      verdict_inconnu: "Complétez les paramètres pour obtenir un arbitrage.",
      rachat_title: "Comparaison avec un rachat de trimestres",
      rachat_unit_hint: "Barème en vigueur : environ {{cost}} par trimestre (option taux seul).",
      rachat_no_bareme: "Aucun barème de rachat exploitable pour ce dossier.",
      rachat_cout: "Coût total du rachat (€)",
      rachat_gain: "Gain mensuel net (€)",
      rachat_roi: "Point mort du rachat",
      commentaire: "Commentaire du consultant",
      commentaire_placeholder: "Hypothèses retenues, points d'attention…",
      note: "Ces montants sont des estimations fondées sur les paramètres saisis. Ils alimentent la synthèse rédigée par Noa, qui ne recalcule rien.",
      save: "Enregistrer l'arbitrage",
      saved: "Arbitrage enregistré.",
      save_failed: "Enregistrement impossible.",
    },
    scenario_comparison: {
      title: "Analyse comparée des scénarios",
      desc: "Écarts de pension nette mensuelle par rapport au scénario de référence ({{reference}}).",
      empty: "Pas assez de scénarios calculés",
      empty_desc: "Lancez un calcul avec au moins deux scénarios pour obtenir la comparaison.",
      col_scenario: "Scénario",
      col_date: "Départ",
      col_age: "Âge",
      col_trimestres: "Trimestres",
      col_net: "Pension nette",
      col_delta: "Écart",
      age_value: "{{age}} ans",
      reference: "Référence",
      delta_hint:
        "Écart entre cette simulation et l'estimation de référence, en pension nette mensuelle (référence {{ref}}, simulation {{sim}}).",
    },
    dashboard: {
      kicker_pilot: "Pilotage Aon",
      kicker_production: "Production Aon",
      greeting: "Bonjour {{name}}",
      desc_pilot: "Pilotage des opérations BRI et de l'équipe production.",
      desc_production: "Vue d'ensemble de votre portefeuille de dossiers BRI.",
      my_portfolio: "Mon portefeuille",
      stat_my_dossiers: "Mes dossiers",
      stat_accessible: "Sur {{count}} accessibles",
      stat_to_complete: "À compléter",
      stat_to_complete_hint: "En attente du salarié ou de moi",
      stat_to_validate: "À valider (N1)",
      stat_to_validate_hint: "Contrôle qualité avant calcul",
      stat_to_restitute: "À restituer",
      stat_to_restitute_hint: "BRI prêt, attente RDV salarié",
      immediate_actions: "Dossiers à action immédiate",
      view_all_dossiers: "Voir tous mes dossiers",
      up_to_date: "Vous êtes à jour",
      restitution_badge: "Restitution",
      no_action_needed: "Aucun dossier ne nécessite d'action immédiate de votre part.",
      quick_links: "Accès rapides",
      link_dossiers: "Tous mes dossiers",
      link_dossiers_desc: "Liste filtrable des dossiers que je suis.",
      link_agenda: "Mon agenda",
      link_agenda_desc: "Mes RDV de restitution à venir.",
      link_library: "Bibliothèque",
      link_library_desc: "Modèles BRI, courriers, supports formation.",
    },
    chef_projet: {
      kicker: "Pilotage chef de projet",
      title: "Suivi opération",
      stat_to_dispatch: "À dispatcher",
      stat_to_dispatch_hint: "Dossiers sans consultant",
      stat_n2: "À contrôler N2",
      stat_n2_hint: "N1 validé en attente",
      stat_avg_time: "Temps moyen production",
      stat_avg_time_hint: "Jours entre démarrage et restitution",
      stat_completion: "Taux de complétion",
      stat_completion_hint: "Dossiers complétés / total",
      to_assign_title: "Dossiers à dispatcher",
      to_assign_empty: "Tous les dossiers sont affectés",
      to_assign_empty_desc: "Aucun dossier n'attend d'être attribué à un consultant.",
      n2_title: "Contrôle N2",
      n2_empty: "Aucun dossier en attente de contrôle N2",
      n2_empty_desc: "Tous les contrôles qualité sont à jour.",
      workload_title: "Charge de l'équipe",
      workload_empty: "Aucun consultant actif",
      workload_empty_desc: "Aucun consultant n'a de dossier assigné pour le moment.",
      workload_dossiers: "dossiers actifs",
      workload_desc: "Dossiers actifs par consultant — ajustez la répartition si nécessaire.",
      view_all: "Voir tout",
    },
    dossiers: {
      kicker: "Production Aon",
      title: "Mes dossiers",
      description: "Liste filtrable de tous vos dossiers BRI.",
      search_placeholder: "Rechercher un dossier…",
      no_dossiers: "Aucun dossier trouvé.",
      filter_status: "Statut",
      filter_operation: "Opération",
      filter_societe: "Société",
      take_over: "Prendre en charge",
      reassign: "Réaffecter",
      assign_self: "Me l'attribuer",
      assign_other: "Affecter à un consultant…",
    },
    equipe: {
      kicker: "Espace Aon",
      title: "Mon équipe",
      description: "Consultants et chefs de projet de votre périmètre.",
      invite: "Inviter un consultant",
      success_prefix: "Invitation envoyée à",
      success_suffix: "La personne recevra un email pour activer son compte.",
      close: "Fermer",
      button_invite: "Inviter un consultant",
      stat_active: "Consultants actifs",
      stat_active_dossiers: "Dossiers actifs",
      stat_avg_time: "Temps moyen dossier",
      stat_avg_time_hint_with_count: "sur {{count}} dossier(s) livré(s)",
      stat_avg_time_hint_none: "aucun dossier livré mesurable",
      stat_invitations: "Invitations en attente",
      section_consultants: "Consultants production",
      consultants_description:
        "Charge actuelle, état des contrôles et temps moyen de production par consultant (soumission du dossier → BRI livré). Le badge N1 signale les dossiers en attente d'auto-contrôle.",
      empty_title: "Aucun consultant",
      empty_desc: "Invitez des consultants production pour démarrer votre équipe.",
      empty_action: "Inviter",
      section_invitations: "Invitations en attente",
      invitations_desc: "Ces personnes n'ont pas encore activé leur compte.",
      revoke_title: "Révoquer cette invitation",
      revoke_desc: "L'invitation envoyée à {{email}} sera annulée.",
      revoke_confirm: "Révoquer",
      revoke_footer:
        "La personne ne pourra plus créer son compte avec ce lien. Vous pourrez en envoyer une nouvelle plus tard.",
      expired: "Expirée",
      invited_at: "Invité {{date}}",
      n1_label: "N1: {{count}}",
      n2_label: "N2: {{count}}",
      relecture_label: "{{count}} en relecture",
      restitution_label: "{{count}} en restitution",
      active_suffix: "actifs",
      delivered_suffix: "livrés",
      avg_time_suffix: "j / dossier",
      avg_time_title: "Temps moyen de production (soumission → BRI livré)",
    },
    revue: {
      kicker: "Pilotage Aon",
      title: "Revue qualité",
      description:
        "Contrôle à deux niveaux des dossiers : N1 (revue croisée peer to peer par la production) puis N2 (validation finale chef de projet). Validez le N2 directement depuis la file pour débloquer la génération du BRI.",
      stat_to_dispatch: "À dispatcher",
      stat_to_dispatch_hint: "Dossiers sans consultant",
      stat_n1: "En attente N1",
      stat_n1_hint: "Revue croisée production",
      stat_n2: "À contrôler N2",
      stat_n2_hint: "N1 validé, en attente de vous",
      stat_avg_time: "Temps moyen production",
      stat_avg_time_value: "{{days}} j",
      stat_avg_time_hint_with_count: "Sur {{count}} dossiers livrés",
      stat_avg_time_hint_none: "Aucun dossier livré",
      to_dispatch_title: "À dispatcher",
      to_dispatch_desc: "Dossiers soumis sans consultant assigné.",
      to_dispatch_empty_title: "Tout est attribué",
      to_dispatch_empty_desc: "Aucun dossier en attente d'affectation.",
      n1_title: "En attente : Niveau 1 (revue croisée)",
      n1_desc:
        "Relecture peer to peer : à réaliser par un pair de la production, pas par le consultant en charge.",
      n1_empty_title: "Rien en attente",
      n1_empty_desc: "Aucun dossier en attente de contrôle N1.",
      n2_title: "À contrôler : Niveau 2",
      n2_desc: "N1 validé par la production, en attente de votre contrôle final.",
      n2_empty_title: "À jour",
      n2_empty_desc: "Aucun dossier en attente de contrôle N2.",
      validated_title: "Validés N2 (revue terminée)",
      validated_desc: "Dossiers déjà contrôlés, masqués des files d'attente. Affichés sur demande.",
      validated_empty_title: "Aucun dossier validé",
      validated_empty_desc: "Aucun contrôle N2 n'a encore été validé.",
      submitted_label: "Soumis",
      n1_ok_label: "N1 ok",
      validated_label: "Validé",
      select_all: "Tout sélectionner",
      deselect_all: "Tout désélectionner",
      action_assign: "Affecter",
      validate_n2: "Valider N2",
      validate_n2_error: "Échec, réessayez",
      consultant_label: "Consultant production",
      reviewer_label: "Consultant relecture",
      restitution_consultant_label: "Consultant de restitution",
      restitution_same_as_production: "Identique au consultant de production",
      chef_projet_label: "Chef de projet",
      keep_unchanged: "— Ne pas changer —",
      empty_consultants: "Aucun consultant actif",
      empty_chefs: "Aucun chef de projet actif",
      clear_selection: "Effacer",
      assign: "Affecter",
      bulk_assign: "Affecter la sélection",
      bulk_assign_desc_one: "{{count}} dossier va être affecté.",
      bulk_assign_desc_other: "{{count}} dossiers vont être affectés.",
      confirm_assign: "Confirmer l'affectation",
      selected_count_one: "{{count}} dossier sélectionné",
      selected_count_other: "{{count}} dossiers sélectionnés",
      dossier_count_one: "{{count}} dossier",
      dossier_count_other: "{{count}} dossiers",
      role_admin: "Admin",
      role_chef_projet: "Chef de projet",
      consultant_assigned: "Consultant : {{name}}",
      unassigned: "Non assigné",
      badge_autonome: "Parcours autonome",
      select_dossier_aria: "Sélectionner le dossier de {{name}}",
      open_dossier_title: "Ouvrir le dossier",
      pagination_unit: "dossiers",
      export_excel: "Exporter (Excel)",
      sheet_consultants: "Consultants",
      times_title: "Temps de production par consultant",
      times_desc:
        "Jours entre la soumission du dossier et le rendez-vous de restitution, par consultant.",
      times_empty_title: "Aucune mesure disponible",
      times_empty_desc:
        "Aucun dossier soumis avec un rendez-vous de restitution planifié pour le moment.",
      times_col_consultant: "Consultant",
      times_col_dossiers: "Dossiers",
      times_col_mesures: "Mesurés",
      times_col_avg: "Temps moyen",
      times_col_min: "Min",
      times_col_max: "Max",
      export_col_salarie: "Salarié",
      export_col_matricule: "Matricule",
      export_col_operation: "Opération",
      export_col_statut: "Statut",
      export_col_consultant: "Consultant",
      export_col_soumis: "Soumis le",
      export_col_n1_at: "N1 validé le",
      export_col_n1_par: "N1 validé par",
      export_col_n2_at: "N2 validé le",
      export_col_n2_par: "N2 validé par",
      export_col_rdv: "RDV de restitution",
      export_col_days: "Temps de production (jours)",
    },
    relances: {
      kicker: "Espace Aon",
      title: "Relances",
      description: "Suivi des relances email et téléphone auprès des salariés.",
      channel_email: "Email",
      channel_phone: "Téléphone",
      outcome_repondu: "Répondu",
      outcome_pas_de_reponse: "Pas de réponse",
      outcome_message_laisse: "Message laissé",
      outcome_a_rappeler: "À rappeler",
      outcome_refus: "Refus",
      outcome_injoignable: "Injoignable",
      next_relance: "Prochaine relance",
      auto_settings: "Relances automatiques",
      auto_enabled: "Activer les relances automatiques",
      first_after: "Première relance après",
      followup_interval: "Intervalle entre relances",
      max_relances: "Nombre maximum de relances",
      target_statuses: "Statuts ciblés",
      template: "Modèle d'email",
      dry_run: "Aperçu (simulation)",
      run_now: "Lancer maintenant",
      last_run: "Dernière exécution",
      auto_badge: "Auto",
    },
    calendrier: {
      kicker: "Espace Aon",
      title: "Mon agenda",
      description: "Rendez-vous de restitution et disponibilités.",
      no_appointments: "Aucun rendez-vous planifié.",
      add_availability: "Ajouter des disponibilités",
    },
    agenda: {
      kicker: "Pilotage Aon",
      title: "Agenda & rendez-vous",
      description: "Gérez vos créneaux ouverts et vos rendez-vous de restitution BRI.",
      add_slot: "Ajouter un créneau",
      stat_open: "Créneaux ouverts",
      stat_booked: "Créneaux réservés",
      stat_upcoming: "RDV à venir",
      appointments_title: "Mes prochains rendez-vous",
      no_appointment_title: "Aucun RDV programmé",
      no_appointment_desc:
        "Ouvrez des créneaux pour permettre aux salariés de prendre RDV avec vous.",
      slots_title: "Mes créneaux",
      scope_upcoming: "À venir",
      scope_past: "Anciens",
      slots_count: "{{count}} créneaux",
      pagination_page: "Page {{page}} sur {{total}}",
      pagination_previous: "Précédent",
      pagination_next: "Suivant",
      empty_past_title: "Aucun ancien créneau",
      empty_upcoming_title: "Aucun créneau ouvert",
      empty_past_desc: "Vos créneaux passés apparaîtront ici.",
      empty_upcoming_desc: "Ajoutez des créneaux pour rendre votre agenda visible aux salariés.",
      cancel_title: "Annuler ce rendez-vous",
      cancel_desc: "RDV avec {{name}} du {{date}}.",
      cancel_confirm: "Annuler le RDV",
      cancel_footer:
        "Le créneau associé redevient disponible. Le salarié et le consultant reçoivent l'annulation dans leur agenda.",
      action_done: "Réalisé",
      action_no_show: "Absent",
      action_cancel: "Annuler",
      meeting_link: "Lien de réunion",
      slot_reserved: "Réservé",
      slot_open: "Libre",
      delete_slot_tooltip: "Annulez d'abord le RDV pour libérer ce créneau",
      delete_slot_action: "Supprimer",
      detail_title: "Détail du créneau",
      detail_start: "Début",
      detail_end: "Fin",
      detail_duration: "Durée",
      detail_channel: "Canal",
      detail_status: "Statut",
      detail_created: "Créé le",
      appointment_section: "Rendez-vous associé",
      unknown_company: "Société inconnue",
      detail_matricule: "Matricule",
      detail_email: "Email",
      detail_video_link: "Lien visio",
      join_meeting: "Rejoindre",
      detail_phone: "Téléphone",
      notes_consultant: "Notes consultant",
      open_dossier: "Ouvrir le dossier",
      missing_appointment: "Créneau marqué réservé, mais aucun rendez-vous n'a été retrouvé.",
      unknown_employee: "Salarié inconnu",
      channel_teams: "Visioconférence (Teams)",
      channel_teams_short: "Visio",
      channel_telephone: "Téléphone",
      channel_presentiel: "Présentiel",
      channel_default: "{{channel}}",
      status_propose: "Proposé",
      status_planifie: "Planifié",
      status_realise: "Réalisé",
      status_annule: "Annulé",
      status_no_show: "Absent",
      duration_min: "{{minutes}} min",
      duration_h: "{{hours}} h",
      duration_h_min: "{{hours}} h {{minutes}} min",
      format_range_separator: " · ",
      format_range_arrow: " → ",
      cal: {
        title: "Calendrier",
        title_for: "Calendrier de {{name}}",
        title_team: "Calendrier de l'équipe",
        view_week: "Semaine",
        view_month: "Mois",
        previous: "Période précédente",
        next: "Période suivante",
        today: "Aujourd'hui",
        more: "+{{count}}",
      },
      feed: {
        title: "Abonnement calendrier : {{name}}",
        you: "vous",
        team: "l'équipe",
        desc: "Recevez les rendez-vous dans Outlook ou votre application calendrier, en lecture seule. Le lien contient un jeton secret révocable.",
        active_since: "Lien actif depuis le {{date}}",
        last_sync: "dernière synchronisation le {{date}}",
        never_synced: "jamais synchronisé",
        create: "Créer le lien d'abonnement",
        regenerate: "Régénérer le lien",
        revoke: "Révoquer",
        shown_once: "Copiez ce lien maintenant : il ne sera plus affiché ensuite.",
        share_warning:
          "Ce lien donne accès aux noms des salariés et aux horaires de rendez-vous : ne le partagez pas.",
        copy: "Copier",
        copied: "Copié",
        subscribe_outlook: "S'abonner dans Outlook",
        open_calendar_app: "Ouvrir dans l'application calendrier",
        refresh_hint:
          "Outlook rafraîchit les abonnements à son propre rythme (jusqu'à quelques heures).",
        hide_link: "Masquer le lien",
        regen_title: "Régénérer le lien d'abonnement",
        regen_desc: "L'ancien lien cessera de fonctionner immédiatement.",
        revoke_title: "Révoquer le lien d'abonnement",
        revoke_desc: "Le lien cessera de fonctionner immédiatement. Cette action est définitive.",
        cal_name: "NOA : agenda de {{name}}",
      },
      tabs_label: "Vue de l'agenda",
      tab_mine: "Mon agenda",
      tab_team: "Tous les agendas",
      team: {
        stat_open: "Créneaux ouverts (30 j)",
        stat_booked: "Créneaux réservés (30 j)",
        stat_upcoming: "RDV à venir (30 j)",
        consultants_title: "Agendas des consultants",
        consultants_desc:
          "Sur les 30 prochains jours. Sélectionnez un consultant pour voir ses créneaux et filtrer ses rendez-vous.",
        no_consultant_title: "Aucun consultant",
        no_consultant_desc: "Aucun compte consultant n'est encore actif dans l'équipe.",
        all_consultants: "Toute l'équipe",
        all_consultants_meta: "{{count}} consultants",
        next_at: "Prochain RDV : {{date}}",
        no_upcoming: "Aucun rendez-vous à venir",
        col_open: "Libres",
        col_booked: "Réservés",
        col_upcoming: "RDV",
        slots_title: "Créneaux de {{name}}",
        no_slot_title: "Aucun créneau à venir",
        no_slot_desc: "Ce consultant n'a pas ouvert de créneau pour les prochaines semaines.",
        appointments_title: "Rendez-vous à venir — toute l'équipe",
        appointments_title_for: "Rendez-vous à venir — {{name}}",
        appointments_desc:
          "Décommander un rendez-vous libère le créneau et notifie le salarié et le consultant (annulation calendrier).",
        no_appointment_title: "Aucun rendez-vous programmé",
        no_appointment_desc: "Les rendez-vous planifiés par l'équipe apparaîtront ici.",
        with_consultant: "avec {{name}}",
        cancel_action: "Décommander",
        cancel_title: "Décommander ce rendez-vous",
        cancel_desc: "RDV de {{name}} avec {{consultant}}, le {{date}}.",
        cancel_confirm: "Décommander le RDV",
        cancel_reason_label: "Motif (transmis au salarié et au consultant)",
        cancel_reason_placeholder:
          "Ex. : consultant indisponible, nous vous proposerons une nouvelle date.",
        cancel_footer:
          "Le créneau redevient disponible. Les deux parties reçoivent un e-mail avec l'annulation de l'événement dans leur agenda.",
      },
      drawer: {
        title: "Ajouter un créneau",
        description: "Ouvrez votre agenda à la prise de RDV par les salariés.",
        single_tab: "Un créneau",
        bulk_tab: "Génération en lot",
        date_label: "Date",
        start_time_label: "Heure début",
        end_time_label: "Heure fin",
        modality_label: "Modalité",
        cancel_button: "Annuler",
        create_slot_button: "Créer le créneau",
        from_date_label: "À partir du",
        to_date_label: "Jusqu'au",
        weekdays_label: "Jours de la semaine",
        slots_per_day_label: "Créneaux par jour",
        add_time_slot: "Ajouter un créneau horaire",
        bulk_preview: "<strong>{{count}}</strong> créneau{{plural}} seront créés",
        bulk_preview_dates: " (du {{start}} au {{end}})",
        bulk_generate_button: "Générer {{count}} créneau{{plural}}",
        error_invalid_datetime: "Date ou heure invalide.",
        error_end_after_start: "L'heure de fin doit être après l'heure de début.",
        error_future: "Le créneau doit être dans le futur.",
        error_no_slots: "Aucun créneau ne sera généré avec ces paramètres.",
        error_too_many_slots: "Trop de créneaux à générer ({{count}}). Limitez à 200.",
        operation_label: "Opération",
        operation_all: "Toutes les opérations",
        operation_hint_all:
          "Créneau ouvert à tous vos dossiers. Choisissez une opération pour le réserver à ses salariés et appliquer sa durée de rendez-vous.",
        operation_hint_selected:
          "Créneau réservé aux salariés de cette opération — durée de rendez-vous : {{minutes}} min.",
        end_time_locked: "Heure de fin calculée : durée de {{minutes}} min fixée par l'opération.",
        ranges_per_day_label: "Plages horaires par jour",
        ranges_hint: "Chaque plage est découpée en créneaux de {{minutes}} min.",
        error_unknown: "Erreur inconnue",
      },
    },
    pilotage: {
      kicker: "Pilotage Aon",
      title: "Pilotage de l'opération",
      description:
        "Synthèse de l'activité production : dossiers en cours, contrôle qualité à deux niveaux, suivi des relances et charge de l'équipe.",
      section_summary: "Synthèse",
      stat_active: "Dossiers actifs",
      stat_active_hint: "{{count}} dossiers livrés",
      stat_to_complete: "À compléter",
      stat_to_complete_hint: "En attente salarié ou production",
      stat_to_relance: "À relancer",
      stat_to_relance_hint: "{{count}} jamais relancés",
      stat_avg_time: "Temps moyen production",
      stat_avg_time_hint_with_count: "Sur {{count}} dossiers livrés",
      stat_avg_time_hint_none: "Aucun dossier livré",
      stat_avg_time_suffix: "j",
      section_review: "Contrôle et revue",
      section_sorties: "Sorties et refus de contact",
      stat_sorties: "Comptes clôturés",
      stat_sorties_hint: "Date et motif de départ renseignés",
      stat_sorties_retraite: "Départs en retraite",
      stat_sorties_retraite_hint: "Volontaires et mises à la retraite",
      stat_refus_contact: "Refus de contact",
      stat_refus_contact_hint: "Exclus des relances manuelles et automatiques",
      review_link: "Ouvrir la revue qualité",
      queue_to_assign: "À dispatcher",
      queue_to_assign_desc: "Dossiers soumis sans consultant assigné.",
      queue_n1: "En attente N1",
      queue_n1_desc: "Auto-contrôle par la production.",
      queue_n2: "À contrôler N2",
      queue_n2_desc: "N1 validé, contrôle final chef de projet.",
      section_relances: "Suivi des relances",
      relances_desc: "Dernières relances réalisées par l'équipe production.",
      relances_manage: "Gérer",
      relance_to_relance: "À relancer",
      relance_this_month: "Ce mois-ci",
      relance_never: "Jamais relancés",
      relances_empty_title: "Aucune relance récente",
      relances_empty_desc: "Les relances enregistrées apparaîtront ici.",
      relance_default_note: "Relance enregistrée",
      section_workload: "Charge de l'équipe",
      workload_desc: "{{occupied}}/{{total}} consultants occupés",
      workload_team: "Équipe",
      workload_empty_title: "Aucun consultant",
      workload_empty_desc: "Invitez des consultants production pour démarrer.",
      workload_n2: "N2: {{count}}",
      time_since_today: "aujourd'hui",
      time_since_days: "il y a {{count}} j",
      time_since_weeks: "il y a {{count}} sem",
      time_since_months: "il y a {{count}} mois",
    },
    library: {
      kicker: "Ressources Aon",
      title: "Bibliothèque",
      subtitle:
        "Méthodes de production, repères techniques et supports pédagogiques pour les équipes Aon.",
    },
  },
  shareLevel: {
    none: "Partage : aucun",
    date_only: "Partage : date du taux plein",
    full: "Partage : BRI complet",
  },
  drh: {
    partage: {
      kicker: "Espace DRH · Dossier",
      title: "Dossier retraite",
      description: "Ce que le salarié a choisi de partager avec votre entreprise.",
      back: "Retour à la liste des salariés",
      error_title: "Dossier indisponible",
      error_desc: "Ce dossier n'existe pas ou n'est pas dans votre périmètre.",
      status_label: "Statut du dossier",
      submitted: "Soumis le {{date}}",
      restituted: "Restitué le {{date}}",
      none_title: "Le salarié n'a pas autorisé le partage de ses résultats.",
      none_body:
        "Vous voyez uniquement le statut de son dossier. Le salarié peut changer son choix à tout moment depuis son espace.",
      taux_plein_label: "Départ à taux plein",
      age_at: "Soit à {{age}}",
      age_years: "{{count}} an",
      age_years_other: "{{count}} ans",
      age_months: "{{count}} mois",
      synthese_label: "Synthèse des résultats",
      kv_premiere_date: "Première date de départ possible",
      kv_age_premiere_date: "Âge à la première date",
      kv_pension_brute: "Pension mensuelle brute",
      kv_pension_nette: "Pension mensuelle nette",
      kv_trimestres: "Trimestres validés",
      trimestres_value: "{{valides}} validés, {{manquants}} manquants",
      kv_points: "Points Agirc-Arrco",
      bris_label: "BRI diffusés au salarié",
      bris_empty: "Aucun BRI n'a encore été diffusé.",
      bri_name: "Bilan retraite individuel, version {{version}}",
      bri_released: "Diffusé le {{date}}",
      bri_download: "Télécharger",
      help: "Le niveau de partage est choisi par le salarié, dans les limites fixées par son groupe. Seule l'équipe Aon voit le contenu complet du dossier.",
    },
    dashboard: {
      kicker: "Espace DRH · Pilotage",
      title: "Tableau de bord DRH",
      description: "Pilotage de la campagne BRI pour votre périmètre.",
      scope_badge: "Vous voyez uniquement les données de votre périmètre.",
      stat_salaries: "Salariés couverts",
      stat_salaries_hint: "{{count}} avec dossier",
      stat_dossiers: "Dossiers actifs",
      stat_dossiers_hint: "{{count}} livrés",
      stat_completion: "Taux de complétion",
      stat_restitutions: "Restitutions à venir",
      stat_restitutions_hint: "{{count}} dans les 30 prochains jours",
      stat_urgents: "Dossiers urgents",
      stat_urgents_hint: "Marqués prioritaires dans votre périmètre",
      badge_urgent: "Urgent",
      distribution_title: "Répartition des dossiers",
      distribution_over: "Sur {{count}} dossiers",
      funnel_completion: "Complétion",
      funnel_production: "Production",
      funnel_restitution: "Restitution",
      funnel_delivered: "Livrés",
      contacts_title: "Mes contacts Aon",
      contacts_desc:
        "Chefs de projet Aon en charge de vos opérations. Cliquez pour démarrer ou reprendre une conversation.",
      contact_role: "Chef de projet",
      contact_chat: "Discuter",
      upcoming_title: "Restitutions à venir",
      upcoming_desc: "Prochains RDV de votre périmètre",
      upcoming_empty_title: "Aucune restitution planifiée",
      upcoming_empty_desc: "Les RDV de restitution apparaîtront ici dès qu'ils seront pris.",
      unknown_salarie: "(salarié inconnu)",
      with: "avec {{name}}",
      recent_title: "Activité récente",
      see_all: "Tout voir",
      recent_empty_title: "Aucun dossier",
      recent_empty_desc: "Aucun dossier n'a encore été créé sur votre périmètre.",
    },
    reporting: {
      kicker: "Espace DRH · Pilotage",
      title: "Reporting",
      description:
        "Statistiques agrégées de votre périmètre — anticipez les départs et pilotez votre campagne de bilans retraite en un coup d'œil.",
      anonymized_badge: "Données anonymisées · effectifs < {{k}} masqués",
      all_societes: "Toutes mes sociétés",
      export: "Exporter",
      no_data_title: "Aucune donnée sur ce périmètre",
      no_data_desc:
        "Les statistiques apparaîtront dès que des salariés et dossiers seront rattachés à votre périmètre.",
      cohort_too_small_title: "Effectif trop faible pour un reporting anonymisé",
      cohort_too_small_desc:
        "Votre périmètre compte moins de {{k}} salariés : les statistiques détaillées sont masquées pour éviter toute ré-identification.",
      participation: "Participation",
      eligible: "Éligibles",
      started: "Démarrés",
      completed: "Complétés",
      delivered: "Livrés",
      participation_rate: "Taux de participation",
      completion_rate: "Taux de complétion",
      delivery_rate: "Taux de livraison",
      distribution_title: "Répartition des statuts",
      departure_title: "Distribution des âges de départ",
      ventilation_title: "Ventilation",
      axis_bu: "Business Unit",
      axis_category: "Catégorie",
      axis_salary_band: "Tranche salariale",
      axis_region: "Région",
      axis_operation: "Opération",
      filter_operation: "Opération",
      filter_region: "Région",
      rachat_tous: "Rachat : tous",
      rachat_sans: "Sans rachat",
      rachat_avec: "Avec rachat",
      pas_label: "Regroupement",
      pas_annee: "Année",
      pas_trimestre: "Trimestre",
      annee_reference: "Année de référence",
      comparaison_masked: "comparaison N / N-1 masquée (effectif sous le seuil)",
      comparaison_resume: "N : {{x}} · N-1 : {{y}} · écart {{ecart}}",
      comparaison_chart_desc: "Comparaison N et N-1 par trimestre",
      adhesion_title: "Adhésion aux formations par BU",
      adhesion_desc:
        "Salariés présents, inscrits et présents à au moins une formation, et refus d'adhésion par Business Unit (effectifs masqués sous le seuil d'anonymat).",
      adhesion_empty: "Aucune Business Unit sur ce périmètre.",
      adhesion_col_presents: "Présents",
      adhesion_col_inscrits: "Inscrits",
      adhesion_col_taux: "Taux d'adhésion",
      adhesion_col_formation_presents: "Présents à la formation",
      adhesion_col_refus: "Refus d'adhésion",
      adhesion_taux_masked: "masqué",
      kpi_refus_adhesion: "Salariés présents refusant d'adhérer",
      kpi_refus_adhesion_hint: "ont refusé d'être contactés",
      category_cadre: "Cadre",
      category_oetam: "OETAM",
      category_dirigeant: "Dirigeant",
      category_none: "Non renseigné",
      salary_sub_80k: "< 80 k€",
      salary_80k_120k: "80 – 120 k€",
      salary_above_120k: "> 120 k€",
      filter_bu: "Business Unit",
      filter_department: "Département",
      filter_category: "Catégorie",
      filter_salary: "Tranche salariale",
      filter_formation: "Formation",
      formation_all: "Formation : toutes",
      formation_registered: "Inscrits à une formation",
      formation_present: "Présents à une formation",
      active_filters: "{{count}} filtre(s) actif(s)",
      reset_filters: "Réinitialiser les filtres",
      satisfaction_title: "Satisfaction",
      satisfaction_avg: "Note moyenne",
      satisfaction_respondents: "Répondants",
      formations_title: "Formations",
      formations_sessions: "Sessions",
      formations_registered: "Inscrits",
      formations_present: "Présents",
      cost_title: "Estimations financières",
      badge_prefix: "Données anonymisées · effectifs",
      badge_suffix: "masqués",
      filter_status: "Statut du dossier",
      reset_filters_count: "Réinitialiser ({{count}})",
      salary_none: "Non renseigné",
      kpi_covered: "Salariés couverts",
      kpi_covered_hint: "{{count}} espace(s) activé(s)",
      kpi_activation_rate: "Taux d'activation",
      kpi_activation_hint: "{{count}} consentement(s) recueilli(s)",
      kpi_delivered: "Bilans livrés",
      kpi_delivered_hint: "sur {{count}} dossier(s)",
      kpi_formation_presence: "Présence formation",
      kpi_formation_presence_hint: "{{count}} inscrit(s)",
      info_activated_label: "Espace activé",
      info_activated_body_1: " : un salarié est compté comme « espace activé » dès qu'il s'est ",
      info_activated_strong: "connecté au moins une fois",
      info_activated_body_2:
        " à son espace personnel (via le lien d'invitation ou son mot de passe). Un compte invité mais jamais utilisé n'est pas compté. Le taux d'activation rapporte ces connexions au nombre total de salariés couverts par votre périmètre.",
      funnel_title: "Avancement des dossiers",
      funnel_desc: "Répartition par statut sur {{count}} dossier(s)",
      funnel_empty: "Aucun dossier sur ce périmètre.",
      chart_depart_title: "Âge de première date de départ possible",
      chart_depart_desc: "Distribution des âges de départ au plus tôt issus des bilans.",
      chart_taux_plein_title: "Âge de taux plein naturel",
      chart_taux_plein_desc: "Distribution des âges d'atteinte du taux plein.",
      chart_tpn_annee_title: "Dates de taux plein naturel par année",
      chart_tpn_annee_desc:
        "Nombre de salariés atteignant leur taux plein naturel (TPN) chaque année civile.",
      chart_departs_annee_title: "Premières dates de départ possibles par année",
      chart_departs_annee_desc:
        "Nombre de salariés pouvant partir chaque année, sans rachat (estimation de base) et avec rachat de trimestres ({{count}} dossiers avec simulation de rachat), et parmi eux les carrières longues.",
      departs_serie_sans_rachat: "Sans rachat",
      departs_serie_avec_rachat: "Avec rachat à l’âge légal",
      departs_serie_carriere_longue: "Carrières longues",
      sorties_title: "Sorties de l'effectif",
      sorties_desc:
        "Comptes clôturés (date et motif de départ renseignés par l'équipe) et salariés ayant refusé d'être contactés.",
      sorties_total: "Comptes clôturés",
      sorties_retraite: "Départs en retraite",
      sorties_retraite_hint: "Volontaires et mises à la retraite",
      refus_contact: "Refus de contact",
      refus_contact_hint: "Salariés exclus des relances",
      sorties_par_motif: "Par motif",
      sorties_par_annee: "Par année de sortie",
      sorties_motif_non_renseigne: "Motif non renseigné",
      sorties_empty: "Aucune sortie enregistrée.",
      droits_title: "Droits récupérés par l'accompagnement",
      droits_desc:
        "Volumes obtenus consignés par les consultants sur les dossiers de votre périmètre (masqués sous {{k}} dossiers).",
      droits_dossiers: "Dossiers concernés",
      droits_trim_rachetes: "Trimestres rachetés",
      droits_trim_gagnes: "Trimestres gagnés",
      droits_points: "Points Agirc-Arrco récupérés",
      droits_en_cours: "+ {{count}} en cours de régularisation",
      droits_gain_total: "Gain de pension annuel estimé (obtenu)",
      droits_gain_en_cours: "+ {{value}} €/an en cours",
      droits_gain_en_cours_label: "Gain de pension annuel estimé (en cours)",
      droits_par_motif: "Ventilation par motif",
      droits_motif_col: "Motif",
      droits_col_trimestres: "Trimestres",
      droits_col_points: "Points",
      droits_col_gain: "Gain (€/an)",
      retraite_title: "Indicateurs retraite",
      retraite_desc: "Carrières longues, rachats et droits issus des derniers bilans.",
      kpi_carriere_longue: "Carrières longues",
      kpi_rachats: "Rachats envisagés",
      kpi_rachats_hint: "dossiers avec un coût de rachat estimé",
      kpi_cout_rachat: "Coût moyen de rachat",
      kpi_trim_rachetes: "Trimestres rachetés",
      kpi_trim_rachetes_hint: "volume total envisagé",
      kpi_points: "Points Agirc-Arrco (moy.)",
      kpi_points_hint: "sur {{count}} dossier(s)",
      kpi_points_none: "non renseigné par le moteur",
      kpi_trim_manquants: "Trimestres manquants (moy.)",
      kpi_trim_manquants_hint: "droits restant à compléter",
      kpi_trim_valides: "Trimestres validés (moy.)",
      kpi_trim_valides_hint: "sur {{count}} bilan(s)",
      kpi_points_total: "Points Agirc-Arrco (total)",
      segment_title: "Participation par segment",
      segment_desc: "Salariés couverts et espaces activés par {{axis}}.",
      geo_title: "Répartition géographique",
      geo_desc: "Salariés couverts par département (effectifs masqués sous le seuil d'anonymat).",
      appetences_title: "Appétences exprimées",
      appetences_desc: "Souhaits des salariés relevés à l'issue de leur bilan.",
      satisfaction_section_title: "Satisfaction des salariés",
      satisfaction_section_desc:
        "Évaluations de la prestation déposées après restitution du bilan (CDC §16).",
      fc_title: "Suivi des formés : connexion & complétude",
      fc_desc:
        "Parmi les salariés formés : qui s'est connecté ? dont le dossier est complet ? (CDC §8b)",
      sessions_title: "Sessions de formation",
      sessions_desc: "Inscriptions et présence par session sur votre périmètre.",
      fc_empty: "Aucun salarié formé sur ce périmètre (ou effectif masqué pour anonymat).",
      fc_formes: "Salariés formés",
      fc_connectes: "… qui se sont connectés",
      fc_bilan: "… dont le dossier a abouti à un bilan",
      fc_non_connectes: "Formés mais jamais connectés",
      fc_non_connectes_desc: "À relancer (mail / téléphone).",
      fc_incomplets: "Connectés, dossier non abouti",
      fc_incomplets_desc: "À accompagner pour finaliser le dossier.",
      sat_masked:
        "Moins de {{k}} évaluations sur ce périmètre : résultats masqués pour préserver l'anonymat.",
      sat_empty: "Aucune évaluation déposée sur ce périmètre pour le moment.",
      sat_avg: "Note moyenne",
      sat_out_of_5: "/ 5",
      sat_avg_hint: "{{count}} évaluation(s)",
      sat_nps: "NPS",
      sat_nps_hint: "sur {{count}} recommandation(s)",
      sat_nps_insufficient: "recommandations insuffisantes (< {{k}})",
      sat_evaluations: "Évaluations",
      sat_evaluations_hint: "avis reçus",
      formations_empty: "Aucune session de formation sur ce périmètre.",
      col_session: "Session",
      col_date: "Date",
      col_channel: "Canal",
      col_registered: "Inscrits",
      col_present: "Présents",
      col_rate: "Taux",
      chart_empty_bilan: "Aucune donnée de bilan disponible.",
      chart_empty_segment: "Aucun segment disponible.",
      masked_note: "Certains effectifs sont masqués (inférieurs au seuil d'anonymat).",
      drill_hint:
        "Cliquez sur une barre pour afficher le détail agrégé de la population correspondante (jamais de liste nominative).",
      drill_desc: "Population du segment ({{axis}}) — effectifs agrégés uniquement",
      drill_salaries: "Salariés couverts",
      drill_actives: "Espaces activés",
      drill_delivered: "Bilans remis",
      drill_funnel: "Répartition des dossiers",
      drill_anonymity_note:
        "Ce panneau ne présente que des effectifs agrégés : les valeurs inférieures au seuil d'anonymat ({{k}}) sont masquées et aucune donnée nominative n'est accessible.",
      status_history_title: "Évolution de la répartition des dossiers",
      status_history_desc:
        "Répartition hebdomadaire des dossiers par état, reconstituée depuis l'historique des changements d'état. Chaque point respecte le seuil d'anonymat.",
      status_history_loading: "Chargement de l’historique…",
      status_history_error:
        "L’historique n’a pas pu être chargé. Réessayez dans quelques instants.",
      status_history_retry: "Réessayer",
      status_history_empty: "Pas encore assez d'historique pour tracer l'évolution.",
      csv_status_history: "Évolution des statuts (semaine)",
      map_loading: "Chargement de la carte…",
      legend_salaries: "Salariés",
      legend_actives: "Espaces activés",
      tt_years: "ans",
      tt_salaries: "salarié(s)",
      tt_actives: "espace(s) activé(s)",
      tt_bilans: "bilan(s) livré(s)",
      tt_no_data: "Aucune donnée",
      app_plus_tot: "Partir au plus tôt",
      app_plus_tard: "Partir au plus tard",
      app_progressive: "Retraite progressive / temps partiel",
      app_rupture: "Rupture conventionnelle",
      app_rachat: "Rachat de trimestres",
      app_cumul: "Cumul emploi-retraite",
      csv_indicator: "Indicateur",
      csv_value: "Valeur",
      csv_covered: "Salariés couverts",
      csv_actives: "Espaces activés",
      csv_consents: "Consentements recueillis",
      csv_formes: "Salariés formés",
      csv_sortants: "Sortants",
      csv_dossiers_total: "Dossiers (total)",
      csv_carriere_longue: "Carrières longues",
      csv_rachats: "Rachats envisagés",
      csv_trim_rachetes: "Trimestres rachetés (volume)",
      csv_cout_rachat: "Coût moyen de rachat (€)",
      csv_points: "Points Agirc-Arrco (moyenne)",
      csv_points_total: "Points Agirc-Arrco (total)",
      csv_trim_manquants: "Trimestres manquants (moyenne)",
      csv_trim_valides: "Trimestres validés (moyenne)",
      csv_trim_valides_total: "Trimestres validés (total)",
      csv_tpn_annee: "Taux plein naturel par année",
      csv_departs_annee: "Premières dates de départ par année",
      csv_sorties_total: "Sorties — comptes clôturés",
      csv_sorties_retraite: "Sorties — départs en retraite",
      csv_refus_contact: "Refus de contact",
      csv_sorties_motif: "Sorties par motif",
      csv_sorties_annee: "Sorties par année",
      csv_formation_inscrits: "Formation — inscrits",
      csv_formation_presents: "Formation — présents",
      csv_sat_evaluations: "Satisfaction — évaluations",
      csv_sat_note: "Satisfaction — note moyenne /5",
      csv_sat_nps: "Satisfaction — NPS",
      csv_funnel_title: "Avancement des dossiers",
      csv_number: "Nombre",
      csv_appetences: "Appétences",
      csv_ventilation: "Ventilation — {{axis}}",
      csv_bilans: "Bilans livrés",
      csv_sessions: "Sessions de formation",
    },
    synthese: {
      kicker: "Espace DRH · Pilotage",
      title: "Synthèse de mission",
      description:
        "Vue consolidée de la mission : effectifs, départs réalisés et envisagés, appétences, droits récupérés et satisfaction.",
      badge: "Effectifs inférieurs à {{k}} masqués",
      export: "Exporter",
      export_title: "Exporter la synthèse",
      export_desc: "Choisissez les vues à inclure dans le fichier.",
      exporting: "Export en cours…",
      all_societes: "Toutes mes sociétés",
      select_societe: "Choisir une société",
      select_societe_title: "Sélectionnez une société",
      select_societe_desc:
        "La synthèse de mission s'affiche pour une société à la fois : choisissez-la dans le sélecteur en haut de page.",
      sec_mission: "Synthèse de mission",
      sec_departs_realises: "Départs réalisés",
      sec_departs_envisages: "Départs envisagés",
      sec_appetences: "Appétences",
      sec_droits: "Droits récupérés",
      sec_satisfaction: "Satisfaction",
      sec_roi: "Retour sur investissement",
      sec_nominatif: "Détail nominatif",
      m_presents: "Salariés présents",
      m_sortis: "Salariés sortis",
      m_en_cours: "Dossiers en cours",
      m_prestations: "Prestations réalisées",
      m_taux: "Taux de réalisation",
      m_anomalies: "Anomalies traitées",
      m_rachats: "Rachats simulés",
      m_refus: "Refus de participation",
      dep_realises_annee: "Départs réalisés par année",
      dep_realises_motif: "Départs réalisés par motif",
      departs_envisages_desc:
        "Dates issues des calculs (estimation de base) : première date possible, taux plein et âge d'annulation de la décote.",
      dep_au_plus_tot: "Au plus tôt",
      dep_taux_plein: "Taux plein",
      dep_annulation: "Annulation de la décote (67 ans)",
      appetences_note: "Souhaits exprimés par les salariés.",
      droits_note:
        "Droits récupérés consignés par les consultants ; le gain est la somme des estimations saisies.",
      roi_note:
        "Même méthode en BRI Flash et Standard : le gain annuel cumule les estimations renseignées pour les droits obtenus. Les autres indicateurs mesurent les accompagnements, les rachats simulés et la satisfaction. Le coût de la prestation et les indemnités de départ n’entrent pas dans ce calcul.",
      nominatif_aide:
        "Seuls les salariés ayant autorisé le partage apparaissent, avec le niveau d'information qu'ils ont choisi.",
      nominatif_date_title: "Accord : date du taux plein",
      nominatif_full_title: "Accord : BRI complet",
      nominatif_voir: "Voir le dossier",
      sat_note: "Note moyenne",
      sat_nps: "NPS",
      sat_evaluations: "Évaluations",
      roi_accompagnes: "Salariés accompagnés",
      roi_taux: "Taux de réalisation",
      roi_droits: "Droits récupérés (trimestres / points)",
      roi_rachats: "Rachats simulés",
      roi_satisfaction: "Satisfaction moyenne",
      roi_gain: "Gain de pension annuel estimé cumulé",
      d_dossiers: "Dossiers concernés",
      d_trim_rachetes: "Trimestres rachetés",
      d_trim_gagnes: "Trimestres gagnés",
      d_points: "Points Agirc-Arrco",
      d_trim_en_cours: "Trimestres en cours",
      d_points_en_cours: "Points en cours",
      d_gain: "Gain annuel estimé (obtenu)",
      d_gain_en_cours: "Gain annuel estimé (en cours)",
      d_par_motif: "Ventilation par motif",
      col_indicateur: "Indicateur",
      col_valeur: "Valeur",
      col_annee: "Année",
      col_departs: "Départs",
      col_motif: "Motif",
      col_souhait: "Souhait",
      col_salaries: "Salariés",
      col_nom: "Nom",
      col_prenom: "Prénom",
      col_matricule: "Matricule",
      col_bu: "Business Unit",
      col_operation: "Opération",
      col_statut: "Statut du dossier",
      col_date_taux_plein: "Départ à taux plein",
      col_age_taux_plein: "Âge au taux plein",
      col_premiere_date: "1re date de départ",
      col_age_premiere_date: "Âge",
      col_pension: "Pension brute mensuelle",
      sheet_perimetre: "Périmètre",
      perimetre_date: "Date",
      perimetre_societe: "Société",
      perimetre_filtres: "Filtres",
      perimetre_filtres_aucun: "Aucun",
      perimetre_seuil: "Effectifs inférieurs à {{k}} masqués",
      pdf_aucune_donnee: "Aucune donnée disponible pour cette vue.",
      pdf_tendance: "{{n}} départs en {{annee}} contre {{nPrec}} en {{anneePrec}}{{delta}}",
      footer_note:
        "Les effectifs inférieurs au seuil d'anonymat ({{k}}) sont masqués. Le détail nominatif ne liste que les salariés ayant autorisé le partage de leurs résultats.",
    },
    formations: {
      kicker: "Espace DRH · Pilotage",
      title: "Formations",
      description: "Suivi des sessions de formation retraite de votre périmètre.",
      no_formations: "Aucune session de formation.",
      search_placeholder: "Rechercher une formation…",
      export: "Exporter",
      channel_presentiel: "Présentiel",
      channel_visio: "Visio",
      channel_mixte: "Mixte",
      stat_sessions: "Sessions",
      stat_registered: "Inscrits",
      stat_present: "Présents",
      stat_absent: "Absents",
      stat_upcoming: "À venir",
      filter_period: "Période",
      filter_channel: "Canal",
      period_all: "Toutes les sessions",
      period_upcoming: "À venir",
      period_past: "Passées",
      page_description:
        "Suivez les sessions de formation retraite de votre périmètre : planning, inscriptions et présence.",
      badge_aggregated: "Effectifs agrégés · aucune donnée nominative",
      all_societes: "Toutes mes sociétés",
      empty_title: "Aucune session de formation",
      empty_desc:
        "Les sessions de formation retraite organisées sur votre périmètre apparaîtront ici.",
      kpi_sessions: "Sessions",
      kpi_upcoming: "À venir",
      kpi_registrations: "Inscriptions",
      kpi_presence_rate: "Taux de présence",
      kpi_presence_hint: "Sessions passées",
      channel_all: "Canal : tous",
      reset: "Réinitialiser",
      filtered_empty_title: "Aucune session pour ces filtres",
      filtered_empty_desc: "Ajustez la période ou le canal pour afficher davantage de sessions.",
      col_session: "Session",
      col_date: "Date",
      col_channel: "Canal",
      col_registered: "Inscrits",
      col_present: "Présents",
      col_rate: "Taux",
      col_eval: "Éval.",
      badge_upcoming: "À venir",
      badge_past: "Passée",
      footer_note:
        "Conformément à la confidentialité, seuls les effectifs agrégés par session sont affichés.",
      csv_session: "Session",
      csv_societe: "Société",
      csv_operation: "Opération",
      csv_date: "Date",
      csv_channel: "Canal",
      csv_lieu: "Lieu",
      csv_capacity: "Capacité",
      csv_registered: "Inscrits",
      csv_present: "Présents",
      csv_absent: "Absents",
      csv_rate: "Taux de présence (%)",
      csv_eval: "Évaluation moyenne",
      csv_status: "Statut",
    },
    library: {
      kicker: "Ressources RH",
      title: "Bibliothèque RH",
      subtitle:
        "Supports de pilotage, fiches pédagogiques et repères pour accompagner vos campagnes retraite.",
    },
    salaries: {
      kicker: "Espace DRH",
      title: "Salariés",
      description: "Consultez les fiches de vos salariés et suivez leur parcours.",
    },
    operations: {
      kicker: "Espace DRH · Pilotage",
      title: "Opérations",
      description: "Suivi des campagnes BRI sur votre périmètre.",
      empty_desc: "Aucune opération n'est rattachée à votre périmètre pour le moment.",
      back_all: "Toutes les opérations",
      dossiers_title: "Dossiers de l'opération",
      dossiers_subtitle: "Suivi en lecture des Bilans Retraite de vos salariés.",
      search_placeholder: "Rechercher par nom, prénom, matricule…",
      all_steps: "Toutes les étapes",
      dossiers_count_one: "{{count}} dossier",
      dossiers_count_many: "{{count}} dossiers",
      no_dossier_title: "Aucun dossier",
      no_dossier_filters: "Aucun résultat pour ces filtres.",
      no_dossier_desc: "Aucun dossier n'est encore visible sur votre périmètre.",
      societe_none: "Société non renseignée",
      with: "avec",
      updated: "Maj {{date}}",
    },
    messages: {
      kicker: "Espace DRH",
      title: "Messages",
      description: "Vos échanges avec les chefs de projet Aon de vos opérations.",
      new_conversation: "Nouvelle conversation",
      search_placeholder: "Rechercher…",
      no_results: "Aucun résultat",
      no_conversations: "Aucune conversation",
      no_conversations_desc:
        "Démarrez un échange avec un chef de projet Aon via « Nouvelle conversation ».",
      back_conversations: "Conversations",
      select_conversation: "Sélectionnez une conversation",
      dialog_title: "Nouvelle conversation",
      dialog_desc: "Sélectionnez un chef de projet Aon pour démarrer (ou rouvrir) un échange.",
      no_contacts_title: "Aucun contact Aon",
      no_contacts_desc: "Aucun chef de projet n'est rattaché à vos opérations pour le moment.",
      no_name: "(sans nom)",
      contact_role: "Chef de projet",
      opening: "Ouverture…",
      unknown_error: "Erreur inconnue",
      no_subject: "(sans sujet)",
      participants_summary: "{{count}} participants · DRH ↔ Chef projet",
      nobody: "(personne)",
      rel_min: "il y a {{count}} min",
      rel_hour: "il y a {{count}} h",
      rel_day: "il y a {{count}} j",
    },
  },
  operations_list: {
    title: "Opérations",
    subtitle: "Pilotage des campagnes BRI client.",
    search_placeholder: "Rechercher une opération, une société…",
    filter_active: "Actives",
    filter_draft: "Brouillons",
    filter_closed: "Clôturées",
    filter_all: "Toutes",
    stat_operations: "Opérations",
    stat_salaries: "Salariés couverts",
    stat_dossiers_active: "Dossiers actifs",
    stat_bri_delivered: "BRI livrés",
    empty_title: "Aucune opération",
    empty_filtered: "Ajustez vos filtres pour voir d'autres opérations.",
    empty_default: "Aucune opération ne vous est rattachée pour le moment.",
    page_of: "Page {{page}} sur {{total}} · {{count}} opérations",
    prev: "Précédent",
    next: "Suivant",
    tile_salaries: "Salariés",
    tile_dossiers: "Dossiers",
    tile_active: "Actifs",
    tile_delivered: "Livrés",
    completion_rate: "Taux de complétion",
    rdv_upcoming: "{{count}} RDV à venir (30j)",
    status_brouillon: "Brouillon",
    status_planifiee: "Planifiée",
    status_en_cours: "En cours",
    status_cloturee: "Clôturée",
    status_archivee: "Archivée",
  },
  formations: {
    title: "Formations",
    add: "Nouvelle session",
    edit: "Modifier la session",
    delete: "Supprimer la session",
    delete_confirm: "Supprimer cette session de formation ?",
    operation: "Opération",
    titre: "Titre",
    description: "Description",
    starts_at: "Date de début",
    ends_at: "Date de fin",
    channel: "Canal",
    lieu: "Lieu",
    capacity: "Capacité max",
    formateur: "Formateur",
    participants: "Participants",
    add_participant: "Ajouter un participant",
    remove_participant: "Retirer",
    presence: "Émargement",
    present: "Présent",
    absent: "Absent",
    not_recorded: "Non renseigné",
    no_participants: "Aucun participant inscrit.",
    search_salarie: "Rechercher un salarié…",
  },
  salaries: {
    form: {
      title_create: "Nouveau salarié",
      title_edit: "Modifier {{prenom}} {{nom}}",
      description_create:
        "Création manuelle d'une fiche. Pour un import en lot, utilisez Importer un fichier.",
      description_edit: "Modification de la fiche salarié.",
      cancel: "Annuler",
      save: "Enregistrer",
      create: "Créer le salarié",
      errors: {
        required: "Champ requis",
        invalidEmail: "Email invalide",
        dateFormat: "Date AAAA-MM-JJ",
      },
      duplicate: {
        title: "Email déjà utilisé",
        description:
          "L'adresse <code>{{email}}</code> est déjà rattachée à <strong>{{prenom}} {{nom}}</strong>.",
        matricule: "matricule {{matricule}}",
        hint: "Rendez-vous sur la fiche de ce salarié pour modifier sa fiche, ou utilisez un email différent.",
        close: "Fermer cet avertissement",
      },
      staff_conflict: {
        title: "Cet email appartient à un compte de l'équipe Aon",
        description_profile:
          "L'adresse <code>{{email}}</code> est celle de <strong>{{name}}</strong> ({{roles}}). Un membre de l'équipe Aon ne peut pas être créé comme salarié. Un DRH, lui, peut avoir sa propre fiche salarié.",
        description_invitation:
          "L'adresse <code>{{email}}</code> fait l'objet d'une invitation en attente pour un compte {{roles}}. Un membre de l'équipe Aon ne peut pas être créé comme salarié.",
        unknown_name: "un utilisateur",
        hint: "Utilisez l'adresse personnelle du salarié, ou révoquez d'abord l'accès Aon de cette personne.",
      },
      sections: {
        company: "Rattachement entreprise",
        identity: "Identité",
        contact: "Contact",
        employment: "Emploi",
        access: "Accès à la plateforme",
      },
      fields: {
        societe: "Société",
        operation: "Opération",
        filiale: "Filiale",
        business_unit: "Business Unit",
        site: "Site / région",
        matricule: "Matricule",
        civilite: "Civilité",
        prenom: "Prénom",
        nom: "Nom",
        nom_naissance: "Nom de naissance",
        date_naissance: "Date de naissance",
        gender: "Genre",
        email_pro: "Email pro",
        email_perso: "Email perso",
        email_correspondance: "Email de correspondance",
        telephone_pro: "Téléphone professionnel",
        telephone_perso: "Téléphone personnel",
        poste: "Poste",
        professional_category: "Catégorie",
        salary_band: "Tranche salariale",
        salaire_annuel_declare: "Salaire annuel (€)",
        date_entree_societe: "Date d'entrée société",
      },
      placeholders: {
        none: "-",
        societe_search: "Rechercher une société…",
        operation_search: "Rechercher une opération…",
        operation_disabled: "Choisissez d'abord une société",
        operation_none: "- Aucune -",
        filiale_search: "Rechercher une filiale…",
        filiale_none: "- Aucune -",
        bu_search: "Rechercher une BU…",
        bu_none: "- Aucune -",
        site_search: "Rechercher un site…",
        site_none: "- Aucun -",
        email_correspondance: "Email utilisé pour les communications (par défaut : pro)",
        matricule: "TE-1001",
      },
      options: {
        civilite_M: "M.",
        civilite_Mme: "Mme",
        civilite_Mx: "Mx",
        gender_m: "Homme",
        gender_f: "Femme",
        gender_x: "Non précisé",
        category_cadre: "Cadre",
        category_oetam: "OETAM (Ouvriers, Employés, Tech., Agents de maîtrise)",
        category_dirigeant: "Dirigeant",
        salary_sub_80k: "< 80 k€",
        salary_80k_120k: "80 - 120 k€",
        salary_above_120k: "> 120 k€",
      },
      flags: {
        is_present: "Présent dans l'entreprise",
        is_vip: "VIP / Dirigeant",
        has_rqth: "RQTH (handicap reconnu)",
      },
      access: {
        description:
          "Cocher cette option crée aussi le compte utilisateur lié dans le backoffice. Le salarié recevra un email d'activation et définira son mot de passe à la première connexion.",
        send_invitation: "Créer le compte lié et envoyer l'invitation",
        email_required:
          "Renseignez au moins un email (correspondance, pro ou perso) pour pouvoir envoyer l'invitation.",
        email_used: "Invitation envoyée à <code>{{email}}</code>.",
      },
    },
    import: {
      title: "Import de salariés",
      upload: "Téléverser le fichier CSV",
      template: "Télécharger le modèle",
      mapping: "Vérification du mapping",
      preview: "Aperçu de l'import",
      confirm: "Lancer l'import",
      success: "{{count}} salarié(s) importé(s) avec succès.",
      errors: "{{count}} erreur(s) détectée(s).",
    },
  },
  messages: {
    title: "Messagerie",
    new_conversation: "Nouvelle conversation",
    search_placeholder: "Rechercher une conversation…",
    no_conversations: "Aucune conversation.",
    no_messages: "Aucun message dans cette conversation.",
    type_message: "Écrire un message…",
    send: "Envoyer",
    attachment: "Joindre un fichier",
    read: "Lu",
    unread: "Non lu",
    tracking: {
      title: "Suivi des messages",
      description: "Vue d'ensemble de tous les échanges de la plateforme.",
    },
  },
  parcours: {
    title: "Mon parcours retraite",
    description: "Complétez les étapes pour produire votre Bilan Retraite Individuel.",
    step_identity: "Identité",
    step_career: "Carrière",
    step_family: "Situation familiale",
    step_documents: "Documents",
    step_scenarios: "Scénarios",
    step_validation: "Validation",
    progress: "Progression",
    complete_step: "Étape complétée",
    next_step: "Étape suivante",
    submit: "Soumettre mon dossier",
    submit_confirm: "Une fois soumis, votre dossier sera transmis à l'équipe Aon pour production.",
    reset: "Recommencer",
    reset_confirm: "Remettre le parcours à zéro ? Vos données saisies seront conservées.",
  },
  bri: {
    title: "Mon Bilan Retraite",
    subtitle: "Consultez et téléchargez votre Bilan Retraite Individuel.",
    download_pdf: "Télécharger le PDF",
    no_bri: "Votre BRI n'est pas encore disponible.",
    generating: "Génération du BRI en cours…",
    generated_at: "Généré le",
    version: "Version",
  },
  salary_band: {
    sub_80k: "Moins de 80 k€ / an",
    "80k_to_120k": "80 à 120 k€ / an",
    above_120k: "Plus de 120 k€ / an",
    mixte: "Mixte (portée par chaque salarié)",
    none: "Non renseigné",
  },
  historique: {
    title: "Historique de mes calculs",
    subtitle: "Retrouvez l'historique complet de vos calculs et simulations.",
    no_history: "Aucun calcul réalisé pour le moment.",
    date: "Date",
    type: "Type",
    result: "Résultat",
    details: "Détails",
  },
} as const;
